(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire41f6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire41f6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bErSZ", function(module, exports) {

$parcel$export(module.exports, "getBerlinClock", function () { return $87b90fb8429ab37c$export$2bc19fa733824c5; });
$parcel$export(module.exports, "parseSpecialAttribute", function () { return $87b90fb8429ab37c$export$71d8523763e1af0f; });
$parcel$export(module.exports, "computeOpeningStatus", function () { return $87b90fb8429ab37c$export$584604daa6c728ce; });
$parcel$export(module.exports, "parsePeriodsAttribute", function () { return $87b90fb8429ab37c$export$ce1c92cfb794fd39; });
$parcel$export(module.exports, "updateOpeningBadge", function () { return $87b90fb8429ab37c$export$9f6405cfeefa8443; });
$parcel$export(module.exports, "refreshAllOpeningStatuses", function () { return $87b90fb8429ab37c$export$68c844e856c22eec; });
$parcel$export(module.exports, "bindOpeningStatusAutoRefresh", function () { return $87b90fb8429ab37c$export$cf37c1b4ebb5aae1; });
/**
 * Cache-safe, timezone-correct open/closed status.
 *
 * Opening hours for Weißenstadt venues are Europe/Berlin wall times. Page cache
 * freezes server-rendered labels, so every live pill recomputes from
 * data-periods in the browser using Berlin time — never the visitor's local TZ.
 */ const $87b90fb8429ab37c$var$BERLIN_TZ = "Europe/Berlin";
const $87b90fb8429ab37c$var$WEEKDAY_MAP = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6
};
const $87b90fb8429ab37c$var$berlinPartsFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: $87b90fb8429ab37c$var$BERLIN_TZ,
    weekday: "short",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
});
function $87b90fb8429ab37c$export$d7e46c5bb54ebe69(isoDate, offset) {
    const [year, month, day] = String(isoDate || "").split("-").map((part)=>Number(part));
    if (!year || !month || !day) return "";
    return new Date(Date.UTC(year, month - 1, day + offset)).toISOString().slice(0, 10);
}
function $87b90fb8429ab37c$export$2bc19fa733824c5(date = new Date()) {
    const parts = $87b90fb8429ab37c$var$berlinPartsFormatter.formatToParts(date);
    const map = {};
    for (const part of parts)if (part.type !== "literal") map[part.type] = part.value;
    const day = $87b90fb8429ab37c$var$WEEKDAY_MAP[map.weekday];
    const hour = Number(map.hour);
    const minute = Number(map.minute);
    const isoDate = map.year && map.month && map.day ? `${map.year}-${map.month}-${map.day}` : "";
    if (day === undefined || Number.isNaN(hour) || Number.isNaN(minute) || hour < 0 || hour > 23 || minute < 0 || minute > 59) {
        // Extremely defensive fallback — still better than visitor local time for
        // this product, but only used if Intl is broken.
        const fallback = new Date(date.toLocaleString("en-US", {
            timeZone: $87b90fb8429ab37c$var$BERLIN_TZ
        }));
        return {
            day: fallback.getDay(),
            hour: fallback.getHours(),
            minute: fallback.getMinutes(),
            minutes: fallback.getHours() * 60 + fallback.getMinutes(),
            date: `${fallback.getFullYear()}-${String(fallback.getMonth() + 1).padStart(2, "0")}-${String(fallback.getDate()).padStart(2, "0")}`
        };
    }
    return {
        day: day,
        hour: hour,
        minute: minute,
        minutes: hour * 60 + minute,
        date: isoDate
    };
}
function $87b90fb8429ab37c$export$6cd6be75c9d108e9(time) {
    const parts = String(time || "").split(":");
    const hour = Number(parts[0]);
    const minute = Number(parts[1] || 0);
    if (Number.isNaN(hour) || Number.isNaN(minute)) return 0;
    return hour * 60 + minute;
}
function $87b90fb8429ab37c$export$3ea53827ed349b2e(lang) {
    const value = String(lang || (typeof document !== "undefined" ? document.documentElement.lang : "") || "").toLowerCase();
    return value.startsWith("en");
}
function $87b90fb8429ab37c$export$9b8f02bdfc79caa1(lang) {
    const value = String(lang || (typeof document !== "undefined" ? document.documentElement.lang : "") || "").toLowerCase();
    return value.startsWith("cs");
}
// `english` wins; otherwise Czech on Czech pages, German everywhere else.
// Mirrors weissenstadt_opening_hours_text() in PHP.
function $87b90fb8429ab37c$var$getCopy(english, compact, czech = false) {
    if (english) return {
        open: "Open",
        closed: "Closed",
        unknown: "Check opening hours",
        today: "today",
        tomorrow: "tomorrow",
        days: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        daysFull: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        byAppointment: "By appointment",
        closesAt: (time)=>`closes at ${time}`,
        opensAt: (day, time)=>`opens ${day} at ${time}`,
        onDay: (day)=>compact ? [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ][day] : [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ][day],
        nextDay (day) {
            return `next ${this.onDay(day)}`;
        },
        reopens: (day, time)=>`Reopens ${day} at ${time}`,
        nextUnknown: "Next opening time unknown",
        formatTime: $87b90fb8429ab37c$var$formatEnglishTime,
        formatDate: (isoDate)=>{
            const [year, month, day] = isoDate.split("-").map(Number);
            const date = new Date(Date.UTC(year, month - 1, day));
            const weekday = [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ][date.getUTCDay()];
            const monthName = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ][month - 1];
            return `${weekday}, ${day} ${monthName} ${year}`;
        },
        specialUntil: (label, date)=>label ? `${label} until incl. ${date}` : `until incl. ${date}`,
        specialToday: (label)=>label ? `${label} today` : "today",
        specialAhead: (label, from, until)=>`${label || "closed"} from ${from} until incl. ${until}`
    };
    if (czech) // Tschechisch: Wochentag als Zeitangabe im Akkusativ („ve středu“,
    // „příští středu“), Uhrzeit 24 h ohne „Uhr“, Datum „st 9. 9. 2026“.
    return {
        open: "Otev\u0159eno",
        closed: "Zav\u0159eno",
        unknown: "Ov\u011B\u0159te otev\xedrac\xed dobu",
        today: "dnes",
        tomorrow: "z\xedtra",
        days: [
            "Ne",
            "Po",
            "\xdat",
            "St",
            "\u010Ct",
            "P\xe1",
            "So"
        ],
        daysFull: [
            "ned\u011Ble",
            "pond\u011Bl\xed",
            "\xfater\xfd",
            "st\u0159eda",
            "\u010Dtvrtek",
            "p\xe1tek",
            "sobota"
        ],
        byAppointment: "Po domluv\u011B",
        closesAt: (time)=>compact ? `Zav\xedr\xe1 v ${time}` : `zav\xedr\xe1 v ${time}`,
        opensAt: (day, time)=>compact ? `Otev\xedr\xe1 ${day} v ${time}` : `otev\xedr\xe1 ${day} v ${time}`,
        onDay: (day)=>[
                "v ned\u011Bli",
                "v pond\u011Bl\xed",
                "v \xfater\xfd",
                "ve st\u0159edu",
                "ve \u010Dtvrtek",
                "v p\xe1tek",
                "v sobotu"
            ][day],
        nextDay: (day)=>[
                "p\u0159\xed\u0161t\xed ned\u011Bli",
                "p\u0159\xed\u0161t\xed pond\u011Bl\xed",
                "p\u0159\xed\u0161t\xed \xfater\xfd",
                "p\u0159\xed\u0161t\xed st\u0159edu",
                "p\u0159\xed\u0161t\xed \u010Dtvrtek",
                "p\u0159\xed\u0161t\xed p\xe1tek",
                "p\u0159\xed\u0161t\xed sobotu"
            ][day],
        reopens: (day, time)=>`Znovu otev\xedr\xe1 ${day} v ${time}`,
        nextUnknown: "Dal\u0161\xed otev\xedrac\xed doba zat\xedm nen\xed zn\xe1ma",
        formatDate: (isoDate)=>{
            const [year, month, day] = isoDate.split("-").map(Number);
            const weekday = [
                "ne",
                "po",
                "\xfat",
                "st",
                "\u010Dt",
                "p\xe1",
                "so"
            ][new Date(Date.UTC(year, month - 1, day)).getUTCDay()];
            return `${weekday} ${day}. ${month}. ${year}`;
        },
        specialUntil: (label, date)=>label ? `${label} do ${date} v\u{10D}etn\u{11B}` : `do ${date} v\u{10D}etn\u{11B}`,
        specialToday: (label)=>label ? `${label} dnes` : "dnes",
        specialAhead: (label, from, until)=>`${label || "zav\u0159eno"} od ${from} do ${until} v\u{10D}etn\u{11B}`,
        formatTime: (time)=>{
            const minutes = $87b90fb8429ab37c$export$6cd6be75c9d108e9(time);
            return `${Math.floor(minutes / 60) % 24}:${String(minutes % 60).padStart(2, "0")}`;
        }
    };
    return {
        open: "Ge\xf6ffnet",
        closed: "Geschlossen",
        unknown: "\xd6ffnungszeiten pr\xfcfen",
        today: "heute",
        tomorrow: "morgen",
        days: [
            "So",
            "Mo",
            "Di",
            "Mi",
            "Do",
            "Fr",
            "Sa"
        ],
        daysFull: [
            "Sonntag",
            "Montag",
            "Dienstag",
            "Mittwoch",
            "Donnerstag",
            "Freitag",
            "Samstag"
        ],
        byAppointment: "Nach Vereinbarung",
        closesAt: (time)=>compact ? `Schlie\xdft um ${time}` : `schlie\xdft um ${time} Uhr`,
        opensAt: (day, time)=>compact ? `\xd6ffnet ${day} um ${time}` : `\xf6ffnet ${day} um ${time} Uhr`,
        onDay: (day)=>compact ? [
                "So",
                "Mo",
                "Di",
                "Mi",
                "Do",
                "Fr",
                "Sa"
            ][day] : [
                "Sonntag",
                "Montag",
                "Dienstag",
                "Mittwoch",
                "Donnerstag",
                "Freitag",
                "Samstag"
            ][day],
        nextDay (day) {
            return `n\xe4chsten ${this.onDay(day)}`;
        },
        reopens: (day, time)=>`\xd6ffnet wieder ${day} um ${time} Uhr`,
        nextUnknown: "N\xe4chster \xd6ffnungstermin noch nicht bekannt",
        formatDate: (isoDate)=>{
            const [year, month, day] = isoDate.split("-");
            const weekday = [
                "So",
                "Mo",
                "Di",
                "Mi",
                "Do",
                "Fr",
                "Sa"
            ][new Date(Date.UTC(Number(year), Number(month) - 1, Number(day))).getUTCDay()];
            return `${weekday}, ${day}.${month}.${year}`;
        },
        specialUntil: (label, date)=>label ? `${label} bis inkl. ${date}` : `bis inkl. ${date}`,
        specialToday: (label)=>label ? `${label} heute` : "heute",
        specialAhead: (label, from, until)=>`${label || "geschlossen"} ab ${from} bis inkl. ${until}`,
        formatTime: (time)=>{
            const minutes = $87b90fb8429ab37c$export$6cd6be75c9d108e9(time);
            const hour = Math.floor(minutes / 60) % 24;
            const minute = minutes % 60;
            return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
        }
    };
}
function $87b90fb8429ab37c$var$formatEnglishTime(time) {
    const minutes = $87b90fb8429ab37c$export$6cd6be75c9d108e9(time);
    let hour = Math.floor(minutes / 60) % 24;
    const minute = minutes % 60;
    const suffix = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    if (hour === 0) hour = 12;
    return minute === 0 ? `${hour}:00 ${suffix}` : `${hour}:${String(minute).padStart(2, "0")} ${suffix}`;
}
function $87b90fb8429ab37c$export$c4fd4720e8bd999d(periods) {
    if (!Array.isArray(periods)) return [];
    const normalized = [];
    for (const period of periods){
        if (!period) continue;
        let day;
        let open;
        let close;
        if (Array.isArray(period)) {
            day = Number(period[0]);
            open = String(period[1] || "");
            close = String(period[2] || "");
        } else {
            day = Number(period.day);
            open = String(period.open || "");
            close = String(period.close || "");
        }
        if (!Number.isInteger(day) || day < 0 || day > 6 || !open || !close) continue;
        normalized.push([
            day,
            open,
            close
        ]);
    }
    return normalized;
}
const $87b90fb8429ab37c$var$SPECIAL_STATUSES = [
    "open",
    "closed",
    "exceptional_unknown",
    "by_appointment"
];
function $87b90fb8429ab37c$export$b8272c8a63d13d35(rows) {
    if (!Array.isArray(rows)) return [];
    const normalized = [];
    for (const row of rows){
        if (!row || typeof row !== "object") continue;
        // Compact array row from data-special, or an already-normalized object
        // (idempotent, so callers may pass either).
        const isArray = Array.isArray(row);
        const from = String((isArray ? row[0] : row.from) || "");
        let to = String((isArray ? row[1] : row.to) || "");
        let status = String((isArray ? row[2] : row.status) || "");
        const label = String((isArray ? row[3] : row.label) || "").trim();
        const rawSlots = isArray ? row[4] : row.slots;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(from)) continue;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(to) || to < from) to = from;
        if (!$87b90fb8429ab37c$var$SPECIAL_STATUSES.includes(status)) status = "closed";
        const slots = [];
        if (status === "open" && Array.isArray(rawSlots)) for (const slot of rawSlots){
            if (!Array.isArray(slot) || !slot[0] || !slot[1]) continue;
            slots.push([
                String(slot[0]).slice(0, 5),
                String(slot[1]).slice(0, 5)
            ]);
        }
        normalized.push({
            from: from,
            to: to,
            status: status,
            label: label,
            slots: slots
        });
    }
    return normalized;
}
function $87b90fb8429ab37c$export$558700ef9419bfe9(rows, isoDate) {
    for (const row of rows){
        if (row.from <= isoDate && isoDate <= row.to) return row;
    }
    return null;
}
function $87b90fb8429ab37c$export$765e86de58a38dfa(value) {
    if (!value) return [];
    try {
        const rows = JSON.parse(value);
        return Array.isArray(rows) ? rows.filter(Array.isArray).map((row)=>{
            const from = Number(row[1]) || 0;
            const to = Number(row[2]) || 0;
            const seasonal = from >= 1 && from <= 12 && to >= 1 && to <= 12;
            return {
                validFrom: /^\d{4}-\d{2}-\d{2}$/.test(String(row[0])) ? String(row[0]) : "",
                seasonFrom: seasonal ? from : 0,
                seasonTo: seasonal ? to : 0,
                periods: $87b90fb8429ab37c$export$c4fd4720e8bd999d(row[3])
            };
        }) : [];
    } catch (error) {
        return [];
    }
}
function $87b90fb8429ab37c$var$seasonCovers(plan, month) {
    if (!plan.seasonFrom) return true;
    return plan.seasonFrom <= plan.seasonTo ? month >= plan.seasonFrom && month <= plan.seasonTo : month >= plan.seasonFrom || month <= plan.seasonTo;
}
function $87b90fb8429ab37c$export$32d5bf99e80cbaa9(plans, isoDate) {
    const month = Number(String(isoDate).slice(5, 7));
    let best = null;
    for (const plan of plans){
        if (plan.validFrom && plan.validFrom > isoDate || !$87b90fb8429ab37c$var$seasonCovers(plan, month)) continue;
        if (!best || plan.validFrom > best.validFrom || plan.validFrom === best.validFrom && !best.seasonFrom && plan.seasonFrom) best = plan;
    }
    return best;
}
function $87b90fb8429ab37c$export$71d8523763e1af0f(value) {
    if (!value) return [];
    try {
        return $87b90fb8429ab37c$export$b8272c8a63d13d35(JSON.parse(value));
    } catch (error) {
        return [];
    }
}
function $87b90fb8429ab37c$var$specialNotice(row, today, copy) {
    if (row.status === "open") return null;
    let state = "closed";
    let word = copy.closed;
    if (row.status === "exceptional_unknown") {
        state = "unknown";
        word = copy.unknown;
    } else if (row.status === "by_appointment") word = copy.byAppointment;
    const detail = row.to > today ? copy.specialUntil(row.label, copy.formatDate(row.to)) : copy.specialToday(row.label);
    return {
        open: false,
        state: state,
        label: word,
        detail: detail,
        summary: `${word} \xb7 ${detail}`
    };
}
// Match the server's dated reopening search, even across long holidays.
function $87b90fb8429ab37c$var$reopeningDetail(periods, special, today, copy) {
    const last = special.reduce((date, row)=>row.to > date ? row.to : date, today);
    const end = $87b90fb8429ab37c$export$d7e46c5bb54ebe69(last, 7);
    for(let date = $87b90fb8429ab37c$export$d7e46c5bb54ebe69(today, 1); date && date <= end; date = $87b90fb8429ab37c$export$d7e46c5bb54ebe69(date, 1)){
        const row = $87b90fb8429ab37c$export$558700ef9419bfe9(special, date);
        if (row && row.status !== "open") continue;
        const day = new Date(`${date}T00:00:00Z`).getUTCDay();
        const slots = (row ? row.slots : periods.filter(([weekday])=>weekday === day).map(([, open, close])=>[
                open,
                close
            ])).filter(([open, close])=>open !== close).sort((a, b)=>a[0].localeCompare(b[0]));
        if (!slots.length) continue;
        let label = copy.formatDate(date);
        if (date === $87b90fb8429ab37c$export$d7e46c5bb54ebe69(today, 1)) label = `${copy.tomorrow} (${label})`;
        return copy.reopens(label, copy.formatTime(slots[0][0]));
    }
    return copy.nextUnknown;
}
function $87b90fb8429ab37c$export$584604daa6c728ce(periods, options = {}) {
    let list = $87b90fb8429ab37c$export$c4fd4720e8bd999d(periods);
    const special = $87b90fb8429ab37c$export$b8272c8a63d13d35(options.special);
    const english = options.english ?? $87b90fb8429ab37c$export$3ea53827ed349b2e(options.lang);
    const czech = !english && (options.czech ?? $87b90fb8429ab37c$export$9b8f02bdfc79caa1(options.lang));
    const compact = Boolean(options.compact);
    const copy = $87b90fb8429ab37c$var$getCopy(english, compact, czech);
    const clock = options.clock || $87b90fb8429ab37c$export$2bc19fa733824c5(options.now || new Date());
    const today = clock.date || "";
    // A special row for today outranks the weekly schedule (Betriebsurlaub,
    // Feiertag). An "open" row swaps in its own slots for today.
    const todayRow = today ? $87b90fb8429ab37c$export$558700ef9419bfe9(special, today) : null;
    if (todayRow) {
        const notice = $87b90fb8429ab37c$var$specialNotice(todayRow, today, copy);
        if (notice) {
            notice.detail += ` \xb7 ${$87b90fb8429ab37c$var$reopeningDetail(list, special, today, copy)}`;
            notice.summary = `${notice.label} \xb7 ${notice.detail}`;
            return notice;
        }
        if (todayRow.slots.length) {
            list = list.filter(([periodDay])=>periodDay !== clock.day);
            for (const [open, close] of todayRow.slots)list.push([
                clock.day,
                open,
                close
            ]);
        }
    }
    if (!list.length) return {
        open: false,
        state: "unknown",
        label: copy.unknown,
        detail: "",
        summary: copy.unknown
    };
    const { day: day, minutes: minutes } = clock;
    const previousDay = (day + 6) % 7;
    for (const [periodDay, open, close] of list){
        const openMinutes = $87b90fb8429ab37c$export$6cd6be75c9d108e9(open);
        const closeMinutes = $87b90fb8429ab37c$export$6cd6be75c9d108e9(close);
        const isOvernight = closeMinutes < openMinutes;
        const displayClose = copy.formatTime(close);
        if (periodDay === day) {
            if (!isOvernight && minutes >= openMinutes && minutes < closeMinutes || isOvernight && minutes >= openMinutes) {
                const detail = copy.closesAt(displayClose);
                return {
                    open: true,
                    state: "open",
                    label: copy.open,
                    detail: detail,
                    summary: `${copy.open} \xb7 ${detail}`
                };
            }
        }
        if (isOvernight && periodDay === previousDay && minutes < closeMinutes) {
            const detail = copy.closesAt(displayClose);
            return {
                open: true,
                state: "open",
                label: copy.open,
                detail: detail,
                summary: `${copy.open} \xb7 ${detail}`
            };
        }
    }
    let blockingRow = null;
    for(let offset = 0; offset <= 7; offset += 1){
        const targetDay = (day + offset) % 7;
        const targetRow = offset > 0 && today ? $87b90fb8429ab37c$export$558700ef9419bfe9(special, $87b90fb8429ab37c$export$d7e46c5bb54ebe69(today, offset)) : null;
        // "Öffnet morgen um 16:30" must not point into a Betriebsurlaub.
        if (targetRow && targetRow.status !== "open") {
            blockingRow = blockingRow || targetRow;
            continue;
        }
        const candidates = (targetRow && targetRow.slots.length ? targetRow.slots.map(([open, close])=>[
                targetDay,
                open,
                close
            ]) : list.filter(([periodDay])=>periodDay === targetDay)).sort((a, b)=>$87b90fb8429ab37c$export$6cd6be75c9d108e9(a[1]) - $87b90fb8429ab37c$export$6cd6be75c9d108e9(b[1]));
        for (const [, open] of candidates){
            if (offset === 0 && $87b90fb8429ab37c$export$6cd6be75c9d108e9(open) <= minutes) continue;
            let dayLabel;
            if (offset === 0) dayLabel = copy.today;
            else if (offset === 1) dayLabel = copy.tomorrow;
            else if (targetDay === day) // Full week wrap (e.g. only open Thursdays, checked Thursday evening).
            dayLabel = copy.nextDay(targetDay);
            else dayLabel = copy.onDay(targetDay);
            const detail = copy.opensAt(dayLabel, copy.formatTime(open));
            return {
                open: false,
                state: "closed",
                label: copy.closed,
                detail: detail,
                summary: `${copy.closed} \xb7 ${detail}`
            };
        }
    }
    if (blockingRow) {
        const detail = copy.specialAhead(blockingRow.label, copy.formatDate(blockingRow.from), copy.formatDate(blockingRow.to));
        return {
            open: false,
            state: "closed",
            label: copy.closed,
            detail: detail,
            summary: `${copy.closed} \xb7 ${detail}`
        };
    }
    return {
        open: false,
        state: "closed",
        label: copy.closed,
        detail: "",
        summary: copy.closed
    };
}
function $87b90fb8429ab37c$export$ce1c92cfb794fd39(value) {
    if (!value) return [];
    try {
        return $87b90fb8429ab37c$export$c4fd4720e8bd999d(JSON.parse(value));
    } catch (error) {
        return [];
    }
}
function $87b90fb8429ab37c$export$9f6405cfeefa8443(badge, status) {
    if (!badge || !status || status.state === "unknown") return;
    badge.hidden = false;
    badge.classList.toggle("restaurants-card__opening--open", status.open);
    badge.classList.toggle("restaurants-card__opening--closed", !status.open);
    badge.classList.remove("restaurants-card__opening--unknown");
    const label = badge.querySelector("strong");
    if (label) label.textContent = status.label;
    let detail = badge.querySelector(".restaurants-card__opening-detail");
    if (status.detail) {
        if (!detail) {
            detail = document.createElement("span");
            detail.className = "restaurants-card__opening-detail";
            badge.append(detail);
        }
        detail.textContent = status.detail;
    } else if (detail) detail.remove();
}
function $87b90fb8429ab37c$export$7d3d5bf555430e84(target, status) {
    if (!target || !status) return;
    // Prefer a nested status span for styling the open/closed word.
    let statusWord = target.querySelector(".footer-status-pill__status");
    const detailText = status.detail ? ` \xb7 ${status.detail}` : "";
    if (!statusWord) {
        target.textContent = "";
        statusWord = document.createElement("span");
        statusWord.className = "footer-status-pill__status";
        target.append(statusWord);
        target.append(document.createTextNode(detailText));
    } else {
        // Replace everything after the status word.
        while(statusWord.nextSibling)statusWord.nextSibling.remove();
        target.append(document.createTextNode(detailText));
    }
    statusWord.textContent = status.label;
    const pill = target.closest(".footer-status-pill");
    if (pill) {
        pill.classList.toggle("is-currently-open", status.open);
        pill.classList.toggle("is-currently-closed", !status.open && status.state !== "unknown");
        pill.dataset.open = status.open ? "1" : "0";
    }
}
function $87b90fb8429ab37c$export$68c844e856c22eec(options = {}) {
    const roots = options.root ? options.root.querySelectorAll("[data-opening-status]") : document.querySelectorAll("[data-opening-status]");
    const english = options.english ?? $87b90fb8429ab37c$export$3ea53827ed349b2e();
    const czech = options.czech ?? $87b90fb8429ab37c$export$9b8f02bdfc79caa1();
    const clock = options.clock || $87b90fb8429ab37c$export$2bc19fa733824c5(options.now || new Date());
    let changed = false;
    roots.forEach((node)=>{
        const plans = $87b90fb8429ab37c$export$765e86de58a38dfa(node.getAttribute("data-plans"));
        const special = $87b90fb8429ab37c$export$71d8523763e1af0f(node.getAttribute("data-special"));
        // Dated plans (Einrichtungen) let a cached page switch to new hours or
        // the next season on its own; data-periods is only the render-day plan.
        const periods = plans.length ? $87b90fb8429ab37c$export$32d5bf99e80cbaa9(plans, clock.date)?.periods || [] : $87b90fb8429ab37c$export$ce1c92cfb794fd39(node.getAttribute("data-periods"));
        if (!periods.length && !special.length && !plans.length) return;
        const compact = node.getAttribute("data-opening-compact") === "1";
        const status = $87b90fb8429ab37c$export$584604daa6c728ce(periods, {
            english: english,
            czech: czech,
            compact: compact,
            clock: clock,
            special: special
        });
        const openValue = status.open ? "1" : "0";
        const prevOpen = node.getAttribute("data-open");
        if (prevOpen !== openValue) changed = true;
        node.setAttribute("data-open", openValue);
        node.setAttribute("data-opening-state", status.state);
        const badge = node.matches(".restaurants-card__opening, .gastgeber-single__opening") ? node : node.querySelector(".restaurants-card__opening, .gastgeber-single__opening");
        if (badge) $87b90fb8429ab37c$export$9f6405cfeefa8443(badge, status);
        const footerLabel = node.querySelector("[data-opening-label]");
        if (footerLabel) $87b90fb8429ab37c$export$7d3d5bf555430e84(footerLabel, status);
        else if (node.hasAttribute("data-opening-label")) $87b90fb8429ab37c$export$7d3d5bf555430e84(node, status);
    });
    return changed;
}
function $87b90fb8429ab37c$export$cf37c1b4ebb5aae1(options = {}) {
    if (typeof document === "undefined" || typeof window === "undefined") return;
    const intervalMs = options.intervalMs || 60000;
    const run = ()=>$87b90fb8429ab37c$export$68c844e856c22eec(options);
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run, {
        once: true
    });
    else run();
    window.setInterval(run, intervalMs);
    window.addEventListener("pageshow", (event)=>{
        if (event.persisted) run();
    });
    // Visibility change: correct immediately after a long background tab.
    document.addEventListener("visibilitychange", ()=>{
        if (document.visibilityState === "visible") run();
    });
} // Kein Seiteneffekt hier: bundle.js ruft bindOpeningStatusAutoRefresh() auf.
 // So kann die Merkliste (merkliste-bundle.js) die reinen Funktionen nutzen,
 // ohne einen zweiten Minutentakt zu starten.

});

parcelRegister("6K3oU", function(module, exports) {

$parcel$export(module.exports, "normalizeItems", function () { return $f0f28bb2d74f783a$export$928021b00bb0ffd6; });
$parcel$export(module.exports, "getFavoritesStore", function () { return $f0f28bb2d74f783a$export$82f1cfb4996cab94; });

var $cYEst = parcelRequire("cYEst");
const $f0f28bb2d74f783a$export$86880b4b2e1a2384 = "weissenstadt-favorites";
function $f0f28bb2d74f783a$export$294e12032e0d0a3b(value, origin) {
    try {
        if (typeof value !== "string" || !value.trim()) return "";
        const url = new URL(value, origin);
        return /^https?:$/.test(url.protocol) && url.origin === origin && !url.username && !url.password ? url.href : "";
    } catch  {
        return "";
    }
}
/** Opening hours as sent by the REST route; never stored, only displayed. */ function $f0f28bb2d74f783a$var$cleanOpening(opening) {
    if (!opening || typeof opening !== "object") return null;
    const periods = Array.isArray(opening.periods) ? opening.periods.filter((period)=>Array.isArray(period) && Number.isInteger(period[0]) && period[0] >= 0 && period[0] <= 6 && typeof period[1] === "string" && typeof period[2] === "string").slice(0, 50).map(([day, open, close])=>[
            day,
            open.slice(0, 5),
            close.slice(0, 5)
        ]) : [];
    const special = Array.isArray(opening.special) ? opening.special.filter((row)=>row && typeof row === "object").slice(0, 50) : [];
    return periods.length || special.length ? {
        periods: periods,
        special: special
    } : null;
}
function $f0f28bb2d74f783a$export$928021b00bb0ffd6(items, origin, withDetails = false) {
    if (!Array.isArray(items)) throw new Error("corrupt");
    const seen = new Set();
    return items.flatMap((item)=>{
        const id = Number(item?.id);
        const url = typeof item?.url === "string" ? $f0f28bb2d74f783a$export$294e12032e0d0a3b(item.url, origin) : "";
        if (!Number.isSafeInteger(id) || id < 1 || seen.has(id) || !url || typeof item?.title !== "string") return [];
        seen.add(id);
        const clean = {
            id: id,
            title: item.title.slice(0, 500),
            url: url
        };
        if ((0, $cYEst.FAVORITE_CATEGORIES).includes(item.category)) clean.category = item.category;
        for (const field of withDetails ? [
            "type",
            "meta",
            "credit"
        ] : [
            "credit"
        ])if (typeof item[field] === "string") clean[field] = item[field].slice(0, 500);
        if (typeof item.image === "string") clean.image = $f0f28bb2d74f783a$export$294e12032e0d0a3b(item.image, origin);
        if (withDetails) {
            const opening = $f0f28bb2d74f783a$var$cleanOpening(item.opening);
            if (opening) clean.opening = opening;
        }
        return [
            clean
        ];
    });
}
function $f0f28bb2d74f783a$export$f44997672ac7151c(getStorage, origin) {
    let state = {
        items: [],
        error: null
    };
    const listeners = new Set();
    function read() {
        try {
            const raw = getStorage().getItem($f0f28bb2d74f783a$export$86880b4b2e1a2384);
            if (raw === null) return {
                items: [],
                error: null
            };
            let data;
            try {
                data = JSON.parse(raw);
            } catch  {
                return {
                    items: [],
                    error: "corrupt"
                };
            }
            if (data?.version !== 2) return {
                items: [],
                error: "corrupt"
            };
            try {
                const items = $f0f28bb2d74f783a$export$928021b00bb0ffd6(data.items, origin);
                return {
                    items: items,
                    error: items.length < data.items.length ? "repaired" : null
                };
            } catch  {
                return {
                    items: [],
                    error: "corrupt"
                };
            }
        } catch  {
            return {
                items: state.items,
                error: "unavailable"
            };
        }
    }
    function publish(next) {
        if (next.error === state.error && JSON.stringify(next.items) === JSON.stringify(state.items)) return state;
        state = next;
        for (const listener of listeners)listener(state);
        return state;
    }
    function refresh() {
        return publish(read());
    }
    function mutate(change) {
        const current = read();
        if (current.error === "corrupt" || current.error === "unavailable") {
            publish(current);
            return {
                ok: false,
                error: current.error
            };
        }
        const result = change(current.items);
        const items = $f0f28bb2d74f783a$export$928021b00bb0ffd6(result.items, origin);
        try {
            getStorage().setItem($f0f28bb2d74f783a$export$86880b4b2e1a2384, JSON.stringify({
                version: 2,
                items: items
            }));
            publish({
                items: items,
                error: null
            });
            return {
                ...result,
                ok: true,
                items: items
            };
        } catch  {
            publish({
                items: current.items,
                error: "write"
            });
            return {
                ok: false,
                error: "write"
            };
        }
    }
    function removeFrom(items, id) {
        const index = items.findIndex((item)=>item.id === Number(id));
        const removed = items[index];
        const before = items[index + 1]?.id;
        return {
            items: items.filter((item)=>item.id !== Number(id)),
            removed: removed,
            before: before
        };
    }
    const store = {
        refresh: refresh,
        getState: ()=>state,
        subscribe (listener) {
            listeners.add(listener);
            listener(state);
            return ()=>listeners.delete(listener);
        },
        toggle (item) {
            const clean = $f0f28bb2d74f783a$export$928021b00bb0ffd6([
                item
            ], origin)[0];
            if (!clean) return {
                ok: false,
                error: "invalid"
            };
            return mutate((items)=>items.some((existing)=>existing.id === clean.id) ? {
                    ...removeFrom(items, clean.id),
                    added: false
                } : {
                    items: [
                        ...items,
                        clean
                    ],
                    added: true
                });
        },
        remove: (id)=>mutate((items)=>removeFrom(items, id)),
        clear: ()=>mutate((items)=>({
                    items: [],
                    removedItems: items
                })),
        restoreMany (incoming) {
            const saved = $f0f28bb2d74f783a$export$928021b00bb0ffd6(incoming, origin);
            return mutate((items)=>{
                const current = new Map(items.map((item)=>[
                        item.id,
                        item
                    ]));
                const restored = saved.map((item)=>{
                    const latest = current.get(item.id) || item;
                    current.delete(item.id);
                    return latest;
                });
                return {
                    items: [
                        ...restored,
                        ...current.values()
                    ]
                };
            });
        },
        restore (item, before) {
            return mutate((items)=>{
                if (items.some((existing)=>existing.id === item.id)) return {
                    items: items
                };
                const index = items.findIndex((existing)=>existing.id === before);
                const next = [
                    ...items
                ];
                next.splice(index < 0 ? next.length : index, 0, item);
                return {
                    items: next
                };
            });
        },
        move (id, direction) {
            return mutate((items)=>{
                const next = [
                    ...items
                ];
                const index = next.findIndex((item)=>item.id === Number(id));
                const target = index + direction;
                if (index >= 0 && target >= 0 && target < next.length) [next[index], next[target]] = [
                    next[target],
                    next[index]
                ];
                return {
                    items: next
                };
            });
        },
        moveBefore (id, before) {
            return mutate((items)=>{
                const item = items.find((entry)=>entry.id === Number(id));
                if (!item || Number(id) === Number(before)) return {
                    items: items
                };
                const next = items.filter((entry)=>entry.id !== item.id);
                const index = next.findIndex((entry)=>entry.id === Number(before));
                next.splice(index < 0 ? next.length : index, 0, item);
                return {
                    items: next
                };
            });
        },
        merge (incoming) {
            const clean = $f0f28bb2d74f783a$export$928021b00bb0ffd6(incoming, origin);
            return mutate((items)=>{
                const ids = new Set(items.map((item)=>item.id));
                const added = clean.filter((item)=>!ids.has(item.id));
                return {
                    items: [
                        ...items,
                        ...added
                    ],
                    addedCount: added.length
                };
            });
        },
        updateDetails (incoming) {
            const current = read();
            const details = new Map($f0f28bb2d74f783a$export$928021b00bb0ffd6(incoming, origin).map((item)=>[
                    item.id,
                    item
                ]));
            if (!current.items.some((item)=>details.has(item.id) && JSON.stringify({
                    ...item,
                    ...details.get(item.id)
                }) !== JSON.stringify(item))) return {
                ok: true
            };
            return mutate((items)=>({
                    items: items.map((item)=>({
                            ...item,
                            ...details.get(item.id)
                        }))
                }));
        },
        reset () {
            try {
                getStorage().setItem($f0f28bb2d74f783a$export$86880b4b2e1a2384, JSON.stringify({
                    version: 2,
                    items: []
                }));
                publish({
                    items: [],
                    error: null
                });
                return {
                    ok: true
                };
            } catch  {
                publish({
                    ...state,
                    error: "unavailable"
                });
                return {
                    ok: false,
                    error: "unavailable"
                };
            }
        }
    };
    refresh();
    return store;
}
function $f0f28bb2d74f783a$export$82f1cfb4996cab94() {
    if (!window.weissenstadtFavoritesStore) {
        const store = $f0f28bb2d74f783a$export$f44997672ac7151c(()=>window.localStorage, window.location.origin);
        window.weissenstadtFavoritesStore = store;
        window.addEventListener("storage", (event)=>{
            if (event.key === $f0f28bb2d74f783a$export$86880b4b2e1a2384 || event.key === null) store.refresh();
        });
        window.addEventListener("pageshow", ()=>store.refresh());
        document.addEventListener("visibilitychange", ()=>{
            if (!document.hidden) store.refresh();
        });
    }
    return window.weissenstadtFavoritesStore;
}

});
parcelRegister("cYEst", function(module, exports) {

$parcel$export(module.exports, "FAVORITE_CATEGORIES", function () { return $28e3a808001092ca$export$21d79fdf84687ea0; });
$parcel$export(module.exports, "favoriteView", function () { return $28e3a808001092ca$export$d3e5228b6a6ce747; });
// Stabile, sprachunabhängige Schlüssel; die Beschriftungen kommen aus PHP
// (weissenstadt_favorite_category_labels()). Reihenfolge = Filterreihenfolge.
const $28e3a808001092ca$export$21d79fdf84687ea0 = [
    "stay",
    "food",
    "event",
    "place",
    "other"
];
function $28e3a808001092ca$export$d3e5228b6a6ce747(items, requested = "all") {
    const counts = new Map($28e3a808001092ca$export$21d79fdf84687ea0.map((category)=>[
            category,
            0
        ]));
    for (const item of items)if (counts.has(item.category)) counts.set(item.category, counts.get(item.category) + 1);
    const categories = $28e3a808001092ca$export$21d79fdf84687ea0.filter((category)=>counts.get(category));
    const category = categories.length > 1 && counts.get(requested) ? requested : "all";
    return {
        category: category,
        categories: categories,
        counts: counts,
        items: category === "all" ? items : items.filter((item)=>item.category === category)
    };
}

});


parcelRegister("kNIpW", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $f24ad6a511d64d01$export$e506a1d27d1eaa20; });
$parcel$export(module.exports, "t", function () { return $f24ad6a511d64d01$export$625550452a3fa3ec; });
$parcel$export(module.exports, "showError", function () { return $f24ad6a511d64d01$export$3879b24e8245693d; });
$parcel$export(module.exports, "notify", function () { return $f24ad6a511d64d01$export$5e14cdade93d6f7b; });

var $6K3oU = parcelRequire("6K3oU");
const $f24ad6a511d64d01$export$e506a1d27d1eaa20 = ()=>({
        ...window.weissenstadtFavorites,
        ...window.weissenstadtFavoritesList
    });
const $f24ad6a511d64d01$export$625550452a3fa3ec = (key)=>window.weissenstadtFavorites?.strings?.[key] || window.weissenstadtFavoritesList?.strings?.[key] || key;
const $f24ad6a511d64d01$var$DURATION = 7000;
const $f24ad6a511d64d01$var$UNDO_DURATION = 12000;
// Inline SVGs from inc/icons.php (localized config); no second icon source.
const $f24ad6a511d64d01$var$glyph = (name)=>$f24ad6a511d64d01$export$e506a1d27d1eaa20().icons?.[name] || "";
const $f24ad6a511d64d01$var$reducedMotion = ()=>window.matchMedia("(prefers-reduced-motion: reduce)").matches;
function $f24ad6a511d64d01$var$element(tag, className, attributes = {}) {
    const node = document.createElement(tag);
    node.className = className;
    for (const [name, value] of Object.entries(attributes))node.setAttribute(name, value);
    return node;
}
/** Without an explicit tone, the offered actions describe what happened. */ function $f24ad6a511d64d01$var$toneFor(options) {
    if (options.error) return "error";
    if (options.tone) return options.tone;
    if (options.undo) return "removed";
    if (options.open) return "added";
    return "info";
}
function $f24ad6a511d64d01$var$createFeedback() {
    const live = $f24ad6a511d64d01$var$element("p", "screen-reader-text", {
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true"
    });
    live.dataset.feedbackLive = "";
    const box = $f24ad6a511d64d01$var$element("aside", "favorites-feedback", {
        "aria-label": $f24ad6a511d64d01$export$625550452a3fa3ec("favorites")
    });
    box.hidden = true;
    const icon = $f24ad6a511d64d01$var$element("span", "favorites-feedback__icon", {
        "aria-hidden": "true"
    });
    const body = $f24ad6a511d64d01$var$element("div", "favorites-feedback__body");
    const message = $f24ad6a511d64d01$var$element("p", "favorites-feedback__message");
    message.dataset.feedbackMessage = "";
    const actions = $f24ad6a511d64d01$var$element("div", "favorites-feedback__actions");
    const open = $f24ad6a511d64d01$var$element("a", "favorites-feedback__action is-primary");
    open.href = $f24ad6a511d64d01$export$e506a1d27d1eaa20().listUrl;
    open.innerHTML = $f24ad6a511d64d01$var$glyph("arrow");
    open.prepend($f24ad6a511d64d01$export$625550452a3fa3ec("open"));
    const buttons = {};
    for (const action of [
        "undo",
        "reset"
    ]){
        const button = $f24ad6a511d64d01$var$element("button", "favorites-feedback__action", {
            type: "button"
        });
        button.dataset.feedbackAction = action;
        button.textContent = $f24ad6a511d64d01$export$625550452a3fa3ec(action);
        if (action === "undo") button.insertAdjacentHTML("afterbegin", $f24ad6a511d64d01$var$glyph("undo"));
        buttons[action] = button;
    }
    actions.append(open, buttons.undo, buttons.reset);
    body.append(message, actions);
    const close = $f24ad6a511d64d01$var$element("button", "favorites-feedback__close", {
        type: "button",
        "aria-label": $f24ad6a511d64d01$export$625550452a3fa3ec("close"),
        title: $f24ad6a511d64d01$export$625550452a3fa3ec("close")
    });
    close.dataset.feedbackAction = "close";
    close.innerHTML = $f24ad6a511d64d01$var$glyph("close");
    const timerBar = $f24ad6a511d64d01$var$element("span", "favorites-feedback__timer", {
        "aria-hidden": "true"
    });
    box.append(icon, body, close, timerBar);
    document.body.append(live, box);
    const onListPage = ()=>{
        try {
            return new URL($f24ad6a511d64d01$export$e506a1d27d1eaa20().listUrl, window.location.href).pathname === window.location.pathname;
        } catch  {
            return false;
        }
    };
    let undo;
    let returnFocus;
    let timeout;
    let remaining = null;
    let deadline;
    let progress;
    let leaving;
    let hovered = false;
    let announcementFrame;
    // A notice never expires unseen: hover, focus and background tabs pause it.
    const interacting = ()=>hovered || document.hidden || box.contains(document.activeElement);
    // The timeout decides; the bar only mirrors it and pauses alongside it.
    function stopTimer() {
        clearTimeout(timeout);
        timeout = undefined;
        remaining = null;
        progress?.cancel();
        progress = null;
    }
    function startTimer(duration) {
        stopTimer();
        box.classList.toggle("has-timer", Boolean(duration));
        if (!duration) return;
        remaining = duration;
        progress = timerBar.animate([
            {
                transform: "scaleX(1)"
            },
            {
                transform: "scaleX(0)"
            }
        ], {
            duration: duration,
            easing: "linear",
            fill: "forwards"
        });
        progress.pause();
        box.classList.add("is-paused");
        resume();
    }
    function pause() {
        if (timeout === undefined) return;
        clearTimeout(timeout);
        timeout = undefined;
        remaining = Math.max(0, deadline - performance.now());
        progress?.pause();
        box.classList.add("is-paused");
    }
    function resume() {
        if (box.hidden || leaving || interacting()) return;
        if (remaining === null || timeout !== undefined) return;
        deadline = performance.now() + remaining;
        timeout = setTimeout(()=>dismiss(), remaining);
        progress?.play();
        box.classList.remove("is-paused");
    }
    function show(wasHidden) {
        leaving?.cancel();
        leaving = null;
        box.classList.remove("is-leaving");
        box.hidden = false;
        if ($f24ad6a511d64d01$var$reducedMotion()) {
            if (wasHidden) box.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 160
            });
            return;
        }
        if (wasHidden) box.animate([
            {
                opacity: 0,
                transform: "translateY(1rem) scale(0.97)"
            },
            {
                opacity: 1,
                transform: "none"
            }
        ], {
            duration: 260,
            easing: "cubic-bezier(0.2, 0.8, 0.2, 1)"
        });
        icon.animate([
            {
                transform: "scale(0.5)"
            },
            {
                transform: "scale(1.15)",
                offset: 0.6
            },
            {
                transform: "scale(1)"
            }
        ], {
            duration: 360,
            delay: wasHidden ? 80 : 0,
            easing: "ease-out"
        });
    }
    function dismiss(restoreFocus = false) {
        stopTimer();
        undo = null;
        hovered = false;
        cancelAnimationFrame(announcementFrame);
        live.textContent = "";
        if (restoreFocus) {
            const target = returnFocus?.isConnected ? returnFocus : document.querySelector(".favorite-title, [data-favorites-nav] a");
            target?.focus({
                preventScroll: true
            });
        }
        if (box.hidden || leaving) return;
        if (document.hidden) {
            box.hidden = true;
            return;
        }
        box.classList.add("is-leaving");
        const exit = box.animate([
            {
                opacity: 1
            },
            {
                opacity: 0,
                transform: $f24ad6a511d64d01$var$reducedMotion() ? "none" : "translateY(0.5rem)"
            }
        ], {
            duration: 180,
            easing: "ease-in"
        });
        leaving = exit;
        exit.onfinish = ()=>{
            // A queued finish must not hide a notice shown again in the meantime.
            if (leaving !== exit) return;
            leaving = null;
            box.classList.remove("is-leaving");
            box.hidden = true;
        };
    }
    function notify(text, options = {}) {
        if (!box.contains(document.activeElement)) returnFocus = document.activeElement;
        const focused = document.activeElement;
        const wasHidden = box.hidden || Boolean(leaving);
        undo = options.undo;
        const canUndo = Boolean(undo?.removed || undo?.removedItems?.length);
        const tone = $f24ad6a511d64d01$var$toneFor(options);
        if (box.dataset.tone !== tone) icon.innerHTML = $f24ad6a511d64d01$var$glyph(tone);
        box.dataset.tone = tone;
        message.textContent = text;
        open.hidden = !options.open || onListPage();
        buttons.undo.hidden = !canUndo;
        buttons.reset.hidden = options.error !== "corrupt";
        actions.hidden = open.hidden && buttons.undo.hidden && buttons.reset.hidden;
        show(wasHidden);
        if (box.contains(focused) && focused.hidden) close.focus({
            preventScroll: true
        });
        // Keep the live region present before announcing, including repeated text.
        cancelAnimationFrame(announcementFrame);
        live.textContent = "";
        announcementFrame = requestAnimationFrame(()=>{
            live.textContent = text;
        });
        startTimer(options.error ? 0 : canUndo ? $f24ad6a511d64d01$var$UNDO_DURATION : $f24ad6a511d64d01$var$DURATION);
    }
    box.addEventListener("pointerenter", (event)=>{
        if (event.pointerType === "touch") return;
        hovered = true;
        pause();
    });
    box.addEventListener("pointerleave", ()=>{
        hovered = false;
        resume();
    });
    box.addEventListener("focusin", pause);
    box.addEventListener("focusout", ()=>queueMicrotask(resume));
    document.addEventListener("visibilitychange", ()=>document.hidden ? pause() : resume());
    box.addEventListener("click", (event)=>{
        const action = event.target.closest("[data-feedback-action]")?.dataset.feedbackAction;
        if (action === "undo" && undo) {
            const bulk = Boolean(undo.removedItems);
            const store = (0, $6K3oU.getFavoritesStore)();
            const result = bulk ? store.restoreMany(undo.removedItems) : store.restore(undo.removed, undo.before);
            if (!result.ok) return notify($f24ad6a511d64d01$export$625550452a3fa3ec(result.error), {
                error: result.error,
                undo: undo
            });
            notify($f24ad6a511d64d01$export$625550452a3fa3ec(bulk ? "listRestored" : "restored"), {
                tone: "added"
            });
        } else if (action === "reset") {
            const result = (0, $6K3oU.getFavoritesStore)().reset();
            if (!result.ok) return $f24ad6a511d64d01$export$3879b24e8245693d(result.error);
            notify($f24ad6a511d64d01$export$625550452a3fa3ec("resetDone"));
        } else if (action === "close") dismiss(true);
    });
    document.addEventListener("keydown", (event)=>{
        // Panels that handle Escape themselves (e.g. sharing) keep the notice open.
        if (event.key === "Escape" && !event.defaultPrevented && !box.hidden) dismiss(box.contains(document.activeElement));
    });
    return {
        notify: notify
    };
}
function $f24ad6a511d64d01$var$getFeedback() {
    window.weissenstadtFavoritesFeedback ||= $f24ad6a511d64d01$var$createFeedback();
    return window.weissenstadtFavoritesFeedback;
}
function $f24ad6a511d64d01$export$5e14cdade93d6f7b(message, options = {}) {
    $f24ad6a511d64d01$var$getFeedback().notify(message, options);
}
function $f24ad6a511d64d01$export$3879b24e8245693d(error) {
    $f24ad6a511d64d01$export$5e14cdade93d6f7b($f24ad6a511d64d01$export$625550452a3fa3ec(error), {
        error: error
    });
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $f24ad6a511d64d01$var$getFeedback, {
    once: true
});
else $f24ad6a511d64d01$var$getFeedback();

});

parcelRegister("1rCcS", function(module, exports) {

$parcel$export(module.exports, "trackFavoriteEvent", function () { return $b4a1fe4fb4326b02$export$bc3afc189ac43973; });
// Feste Ereignisnamen für den GTM-dataLayer (GA4 hinter der Borlabs-
// Einwilligung). Ohne Einwilligung verarbeitet GTM die Einträge nicht weiter.
const $b4a1fe4fb4326b02$var$events = {
    opened: "merkliste_geoeffnet",
    saved: "merkliste_gemerkt",
    shared: "merkliste_geteilt",
    qr: "merkliste_qr",
    imported: "merkliste_uebernommen",
    mailed: "merkliste_email"
};
function $b4a1fe4fb4326b02$export$bc3afc189ac43973(action, context = globalThis) {
    try {
        if (!Object.hasOwn($b4a1fe4fb4326b02$var$events, action)) return;
        const layer = context.dataLayer;
        if (!Array.isArray(layer)) return;
        layer.push({
            event: $b4a1fe4fb4326b02$var$events[action],
            merkliste_seite: context.location.origin + context.location.pathname
        });
    } catch  {
    // Analytics must not interrupt saving, sharing or importing.
    }
}

});


// Frontpage Top Main Slider Video Viewport Resize
var $877c079156189ed2$var$min_w = 300; // minimum video width allowed
var $877c079156189ed2$var$vid_w_orig; // original video dimensions
var $877c079156189ed2$var$vid_h_orig;
jQuery(function() {
    // runs after DOM has loaded
    $877c079156189ed2$var$vid_w_orig = parseInt(jQuery("video").attr("width"));
    $877c079156189ed2$var$vid_h_orig = parseInt(jQuery("video").attr("height"));
    jQuery("#debug").append("<p>DOM loaded</p>");
    jQuery(window).resize(function() {
        $877c079156189ed2$var$resizeToCover();
    });
    jQuery(window).trigger("resize");
});
function $877c079156189ed2$var$resizeToCover() {
    // set the video viewport to the window size
    jQuery(".slide-video").width(jQuery(window).width());
    jQuery(".slide-video").height(jQuery(window).height());
    // use largest scale factor of horizontal/vertical
    var scale_h = jQuery(window).width() / $877c079156189ed2$var$vid_w_orig;
    var scale_v = jQuery(window).height() / $877c079156189ed2$var$vid_h_orig;
    var scale = scale_h > scale_v ? scale_h : scale_v;
    // don't allow scaled width < minimum video width
    if (scale * $877c079156189ed2$var$vid_w_orig < $877c079156189ed2$var$min_w) scale = $877c079156189ed2$var$min_w / $877c079156189ed2$var$vid_w_orig;
    // now scale the video
    jQuery("video").width(scale * $877c079156189ed2$var$vid_w_orig);
    jQuery("video").height(scale * $877c079156189ed2$var$vid_h_orig);
    // and center it by scrolling the video viewport
    jQuery(".slide-video").scrollLeft((jQuery("video").width() - jQuery(window).width()) / 2);
    jQuery(".slide-video").scrollTop((jQuery("video").height() - jQuery(window).height()) / 2);
}
// Mainpage Top Video Slide Wrapper
jQuery(document).ready(function() {
    jQuery(".main-slider").on("init breakpoint", function(event, slick) {
        if (!$877c079156189ed2$var$isChanging) {
            jQuery("#breakpointValue").text(String(slick.activeBreakpoint));
            // Prevent infinite loop
            $877c079156189ed2$var$isChanging = true;
            // The highest breakpoint is null
            if (slick.activeBreakpoint && slick.activeBreakpoint <= $877c079156189ed2$var$breakpointMobile) {
                if (!$877c079156189ed2$var$isFiltered) {
                    slick.slickFilter(":not(.hide-on-mobile)");
                    $877c079156189ed2$var$isFiltered = true;
                }
            } else if ($877c079156189ed2$var$isFiltered) {
                slick.slickUnfilter();
                $877c079156189ed2$var$isFiltered = false;
            }
            $877c079156189ed2$var$isChanging = false;
        }
    });
    jQuery(".main-slider").on("init", function(e, slick) {
        var $firstAnimatingElements = jQuery("div.slideranimation:first-child").find("[data-animation]");
        doAnimations($firstAnimatingElements);
    });
    jQuery(".main-slider").on("beforeChange", function(e, slick, currentSlide, nextSlide) {
        var $animatingElements = jQuery('div.slideranimation[data-slick-index="' + nextSlide + '"]').find("[data-animation]");
        doAnimations($animatingElements);
    });
    var slideWrapper = jQuery(".main-slider"), iframes = slideWrapper.find(".embed-player"), lazyImages = slideWrapper.find(".slide-image"), lazyCounter = 0;
    // POST commands to YouTube or Vimeo API
    function postMessageToPlayer(player, command) {
        if (player == null || command == null) return;
        player.contentWindow.postMessage(JSON.stringify(command), "*");
    }
    // When the slide is changing
    function playPauseVideo(slick, control) {
        var currentSlide, slideType, startTime, player, video;
        currentSlide = slick.find(".slick-current");
        slideType = currentSlide.attr("class").split(" ")[1];
        player = currentSlide.find("iframe").get(0);
        startTime = currentSlide.data("video-start");
        // console.log('Current Slide:');
        // console.log(currentSlide);
        // console.log('Type:');
        // console.log(slideType);
        if (slideType === "vimeo") switch(control){
            case "play":
                if (startTime != null && startTime > 0 && !currentSlide.hasClass("started")) {
                    currentSlide.addClass("started");
                    postMessageToPlayer(player, {
                        method: "setCurrentTime",
                        value: startTime
                    });
                }
                postMessageToPlayer(player, {
                    method: "play",
                    value: 1
                });
                break;
            case "pause":
                postMessageToPlayer(player, {
                    method: "pause",
                    value: 1
                });
                break;
        }
        else if (slideType === "youtube") switch(control){
            case "play":
                postMessageToPlayer(player, {
                    event: "command",
                    func: "mute"
                });
                postMessageToPlayer(player, {
                    event: "command",
                    func: "playVideo"
                });
                break;
            case "pause":
                postMessageToPlayer(player, {
                    event: "command",
                    func: "pauseVideo"
                });
                break;
        }
        else if (slideType === "video") {
            // currentSlide = document.getElementsByClassName('responsive-video');
            // console.log(currentSlide);
            // currentSlide = currentSlide[0];
            // console.log(currentSlide);
            video = currentSlide.children("video").get(0);
            // console.log(video);
            if (video != null) {
                if (control === "play") video.play();
                else video.pause();
            }
        }
    }
    // // Resize player
    // function resizePlayer(iframes, ratio) {
    // 	if (!iframes[0]) return;
    // 	var win = $('.main-slider'),
    // 		width = win.width(),
    // 		playerWidth,
    // 		height = win.height(),
    // 		playerHeight,
    // 		ratio = ratio || 16 / 9;
    // 	iframes.each(function () {
    // 		var current = $(this);
    // 		if (width / ratio < height) {
    // 			playerWidth = Math.ceil(height * ratio);
    // 			current.width(playerWidth).height(height).css({
    // 				left: (width - playerWidth) / 2,
    // 				top: 0
    // 			});
    // 		} else {
    // 			playerHeight = Math.ceil(width / ratio);
    // 			current.width(width).height(playerHeight).css({
    // 				left: 0,
    // 				top: (height - playerHeight) / 2
    // 			});
    // 		}
    // 	});
    // }
    // DOM Ready
    jQuery(function() {
        // Initialize
        // slideWrapper.on('init', function (slick) {
        // 	slick = $(slick.currentTarget);
        // 	setTimeout(function () {
        // 		playPauseVideo(slick, 'play');
        // 	}, 1000);
        // 	resizePlayer(iframes, 16 / 9);
        // });
        // slideWrapper.on('beforeChange', function (event, slick) {
        // 	slick = $(slick.$slider);
        // 	playPauseVideo(slick, 'pause');
        // });
        // slideWrapper.on('afterChange', function (event, slick) {
        // 	slick = $(slick.$slider);
        // 	playPauseVideo(slick, 'play');
        // });
        // slideWrapper.on('lazyLoaded', function (event, slick, image, imageSource) {
        // 	lazyCounter++;
        // 	if (lazyCounter === lazyImages.length) {
        // 		lazyImages.addClass('show');
        // 		// slideWrapper.slick("slickPlay");
        // 	}
        // });
        //start the slider
        slideWrapper.slick({
            // fade:true,
            autoplaySpeed: 4000,
            lazyLoad: "ondemand",
            speed: 600,
            arrows: true,
            dots: false,
            fade: true,
            cssEase: "cubic-bezier(0.87, 0.03, 0.41, 0.9)"
        });
    });
    function doAnimations(elements) {
        var animationEndEvents = "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";
        elements.each(function() {
            var $this = $(this);
            var $animationDelay = $this.data("delay");
            var $animationType = "animated " + $this.data("animation");
            $this.css({
                visibility: "visible",
                "animation-delay": $animationDelay,
                "-webkit-animation-delay": $animationDelay
            });
            $this.addClass($animationType).one(animationEndEvents, function() {
                $this.removeClass($animationType);
            });
        });
    }
// Resize event
// $(window).on('resize.slickVideoPlayer', function () {
// 	resizePlayer(iframes, 16 / 9);
// });
});
jQuery(".aktivitaets-slider").slick({
    autoplaySpeed: 5000,
    autoplay: false,
    prevArrow: ".aktiprev",
    nextArrow: ".aktinext",
    dots: false,
    infinite: true,
    speed: 2500,
    slidesToShow: 4,
    slidesToScroll: 1,
    // prevArrow: false,
    // nextArrow: false,
    lazyLoad: "progressive",
    responsive: [
        // {
        //   breakpoint: 1024,
        //   settings: {
        //     slidesToShow: 3,
        //     slidesToScroll: 1,
        //     infinite: true,
        //     dots: false
        //   }
        // },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
    ]
});
jQuery(".kultur-modul-slider").slick({
    infinite: false,
    autoplaySpeed: 5000,
    autoplay: false,
    dots: false,
    speed: 250,
    // prevArrow: $('.slick-kultur-prev'),
    // nextArrow: $('.slick-kultur-next'),
    slidesToShow: 3,
    slidesToScroll: 1,
    // prevArrow: false,
    // nextArrow: false,
    lazyLoad: "ondemand",
    responsive: [
        // {
        //   breakpoint: 1024,
        //   settings: {
        //     slidesToShow: 3,
        //     slidesToScroll: 1,
        //     infinite: true,
        //     dots: false
        //   }
        // },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});
var $877c079156189ed2$var$$partnerModulSlider = jQuery(".partner-modul-slider");
var $877c079156189ed2$var$partnerModulSliderPrevLabel = $877c079156189ed2$var$$partnerModulSlider.data("prev-label") || "Vorherige Partner anzeigen";
var $877c079156189ed2$var$partnerModulSliderNextLabel = $877c079156189ed2$var$$partnerModulSlider.data("next-label") || "N\xe4chste Partner anzeigen";
var $877c079156189ed2$var$partnerModulSliderShouldReduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
function $877c079156189ed2$var$escapePartnerModulSliderLabel(label) {
    return jQuery("<div>").text(label).html();
}
function $877c079156189ed2$var$partnerModulSliderArrow(direction, label) {
    // Icon-Markup kommt aus inc/icons.php ueber wp_localize_script — kein
    // Klassenname mehr, seit die Icons Inline-SVG statt Webfont sind.
    var icons = window.weissenstadt_bundle_object && window.weissenstadt_bundle_object.icons || {};
    var icon = (direction === "prev" ? icons.chevronLeft : icons.chevronRight) || "";
    return '<button class="frontpage-partner-arrow frontpage-partner-arrow--' + direction + '" type="button" aria-label="' + $877c079156189ed2$var$escapePartnerModulSliderLabel(label) + '">' + icon + "</button>";
}
function $877c079156189ed2$var$normalizePartnerModulSliderFocus(event, slick) {
    var $slider = slick && slick.$slider ? slick.$slider : $877c079156189ed2$var$$partnerModulSlider;
    window.setTimeout(function() {
        $slider.find(".slick-slide").attr("tabindex", "-1");
        $slider.find(".slick-cloned a, .slick-slide[aria-hidden='true'] a").attr("tabindex", "-1");
        $slider.find(".slick-active a").attr("tabindex", "0");
    }, 0);
}
$877c079156189ed2$var$$partnerModulSlider.on("init reInit afterChange breakpoint setPosition", $877c079156189ed2$var$normalizePartnerModulSliderFocus);
// Relaunch 2026: the redesign's motion tuning (gentle autoplay, soft easing,
// pause on hover/focus, per-width breakpoints) merged onto this theme's July
// rework (accessible arrows + focus normalization). Autoplay stays off for
// visitors who prefer reduced motion.
$877c079156189ed2$var$$partnerModulSlider.slick({
    dots: false,
    infinite: true,
    autoplay: !$877c079156189ed2$var$partnerModulSliderShouldReduceMotion,
    autoplaySpeed: 3200,
    pauseOnHover: true,
    pauseOnFocus: true,
    swipeToSlide: true,
    touchThreshold: 10,
    speed: $877c079156189ed2$var$partnerModulSliderShouldReduceMotion ? 0 : 700,
    cssEase: "cubic-bezier(0.22, 1, 0.36, 1)",
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: $877c079156189ed2$var$partnerModulSliderArrow("prev", $877c079156189ed2$var$partnerModulSliderPrevLabel),
    nextArrow: $877c079156189ed2$var$partnerModulSliderArrow("next", $877c079156189ed2$var$partnerModulSliderNextLabel),
    lazyLoad: "progressive",
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});
// $('.buerger-slider').on('afterChange', function (event, slick, currentSlide) {
// 	if (currentSlide === 6) {
// 		$('.slick-next').addClass('hidden');
// 	}
// 	else {
// 		$('.slick-next').removeClass('hidden');
// 	}
// 	if (currentSlide === 0) {
// 		$('.slick-prev').addClass('hidden');
// 	}
// 	else {
// 		$('.slick-prev').removeClass('hidden');
// 	}
// });
jQuery(".buerger-slider").slick({
    dots: false,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    // prevArrow: true,
    // nextArrow: true,
    lazyLoad: "progressive",
    prevArrow: ".buergerprev",
    nextArrow: ".buergernext",
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 300,
    responsive: [
        // {
        //   breakpoint: 1024,
        //   settings: {
        //     slidesToShow: 3,
        //     slidesToScroll: 1,
        //     infinite: true,
        //     dots: false
        //   }
        // },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});
var $877c079156189ed2$var$breakpointMobile = 1328, $877c079156189ed2$var$isChanging = false, $877c079156189ed2$var$isFiltered = false;
jQuery(".footer-slider").slick({
    infinite: true,
    autoplaySpeed: 10000,
    fade: true,
    speed: 1000,
    // cssEase: "linear",
    autoplay: true,
    dots: true,
    lazyLoad: "ondemand",
    pauseOnHover: false,
    responsive: [
        {
            breakpoint: 500
        },
        {
            breakpoint: 700
        },
        {
            breakpoint: 1328
        }
    ]
});


var $616da9c9da875c98$exports = {};
// Init wow.js — honor BITV/WCAG reduced-motion preference
if (typeof WOW !== "undefined" && !(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)) new WOW().init();
function $616da9c9da875c98$var$setAccordionPanelHeight(panel) {
    if (!panel) return;
    panel.style.maxHeight = panel.scrollHeight + "px";
}
function $616da9c9da875c98$var$refreshOpenAccordionHeights(scope) {
    const root = scope || document;
    const openAccordions = root.querySelectorAll(".accordion.active");
    openAccordions.forEach((accordion)=>{
        const panel = accordion.nextElementSibling;
        $616da9c9da875c98$var$setAccordionPanelHeight(panel);
    });
}
// Auto-Preload des 360°-Panos nur auf Geräten, die dessen Dauer-Rendern
// verkraften (Analyse: docs/aktiv/360-performance-schwache-geraete.md — auf
// alten Laptops ruckelten die Startseiten-Menüs, weil das Pano im Hintergrund
// durchgehend per WebGL rendert, auf Blocklisten-GPUs sogar in Software).
// Fällt ein Kriterium durch, bleibt das Preview-JPEG stehen und die Tour lädt
// erst beim Klick — derselbe Weg, den Mobile/Tablet immer nehmen. Fehlende
// APIs zählen neutral, sonst verlöre Firefox/Safari das Pano grundlos
// (deviceMemory/connection gibt es nur in Chromium).
function $616da9c9da875c98$var$deviceCanAffordPanoPreload() {
    // Nutzerwunsch schlägt Gerätefähigkeit: nichts automatisch bewegen
    // (WCAG 2.2.2), keine Megabytes im Datensparmodus.
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
    const connection = navigator.connection;
    if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ""))) return false;
    // Kerne und RAM sind je für sich schwache Proxys — nur die Kombination
    // aus beiden gilt als „zu schwach".
    const cores = navigator.hardwareConcurrency;
    const memory = navigator.deviceMemory;
    if (cores && cores <= 4 && memory && memory < 4) return false;
    // Software-WebGL (SwiftShader, llvmpipe, Microsoft Basic Render) macht
    // das Pano zum CPU-Dauerbrenner — der teuerste Fall, sicher ausschließen.
    try {
        const canvas = document.createElement("canvas");
        const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        if (!gl) // Ohne WebGL fiele Marzipano auf den CSS-Renderer zurück — noch teurer.
        return false;
        const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
        const renderer = debugInfo ? String(gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)) : "";
        const loseContext = gl.getExtension("WEBGL_lose_context");
        if (loseContext) loseContext.loseContext();
        if (/swiftshader|llvmpipe|software|basic render/i.test(renderer)) return false;
    } catch (error) {
    // Probe fehlgeschlagen → neutral werten, nicht ausschließen.
    }
    return true;
}
function $616da9c9da875c98$var$initHero360Tour(heroSection) {
    if (!heroSection) return;
    heroSection.setAttribute("tabindex", "-1");
    const iframeHost = heroSection.querySelector(".iframe-360");
    const desktopOverlay = heroSection.querySelector(".activate-desktop");
    const viewIcon = heroSection.querySelector(".viewicon");
    const previewTriggers = Array.from(heroSection.querySelectorAll(".activate-360, .viewicon"));
    const winterPreview = heroSection.querySelector('[id="360winter"]');
    const summerPreview = heroSection.querySelector('[id="360summer"]');
    const iframeSrc = winterPreview ? "https://360winter.weissenstadt.de" : summerPreview ? "https://360.weissenstadt.de" : "";
    if (!iframeHost || !iframeSrc) return;
    const actionButton = heroSection.querySelector("[data-ws-hero-tour-trigger]");
    const actionButtonLabel = actionButton ? actionButton.querySelector("[data-ws-hero-tour-label]") : null;
    const interactionHint = heroSection.querySelector("[data-ws-hero-tour-hint]");
    const isExperimentHero = Boolean(actionButton);
    const experimentHeader = isExperimentHero ? document.querySelector(".ws-site-header[data-ws-site-header]") : null;
    const brandLink = experimentHeader ? experimentHeader.querySelector(".ws-site-header__brand") : null;
    const deviceAffordsPano = $616da9c9da875c98$var$deviceCanAffordPanoPreload();
    const shouldPreloadIframe = window.matchMedia("(min-width: 1200px)").matches && deviceAffordsPano;
    // Für postMessage zählt nur die Origin — nicht die volle URL. Explizit
    // ableiten, damit der Absender-Check auch hält, falls iframeSrc je einen
    // Pfad trägt.
    const panoOrigin = new URL(iframeSrc, window.location.href).origin;
    const rotationToggle = heroSection.querySelector("[data-ws-hero-rotation-toggle]");
    let iframeElement = null;
    let isActive = false;
    let interactionHintTimeout = null;
    // Steuerkanal zum Pano (Stufe 3, docs/aktiv/360-performance-schwache-geraete.md):
    // das iframe ist cross-origin, eingegriffen wird per postMessage. iframeSrc
    // ist bereits die nackte Origin und dient als targetOrigin/Absender-Check.
    let iframeReady = false;
    let pendingPanoAction = null;
    let panoRotating = false;
    let rotationPausedByUser = false;
    let heroOffscreen = false;
    let menuIsOpen = false;
    let menuHovered = false;
    let panoSuspended = false;
    function focusHeroSection() {
        if (typeof heroSection.focus !== "function") return;
        try {
            heroSection.focus({
                preventScroll: true
            });
        } catch (error) {
            heroSection.focus();
        }
    }
    function restoreParentFocus() {
        if (!isActive) return;
        hideInteractionHint();
        window.setTimeout(()=>{
            if (!isActive) return;
            focusHeroSection();
        }, 60);
    }
    function handleIframeFocus() {
        if (!isActive) return;
        hideInteractionHint();
        restoreParentFocus();
    }
    function handleWindowBlur() {
        if (!isActive || !iframeElement) return;
        window.setTimeout(()=>{
            if (!isActive || document.activeElement !== iframeElement) return;
            hideInteractionHint();
            focusHeroSection();
        }, 0);
    }
    function handleEscapeKey(event) {
        if (!isActive || event.key !== "Escape") return;
        deactivateTour(event);
        focusHeroSection();
    }
    function setActionButtonState(active) {
        if (!actionButton) return;
        const defaultLabel = actionButton.getAttribute("data-ws-tour-label-default") || "";
        const activeLabel = actionButton.getAttribute("data-ws-tour-label-active") || defaultLabel;
        const defaultAria = actionButton.getAttribute("data-ws-tour-aria-default") || defaultLabel;
        const activeAria = actionButton.getAttribute("data-ws-tour-aria-active") || activeLabel;
        actionButton.classList.toggle("is-active", active);
        actionButton.setAttribute("aria-label", active ? activeAria : defaultAria);
        if (actionButtonLabel) actionButtonLabel.textContent = active ? activeLabel : defaultLabel;
    // Das Icon schaltet CSS anhand von .is-active um — beide Varianten stehen
    // im Markup. Frueher tauschte hier ein className-Zuweisung die FA-Klasse;
    // bei Inline-SVG geht das nicht, className ist dort schreibgeschuetzt.
    }
    function setIframeInteractivity(active) {
        if (!iframeElement) return;
        iframeElement.style.pointerEvents = active ? "auto" : "none";
        iframeElement.style.cursor = active ? "grab" : "";
        iframeHost.style.cursor = active ? "grab" : "";
    }
    function hideInteractionHint() {
        if (!interactionHint) return;
        if (interactionHintTimeout) {
            window.clearTimeout(interactionHintTimeout);
            interactionHintTimeout = null;
        }
        interactionHint.classList.remove("is-visible");
        interactionHint.setAttribute("aria-hidden", "true");
    }
    function showInteractionHint() {
        if (!interactionHint) return;
        interactionHint.classList.add("is-visible");
        interactionHint.setAttribute("aria-hidden", "false");
        if (interactionHintTimeout) window.clearTimeout(interactionHintTimeout);
        interactionHintTimeout = window.setTimeout(()=>{
            interactionHint.classList.remove("is-visible");
            interactionHint.setAttribute("aria-hidden", "true");
            interactionHintTimeout = null;
        }, 5000);
    }
    function syncState() {
        heroSection.classList.toggle("is-tour-active", isActive);
        if (desktopOverlay) desktopOverlay.classList.toggle("inactive", isActive);
        setIframeInteractivity(isActive);
        setActionButtonState(isActive);
        syncPanoVisibility();
        syncPanoSuspension();
        updateRotationToggle();
        if (!isExperimentHero) return;
        document.body.classList.toggle("ws-tour-active", isActive);
        if (experimentHeader) experimentHeader.classList.toggle("is-tour-active", isActive);
    }
    // Ohne Preload (Mobile/Tablet, schwache Geräte) ist das Pano kein
    // Hero-Hintergrund, sondern existiert nur für die geöffnete Tour. Nach dem
    // Verlassen steht sie dort pausiert hinter dem Preview-JPEG, statt sichtbar
    // weiterzudrehen und den Pause-Knopf einzublenden.
    function panoParked() {
        return !shouldPreloadIframe && !isActive;
    }
    function syncPanoVisibility() {
        const panoVisible = Boolean(iframeElement) && !panoParked();
        heroSection.classList.toggle("is-pano-ready", iframeReady && panoVisible);
        if (viewIcon) viewIcon.style.display = panoVisible ? "none" : "";
    }
    function ensureIframe() {
        if (iframeElement) return iframeElement;
        iframeElement = document.createElement("iframe");
        iframeElement.className = "iframe-360__frame";
        iframeElement.title = ({
            en: "360\xb0 view of Wei\xdfenstadt",
            cs: "360\xb0 pohled na Wei\xdfenstadt"
        })[document.documentElement.lang.slice(0, 2)] || "360\xb0 Wei\xdfenstadt Ansicht";
        // Das Preview-JPEG bleibt sichtbar, bis das Pano wirklich gerendert werden
        // kann — is-pano-ready blendet das iframe per CSS über das Standbild.
        iframeElement.addEventListener("load", ()=>{
            iframeReady = true;
            syncPanoVisibility();
            if (pendingPanoAction) {
                const queuedAction = pendingPanoAction;
                pendingPanoAction = null;
                postToPano(queuedAction);
            }
        }, {
            once: true
        });
        // Schwaches Gerät, Tour trotzdem per Klick geöffnet: Pano ja, aber ohne
        // Autorotate — der Nutzer steuert selbst, Play in der Tour bleibt Opt-in.
        iframeElement.src = deviceAffordsPano ? iframeSrc : iframeSrc + "/?autorotate=0";
        iframeElement.width = "100%";
        iframeElement.height = "100%";
        iframeElement.tabIndex = -1;
        iframeElement.setAttribute("allowfullscreen", "true");
        iframeElement.setAttribute("loading", shouldPreloadIframe ? "eager" : "lazy");
        iframeElement.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
        iframeElement.style.display = "block";
        iframeElement.style.width = "100%";
        iframeElement.style.height = "100%";
        iframeElement.style.border = "0";
        iframeElement.style.pointerEvents = "none";
        iframeHost.appendChild(iframeElement);
        iframeHost.style.display = "block";
        iframeElement.addEventListener("focus", handleIframeFocus);
        iframeElement.addEventListener("mousedown", restoreParentFocus);
        iframeElement.addEventListener("touchstart", restoreParentFocus, {
            passive: true
        });
        return iframeElement;
    }
    function activateTour(event) {
        if (event) event.preventDefault();
        ensureIframe();
        isActive = true;
        syncState();
        focusHeroSection();
        showInteractionHint();
    }
    function deactivateTour(event) {
        if (event) event.preventDefault();
        if (!iframeElement) return;
        isActive = false;
        syncState();
        hideInteractionHint();
        if (actionButton) actionButton.focus();
    }
    if (desktopOverlay) desktopOverlay.addEventListener("click", activateTour);
    previewTriggers.forEach((trigger)=>{
        trigger.addEventListener("click", activateTour);
    });
    if (actionButton) actionButton.addEventListener("click", (event)=>{
        if (isActive) {
            deactivateTour(event);
            return;
        }
        activateTour(event);
    });
    if (brandLink) brandLink.addEventListener("click", (event)=>{
        if (!isActive) return;
        deactivateTour(event);
    });
    window.addEventListener("keydown", handleEscapeKey, true);
    window.addEventListener("blur", handleWindowBlur);
    if (!isExperimentHero) heroSection.addEventListener("mouseleave", ()=>{
        if (!isActive) return;
        deactivateTour();
    });
    function postToPano(action) {
        if (!iframeElement) return;
        if (!iframeReady) {
            // Nur die letzte Aktion merken — beim iframe-load zählt der Endstand.
            pendingPanoAction = action;
            return;
        }
        iframeElement.contentWindow.postMessage({
            action: action
        }, panoOrigin);
    }
    function updateRotationToggle() {
        if (!rotationToggle) return;
        // Sichtbar nur, solange es etwas zu pausieren gibt (WCAG 2.2.2) — oder
        // der Nutzer selbst pausiert hat und wieder starten können muss. Stoppt
        // das Budget der Tour die Drehung, verschwindet der Knopf von allein
        // (Statusmeldung rotating:false; Systempausen zählen nicht, siehe
        // message-Listener). In der aktiven Tour hat der Nutzer
        // die Kontrolle ohnehin selbst (eigener Pause-Button, Draggen stoppt
        // die Drehung) — dort bleibt der Knopf weg. Ein geparktes Pano (siehe
        // panoParked) ist unsichtbar und pausiert, also auch nichts zu steuern.
        const visible = (panoRotating || rotationPausedByUser) && !isActive && !panoParked();
        rotationToggle.style.display = visible ? "" : "none";
        rotationToggle.classList.toggle("is-paused", rotationPausedByUser);
        const label = rotationToggle.getAttribute(rotationPausedByUser ? "data-ws-rotation-label-play" : "data-ws-rotation-label-pause") || "";
        rotationToggle.setAttribute("aria-label", label);
        rotationToggle.setAttribute("title", label);
    }
    // Pausen, die das Theme selbst verhängt — im Gegensatz zur bewussten
    // Nutzerpause über den Hero-Knopf.
    function panoBlockedBySystem() {
        return heroOffscreen || menuIsOpen || menuHovered || panoParked();
    }
    function syncPanoSuspension() {
        const shouldSuspend = panoBlockedBySystem() || rotationPausedByUser;
        if (shouldSuspend === panoSuspended) return;
        panoSuspended = shouldSuspend;
        postToPano(shouldSuspend ? "ws-360-pause" : "ws-360-resume");
    }
    // Statusmeldungen der Tour (dreht sie gerade?) — nur vom Pano-Origin.
    window.addEventListener("message", (event)=>{
        if (event.origin !== panoOrigin) return;
        const data = event.data;
        if (!data || data.source !== "ws-360") return;
        // „Dreht nicht mehr" wegen einer Systempause (Menü/Offscreen) ist kein
        // Endzustand — sonst flackert der Pause-Knopf bei jedem Überfahren der
        // Navigation weg und wieder herein.
        if (!data.rotating && !rotationPausedByUser && panoBlockedBySystem()) return;
        panoRotating = Boolean(data.rotating);
        updateRotationToggle();
    });
    if (rotationToggle) rotationToggle.addEventListener("click", ()=>{
        rotationPausedByUser = !rotationPausedByUser;
        if (rotationPausedByUser) syncPanoSuspension();
        else {
            // Bewusster Neustart: ws-360-play gibt der Tour ein frisches
            // 90-s-Budget (ein bloßes resume würde nach abgelaufenem Budget
            // stumm verpuffen und der Knopf zeigte ins Leere).
            panoSuspended = panoBlockedBySystem();
            if (!panoSuspended) postToPano("ws-360-play");
        }
        updateRotationToggle();
    });
    // Aus dem Viewport gescrollt → Drehung anhalten: unsichtbar weiterrendern
    // ist verschenkte GPU/Akku-Zeit. Zurück im Bild → weiterlaufen lassen
    // (die Tour rechnet ihr Restbudget selbst).
    if ("IntersectionObserver" in window) new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            heroOffscreen = !entry.isIntersecting;
            syncPanoSuspension();
        });
    }, {
        threshold: 0.05
    }).observe(heroSection);
    // Offenes Menü → Drehung anhalten: jeder Autorotate-Frame zwingt den
    // Browser, das Menü über dem bewegten iframe neu zu kompositen — genau
    // der auf alten Laptops gemeldete Menü-Lag. Desktop-Megamenüs tragen
    // .is-open/.is-mega-hovered im Header, das mobile Panel eine Body-Klasse.
    const siteHeaderRoot = document.querySelector(".ws-site-header");
    function menuCurrentlyOpen() {
        if (document.body.classList.contains("ws-site-header-menu-open")) return true;
        // Bis 1080px ist .is-open an Menüpunkten nur der Akkordeon-Zustand im
        // (meist zugeklappten) Mobil-Panel — der Header klappt den aktuellen
        // Pfad dort sogar vorab auf (site-header/view.js). Zählte das mit, galt
        // das Menü mobil dauerhaft als offen: das Pano stand schon in der
        // geöffneten Tour still, und der Pause-Knopf blieb danach hängen.
        if (window.innerWidth <= 1080) return false;
        return Boolean(siteHeaderRoot && siteHeaderRoot.querySelector(".is-open, .is-mega-hovered"));
    }
    if (siteHeaderRoot && "MutationObserver" in window) {
        const menuObserver = new MutationObserver(()=>{
            const nextMenuOpen = menuCurrentlyOpen();
            if (nextMenuOpen !== menuIsOpen) {
                menuIsOpen = nextMenuOpen;
                syncPanoSuspension();
            }
        });
        menuObserver.observe(siteHeaderRoot, {
            subtree: true,
            attributes: true,
            attributeFilter: [
                "class"
            ]
        });
        menuObserver.observe(document.body, {
            attributes: true,
            attributeFilter: [
                "class"
            ]
        });
    }
    // Schon das Überfahren der Navigation hält die Drehung an, nicht erst ein
    // aufgeklapptes Megamenü: Hover-Styles, Untermenü-Transitions und der
    // Gäste/Bürger-Schalter zeichnen den Header laufend neu — auf dem gemeldeten
    // alten Laptop ruckelte genau das Wandern durch die Menüleiste. Der Hover
    // beginnt außerdem immer vor dem Aufklappen: bis das Megamenü sichtbar ist,
    // steht das Pano bereits. Nur für echte Zeiger — auf Touch gibt es kein
    // verlässliches Gegenstück zu mouseleave, das mobile Panel deckt die
    // Body-Klasse oben ab.
    const headerNav = siteHeaderRoot ? siteHeaderRoot.querySelector(".ws-site-header__nav") : null;
    if (headerNav && window.matchMedia("(hover: hover)").matches) {
        const setMenuHovered = (hovered)=>{
            if (hovered === menuHovered) return;
            menuHovered = hovered;
            syncPanoSuspension();
            updateRotationToggle();
        };
        headerNav.addEventListener("mouseenter", ()=>setMenuHovered(true));
        headerNav.addEventListener("mouseleave", ()=>setMenuHovered(false));
    }
    if (shouldPreloadIframe) {
        // Erst nach window.load + Idle laden: Marzipano + Tiles (~1–3 MB) sollen
        // nicht mit Fonts/CSS/Bildern des kritischen Pfads um Bandbreite
        // konkurrieren. Bis dahin zeigt das Preview-JPEG den Hero.
        const schedulePreload = ()=>{
            if ("requestIdleCallback" in window) window.requestIdleCallback(()=>ensureIframe(), {
                timeout: 3000
            });
            else window.setTimeout(ensureIframe, 250);
        };
        if (document.readyState === "complete") schedulePreload();
        else window.addEventListener("load", schedulePreload, {
            once: true
        });
    }
    syncState();
}
// TABS
document.addEventListener("DOMContentLoaded", ()=>{
    const tab2024Buttons = Array.from(document.querySelectorAll(".tab2024-button[data-tab2024]"));
    const tab2024Panes = Array.from(document.querySelectorAll(".tab2024-pane"));
    if (tab2024Buttons.length === 0 || tab2024Panes.length === 0) return;
    const tabQueryParam = "tab";
    const tabButtonsById = new Map();
    const tabButtonsByKey = new Map();
    // Tab-Semantik (WCAG 4.1.2): die Leiste war bis 31.07.2026 eine Reihe
    // gewöhnlicher Buttons. Ein Screenreader konnte weder erkennen, dass es sich
    // um Registerkarten handelt, noch welche gerade ausgewählt ist, und die
    // Panels hatten keine Verbindung zu ihrem Reiter. Die Rollen werden hier
    // gesetzt statt im Template, damit Verwaltung und Stadtrat nicht zwei
    // getrennte Quellen dafür haben.
    const tab2024List = tab2024Buttons[0].closest(".tabs2024");
    if (tab2024List) tab2024List.setAttribute("role", "tablist");
    tab2024Buttons.forEach((button, index)=>{
        const tabId = button.getAttribute("data-tab2024");
        const tabKey = button.getAttribute("data-tab-key");
        if (tabId) tabButtonsById.set(tabId, button);
        if (tabKey) tabButtonsByKey.set(tabKey.toLowerCase(), button);
        if (!button.id) button.id = `tab2024-trigger-${index + 1}`;
        button.setAttribute("role", "tab");
        if (tabId) {
            button.setAttribute("aria-controls", tabId);
            const pane = document.getElementById(tabId);
            if (pane) {
                pane.setAttribute("role", "tabpanel");
                pane.setAttribute("aria-labelledby", button.id);
                // Ein Panel mit viel Text braucht einen eigenen Fokusstopp, sonst
                // können Tastaturnutzende es nicht scrollen.
                pane.setAttribute("tabindex", "0");
            }
        }
    });
    const syncTabState = (activeButton)=>{
        tab2024Buttons.forEach((button)=>{
            const isActive = button === activeButton;
            button.setAttribute("aria-selected", isActive ? "true" : "false");
            // Roving tabindex: der Reiterstreifen ist ein einziger Tabstopp,
            // gewechselt wird darin mit den Pfeiltasten.
            button.setAttribute("tabindex", isActive ? "0" : "-1");
        });
    };
    const activateTab = (button, shouldUpdateUrl = true)=>{
        if (!button) return;
        const target = button.getAttribute("data-tab2024");
        if (!target) return;
        tab2024Buttons.forEach((btn)=>btn.classList.remove("active2024"));
        button.classList.add("active2024");
        tab2024Panes.forEach((pane)=>pane.classList.remove("active2024"));
        const targetPane = document.getElementById(target);
        if (targetPane) {
            targetPane.classList.add("active2024");
            window.requestAnimationFrame(()=>{
                $616da9c9da875c98$var$refreshOpenAccordionHeights(targetPane);
            });
        }
        syncTabState(button);
        if (!shouldUpdateUrl) return;
        const tabKey = button.getAttribute("data-tab-key") || target;
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set(tabQueryParam, tabKey);
        window.history.replaceState({}, "", nextUrl.toString());
    };
    const focusTabAt = (index)=>{
        const wrapped = (index + tab2024Buttons.length) % tab2024Buttons.length;
        const nextButton = tab2024Buttons[wrapped];
        activateTab(nextButton, true);
        nextButton.focus();
    };
    tab2024Buttons.forEach((button, index)=>{
        button.addEventListener("click", ()=>{
            activateTab(button, true);
        });
        button.addEventListener("keydown", (event)=>{
            switch(event.key){
                case "ArrowRight":
                case "ArrowDown":
                    event.preventDefault();
                    focusTabAt(index + 1);
                    break;
                case "ArrowLeft":
                case "ArrowUp":
                    event.preventDefault();
                    focusTabAt(index - 1);
                    break;
                case "Home":
                    event.preventDefault();
                    focusTabAt(0);
                    break;
                case "End":
                    event.preventDefault();
                    focusTabAt(tab2024Buttons.length - 1);
                    break;
                default:
                    break;
            }
        });
    });
    const tabFromUrl = new URLSearchParams(window.location.search).get(tabQueryParam);
    const normalizedTabFromUrl = tabFromUrl ? tabFromUrl.toLowerCase() : null;
    const tabFromParam = normalizedTabFromUrl && tabButtonsByKey.get(normalizedTabFromUrl) || tabFromUrl && tabButtonsById.get(tabFromUrl);
    const defaultTab = tab2024Buttons.find((button)=>button.classList.contains("active2024")) || tab2024Buttons[0];
    activateTab(tabFromParam || defaultTab, false);
});
jQuery(document).ready(function() {
    // Hero 360° tour (relaunch 2026): data-attribute driven, replaces the old
    // click-shield + deferred-append loader below.
    document.querySelectorAll("[data-ws-hero-tour-root]").forEach((heroSection)=>$616da9c9da875c98$var$initHero360Tour(heroSection));
    // MAP CONTAINER IFRAME FRONTPAGE MAP BOTTOM
    jQuery(".map-container").click(function() {
        jQuery(this).find("iframe").addClass("clicked");
    }).mouseleave(function() {
        jQuery(this).find("iframe").removeClass("clicked");
    });
    // jQuery(".activate-desktop").on("mouseenter", function () {
    //   jQuery(".activate-desktop").hide();
    // });
    // jQuery(".custom-header").on("mouseout", function () {
    //   jQuery(".activate-desktop").show();
    // });
    //  Replace all SVG images with inline SVG
    // https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
    // -> img -> class="svg"
    jQuery("img.svg").each(function() {
        var $img = jQuery(this);
        var imgID = $img.attr("id");
        var imgClass = $img.attr("class");
        var imgURL = $img.attr("src");
        var imgAlt = $img.attr("alt");
        var imgRole = $img.attr("role");
        var imgAriaHidden = $img.attr("aria-hidden");
        jQuery.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find("svg");
            // Add replaced image's ID to the new SVG
            if (typeof imgID !== "undefined") $svg = $svg.attr("id", imgID);
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== "undefined") $svg = $svg.attr("class", imgClass + " replaced-svg");
            // Preserve accessibility: map <img alt> to role="img" + aria-label,
            // or mark decorative when alt="" / aria-hidden was set.
            if (imgAriaHidden === "true" || imgAlt === "") $svg.attr("aria-hidden", "true").attr("focusable", "false");
            else if (typeof imgAlt !== "undefined" && imgAlt !== "") $svg.attr("role", imgRole || "img").attr("aria-label", imgAlt);
            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr("xmlns:a");
            // Replace image with new SVG
            $img.replaceWith($svg);
        }, "xml");
    });
    // MAP OVERLAY
    jQuery(".fp-maptext").click(function() {
        jQuery(".fp-mapoverlay").fadeOut();
        jQuery(".fp-maptext").fadeOut();
        jQuery(".fp-mapiframe").show();
    }).mouseleave(function() {
        jQuery(".fp-mapoverlay").fadeIn();
        jQuery(".fp-maptext").fadeIn();
    });
// Print Function
// function printDiv(divName) {
// 	var printContents = document.getElementById(divName).innerHTML;
// 	var originalContents = document.body.innerHTML;
// 	document.body.innerHTML = printContents;
// 	window.print();
// 	document.body.innerHTML = originalContents;
// }
});
/*!
 * MoveTo - A lightweight scroll animation javascript library without any dependency.
 * Version 1.7.1 (22-10-2017 02:28)
 * Licensed under MIT
 * Copyright 2017 Hasan Aydoğdu <hsnaydd@gmail.com>
 */ "use strict";
var $616da9c9da875c98$var$MoveTo = function() {
    function t(t, e, n, o) {
        return t /= o, t--, -n * (t * t * t * t - 1) + e;
    }
    function e(t, e) {
        var n = {};
        return Object.keys(t).forEach(function(e) {
            n[e] = t[e];
        }), Object.keys(e).forEach(function(t) {
            n[t] = e[t];
        }), n;
    }
    function n(t) {
        return t.replace(/([A-Z])/g, function(t) {
            return "-" + t.toLowerCase();
        });
    }
    function o() {
        var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        this.options = e(r, n), this.easeFunctions = e({
            easeOutQuart: t
        }, o);
    }
    function i(t, e) {
        var o = {};
        return Object.keys(e).forEach(function(e) {
            var i = t.getAttribute("data-mt-" + n(e));
            i && (o[e] = isNaN(i) ? i : parseInt(i, 10));
        }), o;
    }
    var r = {
        tolerance: 0,
        duration: 800,
        easing: "easeOutQuart",
        callback: function() {}
    };
    return o.prototype.registerTrigger = function(t, n) {
        var o = this;
        if (t) {
            var r = t.getAttribute("href") || t.getAttribute("data-target"), a = r && "#" !== r ? document.getElementById(r.substring(1)) : document.body, u = e(this.options, i(t, this.options));
            "function" == typeof n && (u.callback = n);
            var c = function(t) {
                t.preventDefault(), o.move(a, u);
            };
            return t.addEventListener("click", c, !1), function() {
                return t.removeEventListener("click", c, !1);
            };
        }
    }, o.prototype.move = function(t) {
        var n = this, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (0 === t || t) {
            o = e(this.options, o);
            var i = "number" == typeof t ? t : t.getBoundingClientRect().top, r = window.pageYOffset, a = null, u = void 0;
            i -= o.tolerance;
            var c = function e(c) {
                var s = window.pageYOffset;
                a || (a = c - 1);
                var f = c - a;
                if (u && (i > 0 && u > s || i < 0 && u < s)) return o.callback(t);
                u = s;
                var d = n.easeFunctions[o.easing](f, r, i, o.duration);
                window.scroll(0, d), f < o.duration ? window.requestAnimationFrame(e) : (window.scroll(0, i + r), o.callback(t));
            };
            window.requestAnimationFrame(c);
        }
    }, o.prototype.addEaseFunction = function(t, e) {
        this.easeFunctions[t] = e;
    }, o;
}();
$616da9c9da875c98$exports = $616da9c9da875c98$var$MoveTo;
// FIX NAVIGATION
const $616da9c9da875c98$var$nav = document.querySelector(".main-navigation");
if ($616da9c9da875c98$var$nav) {
    let topOfNav = $616da9c9da875c98$var$nav.offsetTop;
    function fixNav() {
        if (window.scrollY >= topOfNav) // document.body.style.paddingTop = nav.offsetHeight + 'px';
        document.body.classList.add("fixed-nav");
        else document.body.classList.remove("fixed-nav");
    }
    window.addEventListener("scroll", fixNav);
}
// Slick equal height
let $616da9c9da875c98$var$stHeight = jQuery(".slick-track").height();
$616da9c9da875c98$var$stHeight = $616da9c9da875c98$var$stHeight - 40;
jQuery(".slick-slide-buerger").css("height", $616da9c9da875c98$var$stHeight + "px");
jQuery("#newsbutton").click(function() {
    jQuery("#allevents").fadeOut();
    jQuery("#allnews").fadeIn();
    jQuery("#eventbutton").removeClass("aktuellesactive");
    jQuery("#newsbutton").addClass("aktuellesactive");
});
jQuery("#eventbutton").click(function() {
    jQuery("#allnews").fadeOut();
    jQuery("#allevents").fadeIn();
    jQuery("#eventbutton").addClass("aktuellesactive");
    jQuery("#newsbutton").removeClass("aktuellesactive");
});
// Scroll-Up Function
jQuery(document).ready(function() {
    const scrollButton = jQuery("#scroll-up");
    // Initially hide the button
    scrollButton.hide();
    jQuery(window).scroll(function() {
        if (jQuery(this).scrollTop() > 1500) scrollButton.fadeIn().css("display", "flex"); // Use flex to ensure proper display
        else scrollButton.fadeOut();
    });
    // Add click handler
    scrollButton.on("click keyup", function(e) {
        // Handle both click and Enter key
        if (e.type === "click" || e.type === "keyup" && e.key === "Enter") {
            jQuery("html, body").animate({
                scrollTop: 0
            }, 800);
            return false;
        }
    });
});
// moveTo
document.addEventListener("DOMContentLoaded", function() {
    const easeFunctions = {
        easeInQuad: function(t, b, c, d) {
            t /= d;
            return c * t * t + b;
        },
        easeOutQuad: function(t, b, c, d) {
            t /= d;
            return -c * t * (t - 2) + b;
        }
    };
    const moveTo = new $616da9c9da875c98$var$MoveTo({
        ease: "easeInQuad"
    }, easeFunctions);
    const triggers = document.getElementsByClassName("js-trigger");
    for(var i = 0; i < triggers.length; i++)moveTo.registerTrigger(triggers[i]);
});
// ACCORDION
// Ein geschlossenes Panel war bis 31.07.2026 nur `max-height: 0; overflow:
// hidden` — für das Auge weg, für die Tastatur nicht: Tab lief durch alle Links
// darin und der Fokus stand auf etwas Unsichtbarem (WCAG 2.4.3/2.4.7). `inert`
// nimmt Panel-Inhalt aus Fokusreihenfolge und Accessibility-Tree; die CSS-Regel
// in _posts-and-pages.scss setzt zusätzlich `visibility: hidden`, damit auch
// ohne inert-Unterstützung nichts fokussierbar bleibt.
var $616da9c9da875c98$var$acc = document.getElementsByClassName("accordion");
var $616da9c9da875c98$var$accordionPanelIdCounter = 0;
var $616da9c9da875c98$var$i;
function $616da9c9da875c98$var$setAccordionExpanded(button, panel, expanded) {
    button.setAttribute("aria-expanded", expanded ? "true" : "false");
    if (!panel) return;
    if (expanded) {
        panel.removeAttribute("inert");
        panel.removeAttribute("aria-hidden");
    } else {
        panel.setAttribute("inert", "");
        panel.setAttribute("aria-hidden", "true");
    }
}
function $616da9c9da875c98$var$hydrateAccordionDeferredIframes(panel) {
    if (!panel) return;
    var iframes = panel.querySelectorAll("iframe[data-src]");
    for(var n = 0; n < iframes.length; n++){
        var iframe = iframes[n];
        var deferredSrc = iframe.getAttribute("data-src");
        if (!deferredSrc) continue;
        var currentSrc = iframe.getAttribute("src");
        if (currentSrc && currentSrc !== "about:blank") continue;
        iframe.setAttribute("src", deferredSrc);
    }
}
function $616da9c9da875c98$var$bindAccordionMediaLoad(panel) {
    if (!panel) return;
    var mediaElements = panel.querySelectorAll("img, iframe");
    for(var j = 0; j < mediaElements.length; j++){
        var mediaElement = mediaElements[j];
        if (mediaElement.tagName === "IMG" && mediaElement.complete) continue;
        mediaElement.addEventListener("load", function() {
            if (panel.style.maxHeight) $616da9c9da875c98$var$setAccordionPanelHeight(panel);
        }, {
            once: true
        });
    }
}
function $616da9c9da875c98$var$isAccordionPanelOpen(panel) {
    if (!panel || !panel.classList.contains("panel")) return false;
    var button = panel.previousElementSibling;
    return !!(button && button.classList.contains("accordion") && button.classList.contains("active"));
}
function $616da9c9da875c98$var$hydrateOpenAccordionPanel(panel) {
    if (!$616da9c9da875c98$var$isAccordionPanelOpen(panel)) return;
    $616da9c9da875c98$var$hydrateAccordionDeferredIframes(panel);
    $616da9c9da875c98$var$bindAccordionMediaLoad(panel);
    $616da9c9da875c98$var$setAccordionPanelHeight(panel);
}
function $616da9c9da875c98$var$accordionPanelFromNode(node) {
    if (!node || node.nodeType !== 1 || !node.closest) return null;
    return node.closest(".panel");
}
function $616da9c9da875c98$var$scheduleOpenAccordionHydration(node) {
    var panel = $616da9c9da875c98$var$accordionPanelFromNode(node);
    window.requestAnimationFrame(function() {
        if (panel) {
            $616da9c9da875c98$var$hydrateOpenAccordionPanel(panel);
            return;
        }
        var openAccordions = document.querySelectorAll(".accordion.active");
        for(var n = 0; n < openAccordions.length; n++)$616da9c9da875c98$var$hydrateOpenAccordionPanel(openAccordions[n].nextElementSibling);
    });
}
for($616da9c9da875c98$var$i = 0; $616da9c9da875c98$var$i < $616da9c9da875c98$var$acc.length; $616da9c9da875c98$var$i++)(function(button) {
    var panel = button.nextElementSibling;
    if (!panel || !panel.classList.contains("panel")) return;
    if (!panel.id) {
        $616da9c9da875c98$var$accordionPanelIdCounter += 1;
        panel.id = "ws-accordion-panel-" + $616da9c9da875c98$var$accordionPanelIdCounter;
    }
    button.setAttribute("aria-controls", panel.id);
    $616da9c9da875c98$var$setAccordionExpanded(button, panel, button.classList.contains("active"));
    button.addEventListener("click", function() {
        this.classList.toggle("active");
        var isOpen = this.classList.contains("active");
        $616da9c9da875c98$var$setAccordionExpanded(this, panel, isOpen);
        if (!isOpen) {
            panel.style.maxHeight = null;
            return;
        }
        $616da9c9da875c98$var$hydrateOpenAccordionPanel(panel);
    });
})($616da9c9da875c98$var$acc[$616da9c9da875c98$var$i]);
// Event maps keep Google off the wire via data-src until the accordion opens.
// Borlabs then replaces that iframe with a content blocker. Clicking "Karte
// laden" injects the original markup (still data-src, no src) after hydrate
// already ran — the map stayed blank. Re-hydrate when Borlabs unblocks or
// when an iframe appears inside an open panel.
document.addEventListener("borlabs-cookie-content-unblocked[google-maps]", function(event) {
    $616da9c9da875c98$var$scheduleOpenAccordionHydration(event.target);
});
document.addEventListener("borlabs-cookie-consent-saved", function() {
    window.requestAnimationFrame(function() {
        $616da9c9da875c98$var$refreshOpenAccordionHeights();
        var openAccordions = document.querySelectorAll(".accordion.active");
        for(var n = 0; n < openAccordions.length; n++)$616da9c9da875c98$var$hydrateOpenAccordionPanel(openAccordions[n].nextElementSibling);
    });
});
document.addEventListener("click", function(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest("[data-borlabs-cookie-unblock], [data-borlabs-cookie-accept-service]")) return;
    var panel = $616da9c9da875c98$var$accordionPanelFromNode(target);
    if (!panel) return;
    window.setTimeout(function() {
        $616da9c9da875c98$var$hydrateOpenAccordionPanel(panel);
    }, 50);
});
if (window.MutationObserver) {
    var $616da9c9da875c98$var$accordionIframeObserver = new MutationObserver(function(mutations) {
        for(var m = 0; m < mutations.length; m++){
            var added = mutations[m].addedNodes;
            for(var n = 0; n < added.length; n++){
                var node = added[n];
                if (node.nodeType !== 1) continue;
                var hasDeferredIframe = node.matches && node.matches("iframe[data-src]") || node.querySelector && node.querySelector("iframe[data-src]");
                if (!hasDeferredIframe) continue;
                $616da9c9da875c98$var$scheduleOpenAccordionHydration(node);
            }
        }
    });
    $616da9c9da875c98$var$accordionIframeObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
}
window.addEventListener("resize", function() {
    window.requestAnimationFrame(function() {
        $616da9c9da875c98$var$refreshOpenAccordionHeights();
    });
});
window.addEventListener("load", function() {
    $616da9c9da875c98$var$refreshOpenAccordionHeights();
});
// Tagestipp
jQuery.fn.extend({
    animateCss: function(animationName, callback) {
        var animationEnd = function(el) {
            var animations = {
                animation: "animationend",
                OAnimation: "oAnimationEnd",
                MozAnimation: "mozAnimationEnd",
                WebkitAnimation: "webkitAnimationEnd"
            };
            for(var t in animations){
                if (el.style[t] !== undefined) return animations[t];
            }
        }(document.createElement("div"));
        this.addClass("animated " + animationName).one(animationEnd, function() {
            jQuery(this).removeClass("animated " + animationName);
            if (typeof callback === "function") callback();
        });
        return this;
    }
});
jQuery(document).ready(function() {
    jQuery(".rotate").on("click", function() {
        // jQuery(".rotate svg").toggleClass("down");
        jQuery(".minimenu-dropout").toggleClass("minimenu-toggled");
    });
    // jQuery('#tagestipp').addClass('animated bounceIn');
    function openTagestipp($tagestipp) {
        if (!$tagestipp.length) return;
        $tagestipp.find(".bummelbounce").animateCss("tada");
        $tagestipp.css({
            top: "30%"
        });
        $tagestipp.find(".tagestipp-button").attr("aria-expanded", "true");
        $tagestipp.find(".tagestipp-button").closest(".wp-block-button").hide();
        $tagestipp.find(".tipp-wrapperbummel").removeClass("invis").addClass("animated fadeIn");
    }
    function closeTagestipp($tagestipp) {
        if (!$tagestipp.length) return;
        $tagestipp.find(".bummelbounce").animateCss("tada");
        $tagestipp.css({
            top: "45%"
        });
        $tagestipp.find(".tipp-wrapperbummel").addClass("invis").removeClass("animated fadeIn");
        $tagestipp.find(".tagestipp-button").attr("aria-expanded", "false");
        $tagestipp.find(".tagestipp-button").closest(".wp-block-button").fadeIn();
    }
    function isTagestippOpen($tagestipp) {
        return !$tagestipp.find(".tipp-wrapperbummel").hasClass("invis");
    }
    // Ein Klick irgendwo im Trigger (Bummelkopf, Button und die Polsterung
    // ringsum) schaltet den Tipp um. Vorher traf man nur die Pille exakt und
    // knapp daneben öffnete sich die 360°-Tour aus dem Layer darunter.
    jQuery(document).on("click", "[data-ws-tagestipp-trigger]", function(event) {
        if (jQuery(event.target).closest(".tipp-closebummel").length) return;
        event.preventDefault();
        var $tagestipp = jQuery(this).closest("#tagestipp");
        if (isTagestippOpen($tagestipp)) {
            closeTagestipp($tagestipp);
            return;
        }
        openTagestipp($tagestipp);
    });
    // Tastatur: Enter/Space auf den Schließen-Kreisen (role="button").
    jQuery(document).on("keydown", '#tagestipp .round-button[role="button"]', function(event) {
        if (event.key !== "Enter" && event.key !== " " && event.key !== "Spacebar") return;
        event.preventDefault();
        jQuery(this).trigger("click");
    });
    jQuery(".closebummel").click(function(event) {
        event.preventDefault();
        closeTagestipp(jQuery(this).closest("#tagestipp"));
    });
    jQuery(".tipp-closebummel").click(function(event) {
        event.preventDefault();
        var $tagestipp = jQuery(this).closest("#tagestipp");
        $tagestipp.animateCss("bounceOut", function() {
            $tagestipp.addClass("invis").css({
                top: ""
            });
            $tagestipp.find(".tipp-wrapperbummel").addClass("invis").removeClass("animated fadeIn");
            $tagestipp.find(".tagestipp-button").attr("aria-expanded", "false");
            $tagestipp.find(".tagestipp-button").closest(".wp-block-button").show();
        });
    });
    jQuery("#button1").css("cursor", "pointer");
    jQuery(document).on("click", "#button1", function(event) {
        event.preventDefault();
        jQuery(".imfokuswrapper").addClass("animated bounceOut");
    });
// IM FOKUS CLOSE
});
jQuery(document).ready(function() {
    setTimeout(function() {
        jQuery("#tagestipp").removeClass("invis");
        jQuery("#tagestipp").animateCss("bounceIn");
    }, 2500);
    setTimeout(function() {
        jQuery(".bummelbounce").animateCss("tada");
    }, 4000);
});
// SUCHE MODAL
(function() {
    var modal = document.getElementById("suchModal");
    var openBtn = document.getElementById("suchButton");
    var closeBtn = document.getElementById("suchClose");
    var backdrop = document.getElementById("suchBackdrop");
    if (!modal) return;
    // Fokusfalle: aria-modal="true" verspricht, dass der Fokus im Dialog bleibt.
    // Ohne Falle lief Tab hinter das Overlay in die weiterhin sichtbare Seite —
    // Fokus auf Elementen, die niemand sieht (WCAG 2.4.3).
    var FOCUSABLE_IN_MODAL = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])';
    function modalFocusables() {
        return Array.prototype.filter.call(modal.querySelectorAll(FOCUSABLE_IN_MODAL), function(el) {
            return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
        });
    }
    function trapFocus(event) {
        if (event.key !== "Tab" || !modal.classList.contains("is-open")) return;
        var items = modalFocusables();
        if (items.length === 0) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        } else if (!modal.contains(document.activeElement)) {
            event.preventDefault();
            first.focus();
        }
    }
    function openSearch() {
        // On mobile the search button lives inside the open menu sheet — close
        // the sheet so the two overlays don't stack.
        var openHeader = document.querySelector(".ws-site-header.is-open");
        if (openHeader) {
            openHeader.classList.remove("is-open");
            var headerToggle = openHeader.querySelector(".ws-site-header__toggle");
            if (headerToggle) headerToggle.setAttribute("aria-expanded", "false");
        }
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
        modal.removeAttribute("inert");
        if (openBtn) openBtn.setAttribute("aria-expanded", "true");
        document.body.style.overflow = "hidden";
        var field = modal.querySelector(".search-field");
        if (field) // Delay focus until bar has slid into view
        setTimeout(function() {
            field.focus();
        }, 120);
    }
    function closeSearch() {
        // inert erst setzen, nachdem der Fokus den Dialog verlassen hat — sonst
        // verliert der Browser den Fokus ans <body> und die Tastaturposition ist weg.
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
        if (openBtn) {
            openBtn.setAttribute("aria-expanded", "false");
            openBtn.focus();
        }
        modal.setAttribute("inert", "");
    }
    if (openBtn) openBtn.addEventListener("click", openSearch);
    // Additional openers, e.g. the search tile in the mobile menu's quick grid.
    document.querySelectorAll("[data-ws-open-search]").forEach(function(el) {
        el.addEventListener("click", openSearch);
    });
    if (closeBtn) closeBtn.addEventListener("click", closeSearch);
    if (backdrop) backdrop.addEventListener("click", closeSearch);
    document.addEventListener("keydown", function(e) {
        if (e.key === "Escape" && modal.classList.contains("is-open")) {
            closeSearch();
            return;
        }
        trapFocus(e);
    });
})();
// HINTERGRUNDVIDEO PAUSIEREN (WCAG 2.2.2)
//
// Das Kultur-Modul der Startseite startet ein stummes YouTube-Video automatisch
// und in Endlosschleife. Bewegung, die länger als fünf Sekunden ohne Zutun
// läuft, braucht eine Möglichkeit zum Anhalten. Gesteuert wird über die
// postMessage-Schnittstelle des Players (`enablejsapi=1` in der iframe-URL) —
// bewusst ohne die YouTube-IFrame-API, die ein weiteres Drittanbieter-Skript
// nachladen würde.
//
// Zwei Eigenheiten der Einbindung:
//   • Vor der Cookie-Einwilligung ersetzt Borlabs das iframe durch einen
//     Content-Blocker. Der Button bleibt deshalb versteckt, bis wirklich ein
//     iframe im Container liegt — beobachtet per MutationObserver.
//   • Der Player meldet seinen Zustand zurück, sobald man sich mit
//     `{event: "listening"}` anmeldet. Damit folgt die Beschriftung dem
//     tatsächlichen Zustand und nicht nur unserer Absicht.
(function() {
    var YT_ORIGIN = "https://www.youtube-nocookie.com";
    function initBackgroundVideo(container) {
        var toggle = container.querySelector("[data-ws-bg-video-toggle]");
        if (!toggle) return;
        var frame = null;
        var isPlaying = true;
        // Der Player meldet seinen Zustand im Sekundentakt und mit Verzögerung.
        // Direkt nach einem Klick sind noch Meldungen des alten Zustands unterwegs —
        // ohne diese Sperrfrist drehen sie die Beschriftung wieder zurück und der
        // nächste Klick tut dann das Gegenteil von dem, was der Button ansagt.
        var ignoreStateUntil = 0;
        // targetOrigin "*" statt YT_ORIGIN: solange das iframe noch auf about:blank
        // steht (vor dem ersten load), passt seine Herkunft nicht zu YouTube und der
        // Browser verwirft die Nachricht mit einer Konsolenwarnung. Der Befehl selbst
        // enthält nichts Schützenswertes; entscheidend ist die Herkunftsprüfung in
        // der Gegenrichtung weiter unten, und die bleibt streng.
        function postToPlayer(payload) {
            if (!frame || !frame.contentWindow) return;
            try {
                frame.contentWindow.postMessage(JSON.stringify(payload), "*");
            } catch (error) {
            // Ein Player, der den Befehl nicht annimmt, darf die Seite nicht killen.
            }
        }
        function command(func) {
            postToPlayer({
                event: "command",
                func: func,
                args: []
            });
        }
        function syncLabel() {
            var label = isPlaying ? toggle.getAttribute("data-label-pause") : toggle.getAttribute("data-label-play");
            toggle.setAttribute("aria-label", label || "");
            toggle.classList.toggle("is-paused", !isPlaying);
        }
        function subscribe() {
            postToPlayer({
                event: "listening",
                id: "ws-bg-video"
            });
        }
        function attachFrame(candidate) {
            if (!candidate || frame === candidate) return;
            frame = candidate;
            toggle.hidden = false;
            candidate.addEventListener("load", function() {
                subscribe();
                // Wer reduzierte Bewegung eingestellt hat, bekommt das Video gar nicht
                // erst laufend zu sehen — anhalten statt abspielen lassen.
                if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
                    isPlaying = false;
                    command("pauseVideo");
                    syncLabel();
                }
            });
            subscribe();
            syncLabel();
        }
        toggle.addEventListener("click", function() {
            isPlaying = !isPlaying;
            ignoreStateUntil = Date.now() + 2000;
            command(isPlaying ? "playVideo" : "pauseVideo");
            syncLabel();
        });
        window.addEventListener("message", function(event) {
            if (event.origin !== YT_ORIGIN || !frame) return;
            if (Date.now() < ignoreStateUntil) return;
            var payload;
            try {
                payload = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
            } catch (error) {
                return;
            }
            var state = payload && payload.info && payload.info.playerState;
            // 1 = playing, 2 = paused, 3 = buffering (zählt als laufend).
            if (state === 1 || state === 3) {
                isPlaying = true;
                syncLabel();
            } else if (state === 2) {
                isPlaying = false;
                syncLabel();
            }
        });
        attachFrame(container.querySelector("[data-ws-bg-video-frame], iframe"));
        if (frame || typeof MutationObserver !== "function") return;
        // Borlabs hängt das iframe erst nach der Einwilligung ein.
        var observer = new MutationObserver(function() {
            var injected = container.querySelector("[data-ws-bg-video-frame], iframe");
            if (injected) {
                attachFrame(injected);
                observer.disconnect();
            }
        });
        observer.observe(container, {
            childList: true,
            subtree: true
        });
    }
    document.querySelectorAll("[data-ws-bg-video]").forEach(function(container) {
        initBackgroundVideo(container);
    });
})();


const $eaa9cbedfac6f5a5$var$HEART_LAYER_CLASS = "valentines-hearts-layer";
function $eaa9cbedfac6f5a5$var$getHeartLayer() {
    let layer = document.querySelector(`.${$eaa9cbedfac6f5a5$var$HEART_LAYER_CLASS}`);
    if (layer) return layer;
    layer = document.createElement("div");
    layer.classList.add($eaa9cbedfac6f5a5$var$HEART_LAYER_CLASS);
    document.body.appendChild(layer);
    return layer;
}
function $eaa9cbedfac6f5a5$var$createHeart(layer) {
    const heart = document.createElement("div");
    const drift = Math.random() * 24 - 12;
    heart.classList.add("valentines-heart");
    heart.style.left = `${Math.random() * 100}vw`;
    heart.style.animationDuration = `${Math.random() * 2 + 3}s`;
    heart.style.setProperty("--heart-drift", `${drift}vw`);
    heart.textContent = "\uD83D\uDC97";
    layer.appendChild(heart);
    heart.addEventListener("animationend", ()=>{
        heart.remove();
    }, {
        once: true
    });
}
const $eaa9cbedfac6f5a5$var$today = new Date();
const $eaa9cbedfac6f5a5$var$isValentinesDay = $eaa9cbedfac6f5a5$var$today.getMonth() === 1 && $eaa9cbedfac6f5a5$var$today.getDate() === 14;
const $eaa9cbedfac6f5a5$var$reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const $eaa9cbedfac6f5a5$var$isFrontPage = document.body.classList.contains("weissenstadt-front-page") || document.body.classList.contains("home") || document.body.classList.contains("front-page");
if ($eaa9cbedfac6f5a5$var$isFrontPage && $eaa9cbedfac6f5a5$var$isValentinesDay && !$eaa9cbedfac6f5a5$var$reduceMotion) {
    const layer = $eaa9cbedfac6f5a5$var$getHeartLayer();
    setInterval(()=>$eaa9cbedfac6f5a5$var$createHeart(layer), 320);
}


const $cc16b7f91f03dc4f$var$focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
].join(',');
const $cc16b7f91f03dc4f$var$isVisible = (element)=>{
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
};
const $cc16b7f91f03dc4f$var$isShownByOwnStyles = (element)=>{
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
};
document.addEventListener('DOMContentLoaded', ()=>{
    const dialog = document.getElementById('prospekt-order-dialog');
    const openButtons = document.querySelectorAll('[data-prospekt-modal-open]');
    const orderableCards = document.querySelectorAll('[data-prospekt-card-open]');
    if (!dialog || openButtons.length === 0) return;
    const closeButtons = dialog.querySelectorAll('[data-prospekt-modal-close]');
    const context = dialog.querySelector('#prospekt-order-context');
    const loadingIndicator = dialog.querySelector('[data-prospekt-modal-loading]');
    const formRegion = dialog.querySelector('[data-prospekt-modal-form]');
    const preloadRegion = document.querySelector('[data-prospekt-modal-preload]');
    const gravityFormSelector = [
        '.gform_wrapper form',
        'form[id^="gform_"]',
        '.gform_confirmation_wrapper'
    ].join(',');
    const gravityContainerSelector = '.gform_wrapper, .gform_confirmation_wrapper';
    const gravityLoadingSelector = [
        '.gform_ajax_spinner',
        '.gform-loader',
        '.gform-loader--theme',
        '.gform_spinner'
    ].join(',');
    let opener = null;
    let formObserver = null;
    let isClosing = false;
    const getFocusableElements = ()=>Array.from(dialog.querySelectorAll($cc16b7f91f03dc4f$var$focusableSelector)).filter($cc16b7f91f03dc4f$var$isVisible);
    const focusDialogTitle = ()=>{
        const title = dialog.querySelector('#prospekt-order-title');
        const fallback = dialog.querySelector('[data-prospekt-modal-close]');
        (title || fallback || dialog).focus({
            preventScroll: true
        });
    };
    const setContext = (button)=>{
        if (!context) return;
        const title = button.getAttribute('data-prospekt-title');
        context.textContent = title ? `Bestellformular ge\xf6ffnet f\xfcr: ${title}.` : '';
    };
    const getActiveFormRegion = ()=>{
        if (formRegion?.querySelector(gravityFormSelector)) return formRegion;
        if (preloadRegion?.querySelector(gravityFormSelector)) return preloadRegion;
        return formRegion;
    };
    const hasVisibleGravityLoader = ()=>{
        const activeFormRegion = getActiveFormRegion();
        if (!activeFormRegion) return false;
        return Array.from(activeFormRegion.querySelectorAll(gravityLoadingSelector)).some($cc16b7f91f03dc4f$var$isVisible);
    };
    const mountPreloadedForm = ()=>{
        if (!formRegion || !preloadRegion || formRegion.querySelector(gravityFormSelector)) return;
        while(preloadRegion.firstChild)formRegion.appendChild(preloadRegion.firstChild);
        preloadRegion.setAttribute('hidden', '');
    };
    const isFormReady = ()=>{
        const activeFormRegion = getActiveFormRegion();
        if (!activeFormRegion) return true;
        const hasForm = !!activeFormRegion.querySelector(gravityFormSelector);
        const hasFormContent = !!activeFormRegion.querySelector('input:not([type="hidden"]), select, textarea, button[type="submit"], .gfield, .gform_confirmation_wrapper');
        const visibleFormContainer = Array.from(activeFormRegion.querySelectorAll(gravityContainerSelector)).some($cc16b7f91f03dc4f$var$isShownByOwnStyles);
        return hasForm && hasFormContent && visibleFormContainer && !hasVisibleGravityLoader();
    };
    const setFormLoading = (isLoading)=>{
        if (loadingIndicator) loadingIndicator.hidden = !isLoading;
        if (formRegion) {
            formRegion.classList.toggle('is-loading', isLoading);
            formRegion.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        }
    };
    const updateFormLoading = ()=>{
        const isLoading = !isFormReady();
        setFormLoading(isLoading);
        return !isLoading;
    };
    const observeFormLoading = ()=>{
        if (!formRegion || formObserver) return;
        formObserver = new MutationObserver(updateFormLoading);
        formObserver.observe(formRegion, {
            attributes: true,
            attributeFilter: [
                'class',
                'style',
                'aria-hidden',
                'hidden'
            ],
            childList: true,
            subtree: true
        });
    };
    const refreshFormLoading = ()=>{
        mountPreloadedForm();
        const isReady = updateFormLoading();
        if (!isReady) {
            observeFormLoading();
            window.setTimeout(updateFormLoading, 120);
            window.setTimeout(updateFormLoading, 600);
            window.setTimeout(updateFormLoading, 1600);
        }
    };
    const openDialog = (button)=>{
        if (dialog.open || isClosing) return;
        opener = button;
        setContext(button);
        dialog.classList.remove('is-closing');
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else {
            dialog.setAttribute('open', '');
            dialog.setAttribute('aria-modal', 'true');
        }
        document.documentElement.classList.add('has-prospekt-modal');
        refreshFormLoading();
        window.requestAnimationFrame(focusDialogTitle);
    };
    const closeDialog = ()=>{
        if (!dialog.open || isClosing) return;
        const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        const canAnimateClose = typeof dialog.close === 'function' && !reduceMotion;
        let closeFinished = false;
        let closeTimer = null;
        const finishClose = ()=>{
            if (closeFinished) return;
            closeFinished = true;
            if (closeTimer) window.clearTimeout(closeTimer);
            if (typeof dialog.close === 'function') dialog.close();
            else {
                dialog.removeAttribute('open');
                dialog.removeAttribute('aria-modal');
            }
            dialog.classList.remove('is-closing');
            document.documentElement.classList.remove('has-prospekt-modal');
            setFormLoading(false);
            isClosing = false;
            if (opener && typeof opener.focus === 'function' && document.contains(opener)) opener.focus({
                preventScroll: true
            });
        };
        if (!canAnimateClose) {
            finishClose();
            return;
        }
        isClosing = true;
        dialog.classList.add('is-closing');
        const handleAnimationEnd = (event)=>{
            if (event.target === dialog) {
                dialog.removeEventListener('animationend', handleAnimationEnd);
                finishClose();
            }
        };
        dialog.addEventListener('animationend', handleAnimationEnd);
        closeTimer = window.setTimeout(()=>{
            dialog.removeEventListener('animationend', handleAnimationEnd);
            finishClose();
        }, 240);
    };
    openButtons.forEach((button)=>{
        button.addEventListener('click', (event)=>{
            event.preventDefault();
            openDialog(button);
        });
    });
    orderableCards.forEach((card)=>{
        const cardButton = card.querySelector('[data-prospekt-modal-open]');
        if (!cardButton) return;
        card.addEventListener('click', (event)=>{
            const target = event.target instanceof Element ? event.target : event.target.parentElement;
            const interactiveTarget = target?.closest('a, button, input, select, textarea, label, summary, [role="button"], [role="link"]');
            if (interactiveTarget || event.defaultPrevented) return;
            openDialog(cardButton);
        });
    });
    closeButtons.forEach((button)=>{
        button.addEventListener('click', closeDialog);
    });
    dialog.addEventListener('cancel', (event)=>{
        event.preventDefault();
        closeDialog();
    });
    dialog.addEventListener('click', (event)=>{
        if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('keydown', (event)=>{
        if (event.key === 'Escape') {
            event.preventDefault();
            closeDialog();
            return;
        }
        if (event.key !== 'Tab') return;
        const focusableElements = getFocusableElements();
        if (focusableElements.length === 0) {
            event.preventDefault();
            dialog.focus({
                preventScroll: true
            });
            return;
        }
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus({
                preventScroll: true
            });
        } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus({
                preventScroll: true
            });
        }
    });
    document.addEventListener('gform/postRender', updateFormLoading);
    document.addEventListener('gform/ajax/post_ajax_submission', updateFormLoading);
    window.addEventListener('load', updateFormLoading);
    if (window.jQuery) window.jQuery(document).on('gform_post_render gform_confirmation_loaded', updateFormLoading);
    setFormLoading(false);
});


document.addEventListener("DOMContentLoaded", ()=>{
    const tablists = document.querySelectorAll(".tabs[data-tabgroup]");
    /**
   * Allow only simple slug keys for URL deep-links.
   * Mirrors PHP sanitize_key-ish constraints; never pass raw input elsewhere.
   */ function normalizeTabKey(value) {
        if (typeof value !== "string") return "";
        return value.trim().toLowerCase().replace(/[^a-z0-9_-]/g, "").slice(0, 64);
    }
    /**
   * URL param name from data-url-param; only [a-z0-9_-], max 32 chars.
   */ function normalizeParamName(value) {
        if (typeof value !== "string") return "";
        return value.trim().toLowerCase().replace(/[^a-z0-9_-]/g, "").slice(0, 32);
    }
    tablists.forEach((tablist)=>{
        const groupId = tablist.getAttribute("data-tabgroup");
        const tabs = Array.from(tablist.querySelectorAll("[data-tab-target]"));
        if (!groupId || tabs.length === 0) return;
        const panelContainer = document.getElementById(groupId);
        const panels = panelContainer ? Array.from(panelContainer.querySelectorAll("[role='tabpanel'], .tabwrapper")) : [];
        const urlParam = normalizeParamName(tablist.getAttribute("data-url-param"));
        const tabsByKey = new Map();
        // Ensure semantics even if markup is incomplete.
        tablist.setAttribute("role", "tablist");
        tabs.forEach((tab, index)=>{
            const targetId = tab.getAttribute("data-tab-target");
            if (!tab.id) tab.id = `${groupId}-tab-${index + 1}`;
            tab.setAttribute("role", "tab");
            tab.setAttribute("aria-selected", tab.classList.contains("tabs-active") ? "true" : "false");
            tab.setAttribute("aria-controls", targetId);
            const key = normalizeTabKey(tab.getAttribute("data-tab-key") || targetId || "");
            if (key) tabsByKey.set(key, tab);
            const panel = panels.find((p)=>p.id === targetId);
            if (panel) {
                panel.setAttribute("role", "tabpanel");
                panel.setAttribute("aria-labelledby", tab.id);
                if (!tab.classList.contains("tabs-active")) panel.setAttribute("hidden", "");
                else panel.removeAttribute("hidden");
            }
        });
        function updateUrlForTab(tab) {
            if (!urlParam || !window.history || !window.history.replaceState) return;
            const key = normalizeTabKey(tab.getAttribute("data-tab-key") || tab.getAttribute("data-tab-target") || "");
            if (!key || !tabsByKey.has(key)) return;
            try {
                const nextUrl = new URL(window.location.href);
                nextUrl.searchParams.set(urlParam, key);
                window.history.replaceState({}, "", nextUrl.toString());
            } catch (error) {
            // Ignore malformed location; never throw from tab UI.
            }
        }
        function activateTab(tab, { focus: focus = true, updateUrl: updateUrl = true } = {}) {
            if (!tab) return;
            const targetId = tab.getAttribute("data-tab-target");
            if (!targetId) return;
            tabs.forEach((t)=>{
                const isActive = t === tab;
                t.classList.toggle("tabs-active", isActive);
                t.setAttribute("aria-selected", isActive ? "true" : "false");
            });
            panels.forEach((panel)=>{
                if (panel.id === targetId) panel.removeAttribute("hidden");
                else panel.setAttribute("hidden", "");
            });
            if (updateUrl) updateUrlForTab(tab);
            if (focus) tab.focus();
        }
        function focusAdjacentTab(current, direction) {
            const index = tabs.indexOf(current);
            if (index === -1) return;
            let nextIndex = index + direction;
            if (nextIndex < 0) nextIndex = tabs.length - 1;
            else if (nextIndex >= tabs.length) nextIndex = 0;
            const nextTab = tabs[nextIndex];
            nextTab.focus();
        }
        tabs.forEach((tab)=>{
            tab.addEventListener("click", (event)=>{
                event.preventDefault();
                activateTab(tab, {
                    focus: false,
                    updateUrl: true
                });
            });
            tab.addEventListener("keydown", (event)=>{
                switch(event.key){
                    case "ArrowRight":
                    case "ArrowDown":
                        event.preventDefault();
                        focusAdjacentTab(tab, 1);
                        break;
                    case "ArrowLeft":
                    case "ArrowUp":
                        event.preventDefault();
                        focusAdjacentTab(tab, -1);
                        break;
                    case "Home":
                        event.preventDefault();
                        tabs[0].focus();
                        break;
                    case "End":
                        event.preventDefault();
                        tabs[tabs.length - 1].focus();
                        break;
                    case " ":
                    case "Enter":
                        event.preventDefault();
                        activateTab(tab, {
                            focus: false,
                            updateUrl: true
                        });
                        break;
                    default:
                        break;
                }
            });
        });
        // Deep-link: only accept keys that exist on this tablist (allowlist).
        let tabFromUrl = null;
        if (urlParam) try {
            const raw = new URLSearchParams(window.location.search).get(urlParam);
            const key = normalizeTabKey(raw || "");
            if (key) tabFromUrl = tabsByKey.get(key) || null;
        } catch (error) {
            tabFromUrl = null;
        }
        const activeTab = tabFromUrl || tabs.find((tab)=>tab.classList.contains("tabs-active")) || tabs[0];
        // Do not rewrite the URL on initial paint when PHP already set the right tab
        // (or when there is no url-param binding).
        activateTab(activeTab, {
            focus: false,
            updateUrl: false
        });
        // Optional: scroll to the section when a deep-link param was present.
        if (tabFromUrl && urlParam) {
            const section = tablist.closest("section[id]");
            if (section && typeof section.scrollIntoView === "function") window.requestAnimationFrame(()=>{
                section.scrollIntoView({
                    block: "start",
                    behavior: "smooth"
                });
            });
        }
    });
});


function $b2020c1da9e9c614$var$enhanceOpenStreetMapEmbeds() {
    const maps = Array.from(document.querySelectorAll(".acfstreetmap iframe"));
    maps.forEach((iframe, index)=>{
        if (iframe.dataset.osmEnhanced === "true") return;
        iframe.dataset.osmEnhanced = "true";
        iframe.setAttribute("loading", iframe.getAttribute("loading") || "lazy");
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("referrerpolicy", iframe.getAttribute("referrerpolicy") || "no-referrer-when-downgrade");
        if (!iframe.getAttribute("title")) iframe.setAttribute("title", "OpenStreetMap Lagekarte");
        const wrapper = document.createElement("div");
        wrapper.className = "osm-embed";
        iframe.parentNode.insertBefore(wrapper, iframe);
        wrapper.appendChild(iframe);
        const interactionButton = document.createElement("button");
        interactionButton.className = "osm-embed__interaction";
        interactionButton.type = "button";
        interactionButton.textContent = "Karte aktivieren";
        interactionButton.setAttribute("aria-describedby", `osm-embed-hint-${index}`);
        const hint = document.createElement("span");
        hint.className = "osm-embed__hint";
        hint.id = `osm-embed-hint-${index}`;
        hint.textContent = "Danach kann die Karte verschoben und gezoomt werden.";
        interactionButton.appendChild(hint);
        const fullscreenButton = document.createElement("button");
        fullscreenButton.className = "osm-embed__fullscreen";
        fullscreenButton.type = "button";
        fullscreenButton.title = "Vollbildmodus starten";
        fullscreenButton.setAttribute("aria-label", "Vollbildmodus starten");
        fullscreenButton.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="M5 10V5h5v2H8.41l3.3 3.29-1.42 1.42L7 8.41V10H5Zm9-5h5v5h-2V8.41l-3.29 3.3-1.42-1.42L15.59 7H14V5ZM7 15.59l3.29-3.3 1.42 1.42L8.41 17H10v2H5v-5h2v1.59ZM17 15.59V14h2v5h-5v-2h1.59l-3.3-3.29 1.42-1.42 3.29 3.3Z"/></svg>';
        wrapper.appendChild(interactionButton);
        wrapper.appendChild(fullscreenButton);
        const setActive = (active)=>{
            wrapper.classList.toggle("is-active", active);
            iframe.style.pointerEvents = active ? "auto" : "none";
            interactionButton.hidden = active;
        };
        setActive(false);
        interactionButton.addEventListener("click", ()=>{
            setActive(true);
            iframe.focus();
        });
        wrapper.addEventListener("mouseleave", ()=>{
            setActive(false);
        });
        wrapper.addEventListener("keydown", (event)=>{
            if (event.key === "Escape") {
                setActive(false);
                interactionButton.focus();
            }
        });
        fullscreenButton.addEventListener("click", async ()=>{
            if (document.fullscreenElement === wrapper) {
                await document.exitFullscreen();
                return;
            }
            if (wrapper.requestFullscreen) await wrapper.requestFullscreen();
        });
        document.addEventListener("fullscreenchange", ()=>{
            const isFullscreen = document.fullscreenElement === wrapper;
            fullscreenButton.title = isFullscreen ? "Vollbildmodus beenden" : "Vollbildmodus starten";
            fullscreenButton.setAttribute("aria-label", isFullscreen ? "Vollbildmodus beenden" : "Vollbildmodus starten");
        });
    });
}
function $b2020c1da9e9c614$var$observeOpenStreetMapEmbeds() {
    $b2020c1da9e9c614$var$enhanceOpenStreetMapEmbeds();
    if (!document.body || typeof MutationObserver === "undefined") return;
    const observer = new MutationObserver(()=>{
        $b2020c1da9e9c614$var$enhanceOpenStreetMapEmbeds();
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
document.addEventListener("DOMContentLoaded", $b2020c1da9e9c614$var$observeOpenStreetMapEmbeds);



var $bErSZ = parcelRequire("bErSZ");

var $bErSZ = parcelRequire("bErSZ");
document.addEventListener("DOMContentLoaded", ()=>{
    const grid = document.querySelector("[data-restaurants-grid]");
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll("[data-restaurant-card]"));
    const filters = {
        type: document.querySelector('[data-restaurants-filter="type"]'),
        subtype: document.querySelector('[data-restaurants-filter="subtype"]'),
        rating: document.querySelector('[data-restaurants-filter="rating"]'),
        cuisine: document.querySelector('[data-restaurants-filter="cuisine"]'),
        service: document.querySelector('[data-restaurants-filter="service"]'),
        open: document.querySelector('[data-restaurants-filter="open"]')
    };
    // Category pages keep their own URL and pre-set the filters that match it.
    // Those values are the page's baseline: they stay out of the query string and
    // "Filter zurücksetzen" returns to them instead of to the unfiltered list.
    const presetState = {
        type: filters.type?.dataset.restaurantsPreset || "",
        subtype: filters.subtype?.dataset.restaurantsPreset || "",
        rating: filters.rating?.dataset.restaurantsPreset || "",
        cuisine: filters.cuisine?.dataset.restaurantsPreset || "",
        service: filters.service?.dataset.restaurantsPreset || "",
        open: filters.open?.dataset.restaurantsPreset === "1"
    };
    const subtypeField = document.querySelector("[data-restaurants-subtype-field]");
    const ratingField = document.querySelector("[data-restaurants-rating-field]");
    const ratingParentValue = ratingField?.dataset.restaurantsRatingParent || "unterkunft";
    const subtypePlaceholder = filters.subtype ? filters.subtype.querySelector('option[value=""]')?.textContent || "Kategorie ausw\xe4hlen" : "";
    const subtypeOptions = filters.subtype ? Array.from(filters.subtype.options).filter((option)=>option.value).map((option)=>({
            parent: option.dataset.parent || "",
            text: option.textContent || "",
            value: option.value
        })) : [];
    const resetButton = document.querySelector("[data-restaurants-reset]");
    const emptyResetButton = document.querySelector("[data-restaurants-empty-reset]");
    const openToggleLabel = document.querySelector("[data-restaurants-open-label]");
    const countTarget = document.querySelector("[data-restaurants-count]");
    const countLabelTarget = document.querySelector("[data-restaurants-count-label]");
    const emptyState = document.querySelector("[data-restaurants-empty]");
    const reducedMotionQuery = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
    const cardCleanups = new WeakMap();
    let gridCleanup = null;
    const filterAnimationDuration = 220;
    const flipMoveDuration = 300;
    const countedFilterKeys = [
        "type",
        "subtype",
        "rating",
        "cuisine",
        "service"
    ];
    const openStateRefreshInterval = 60000;
    const urlParamMap = {
        type: "typ",
        subtype: "art",
        rating: "bewertung",
        cuisine: "kueche",
        service: "service",
        open: "offen"
    };
    const cardPeriods = new Map();
    const cardSpecial = new Map();
    cards.forEach((card)=>{
        // Prefer data-periods on the card; keep a parsed cache for filter refresh.
        const periods = (0, $bErSZ.parsePeriodsAttribute)(card.getAttribute("data-periods"));
        const special = (0, $bErSZ.parseSpecialAttribute)(card.getAttribute("data-special"));
        cardPeriods.set(card, periods);
        cardSpecial.set(card, special);
        // Mark for the shared Berlin-time refresher (footer/singles/cards).
        if ((periods.length || special.length) && !card.hasAttribute("data-opening-status")) {
            card.setAttribute("data-opening-status", "1");
            card.setAttribute("data-opening-compact", "1");
        }
    });
    // Recompute open/closed from Europe/Berlin so page cache + tourist TZs stay correct.
    const refreshOpenStates = ()=>{
        let changed = false;
        cards.forEach((card)=>{
            const periods = cardPeriods.get(card) || [];
            const special = cardSpecial.get(card) || [];
            if (!periods.length && !special.length) return;
            const opening = (0, $bErSZ.computeOpeningStatus)(periods, {
                compact: true,
                special: special
            });
            const openValue = opening.open ? "1" : "0";
            const prevOpen = card.dataset.open;
            card.dataset.open = openValue;
            card.setAttribute("data-opening-state", opening.state);
            const badge = card.querySelector(".restaurants-card__opening");
            if (badge) (0, $bErSZ.updateOpeningBadge)(badge, opening);
            if (prevOpen !== openValue) changed = true;
        });
        // Keep any other [data-opening-status] nodes (footer, singles) in sync too.
        (0, $bErSZ.refreshAllOpeningStatuses)();
        return changed;
    };
    const includesToken = (value, token)=>{
        if (!token) return true;
        return (value || "").split(/\s+/).includes(token);
    };
    const getOptionBaseLabel = (option)=>{
        if (option.dataset.filterLabel) return option.dataset.filterLabel;
        const label = (option.textContent || "").replace(/\s+\(\d+\)\s*$/, "");
        option.dataset.filterLabel = label;
        return label;
    };
    const syncSubtypeOptions = ()=>{
        if (!filters.subtype) return;
        const parentValue = filters.type ? filters.type.value : "";
        const selectedValue = filters.subtype.value;
        const matchingOptions = subtypeOptions.filter((option)=>option.parent === parentValue);
        filters.subtype.textContent = "";
        const placeholder = document.createElement("option");
        placeholder.value = "";
        placeholder.textContent = subtypePlaceholder;
        filters.subtype.append(placeholder);
        matchingOptions.forEach((option)=>{
            const element = document.createElement("option");
            element.value = option.value;
            element.textContent = option.text;
            element.dataset.parent = option.parent;
            filters.subtype.append(element);
        });
        const isSubtypeAvailable = Boolean(parentValue && matchingOptions.length);
        filters.subtype.disabled = !isSubtypeAvailable;
        if (subtypeField) subtypeField.hidden = !isSubtypeAvailable;
        if (!isSubtypeAvailable || !matchingOptions.some((option)=>option.value === selectedValue)) filters.subtype.value = "";
        else filters.subtype.value = selectedValue;
    };
    const syncRatingFilter = ()=>{
        if (!filters.rating) return;
        const isRatingParentSelected = filters.type ? filters.type.value === ratingParentValue : false;
        filters.rating.disabled = !isRatingParentSelected;
        if (ratingField) ratingField.hidden = !isRatingParentSelected;
        if (!isRatingParentSelected) filters.rating.value = "";
    };
    const getState = ()=>({
            type: filters.type ? filters.type.value : "",
            subtype: filters.subtype ? filters.subtype.value : "",
            rating: filters.rating ? filters.rating.value : "",
            cuisine: filters.cuisine ? filters.cuisine.value : "",
            service: filters.service ? filters.service.value : "",
            open: filters.open ? filters.open.checked : false
        });
    const cardMatches = (card, state)=>includesToken(card.dataset.type, state.type) && includesToken(card.dataset.subtype, state.subtype) && (!state.rating || card.dataset.rating === state.rating) && includesToken(card.dataset.cuisine, state.cuisine) && includesToken(card.dataset.service, state.service) && (!state.open || card.dataset.open === "1");
    const getPotentialCount = (filterKey, value, state)=>{
        const potentialState = {
            ...state,
            [filterKey]: value
        };
        return cards.reduce((count, card)=>count + (cardMatches(card, potentialState) ? 1 : 0), 0);
    };
    const updateOptionCounts = (state)=>{
        countedFilterKeys.forEach((filterKey)=>{
            const filter = filters[filterKey];
            if (!filter || filter.tagName !== "SELECT") return;
            Array.from(filter.options).forEach((option)=>{
                const baseLabel = getOptionBaseLabel(option);
                if (!option.value) {
                    option.textContent = baseLabel;
                    return;
                }
                const count = getPotentialCount(filterKey, option.value, state);
                option.textContent = `${baseLabel} (${count})`;
                option.disabled = 0 === count && option.value !== filter.value;
            });
        });
        if (filters.open && openToggleLabel) {
            const openCount = getPotentialCount("open", true, state);
            if (!openToggleLabel.dataset.filterLabel) openToggleLabel.dataset.filterLabel = (openToggleLabel.textContent || "").replace(/\s+\(\d+\)\s*$/, "");
            openToggleLabel.textContent = `${openToggleLabel.dataset.filterLabel} (${openCount})`;
            filters.open.disabled = 0 === openCount && !state.open;
        }
    };
    const shouldAnimateCards = ()=>!reducedMotionQuery || !reducedMotionQuery.matches;
    const finalizeCardAnimation = (card)=>{
        const cleanup = cardCleanups.get(card);
        if (cleanup) cleanup();
    };
    const clearCardAnimationStyles = (card)=>{
        card.classList.remove("is-filtering-in", "is-filtering-out");
        card.style.position = "";
        card.style.top = "";
        card.style.left = "";
        card.style.width = "";
        card.style.height = "";
        card.style.margin = "";
        card.style.transition = "";
        card.style.transform = "";
    };
    const finalizeGridAnimation = ()=>{
        if (gridCleanup) gridCleanup();
    };
    const applyCardVisibility = (changes)=>{
        finalizeGridAnimation();
        changes.forEach(({ card: card, isVisible: isVisible })=>{
            finalizeCardAnimation(card);
            clearCardAnimationStyles(card);
            card.hidden = !isVisible;
        });
    };
    const animateCardVisibility = (changes)=>{
        finalizeGridAnimation();
        const gridRect = grid.getBoundingClientRect();
        const firstHeight = gridRect.height;
        const firstRects = new Map();
        const wasExiting = new Set();
        const entering = [];
        const moving = [];
        // Capture the current on-screen position of every visible card —
        // including cards still mid-animation — before finalizing, so an
        // interrupted animation continues from where it visually is.
        changes.forEach(({ card: card })=>{
            if (!card.hidden) firstRects.set(card, card.getBoundingClientRect());
            if (card.classList.contains("is-filtering-out")) wasExiting.add(card);
            finalizeCardAnimation(card);
            card.style.transition = "";
            card.style.transform = "";
        });
        changes.forEach(({ card: card, isVisible: isVisible })=>{
            const firstRect = firstRects.get(card);
            if (isVisible) {
                if (firstRect) // Covers cards resurrected mid-exit: back into the flow, the FLIP
                // pass below moves them from their measured ghost position.
                card.hidden = false;
                else {
                    card.hidden = false;
                    card.classList.add("is-filtering-in");
                    entering.push(card);
                }
                return;
            }
            if (!firstRect || wasExiting.has(card)) {
                card.hidden = true;
                card.classList.remove("is-filtering-in", "is-filtering-out");
                return;
            }
            // Take the leaving card out of the flow and pin it to its old spot so
            // it can fade out while the grid reflows around it.
            card.classList.add("is-filtering-out");
            card.style.position = "absolute";
            card.style.top = `${firstRect.top - gridRect.top}px`;
            card.style.left = `${firstRect.left - gridRect.left}px`;
            card.style.width = `${firstRect.width}px`;
            card.style.height = `${firstRect.height}px`;
            card.style.margin = "0";
            const timer = window.setTimeout(()=>finalizeCardAnimation(card), filterAnimationDuration);
            cardCleanups.set(card, ()=>{
                window.clearTimeout(timer);
                cardCleanups.delete(card);
                card.hidden = true;
                clearCardAnimationStyles(card);
            });
        });
        // Animate the grid's own height so the content below it doesn't jump.
        const lastHeight = grid.offsetHeight;
        const heightChanged = Math.round(firstHeight) !== Math.round(lastHeight);
        if (heightChanged) {
            grid.style.transition = "none";
            grid.style.height = `${firstHeight}px`;
        }
        // FLIP: put remaining cards back on their old position, then release the
        // transform so they glide into their new grid slot.
        changes.forEach(({ card: card, isVisible: isVisible })=>{
            const firstRect = firstRects.get(card);
            if (!isVisible || !firstRect) return;
            const lastRect = card.getBoundingClientRect();
            const deltaX = firstRect.left - lastRect.left;
            const deltaY = firstRect.top - lastRect.top;
            if (deltaX || deltaY) {
                card.style.transition = "none";
                card.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
                moving.push(card);
            }
        });
        grid.offsetWidth;
        moving.forEach((card)=>{
            card.style.transition = `transform ${flipMoveDuration}ms cubic-bezier(0.2, 0, 0, 1)`;
            card.style.transform = "";
            const timer = window.setTimeout(()=>finalizeCardAnimation(card), flipMoveDuration + 50);
            cardCleanups.set(card, ()=>{
                window.clearTimeout(timer);
                cardCleanups.delete(card);
                card.style.transition = "";
                card.style.transform = "";
            });
        });
        if (heightChanged) {
            grid.style.transition = `height ${flipMoveDuration}ms cubic-bezier(0.2, 0, 0, 1)`;
            grid.style.height = `${lastHeight}px`;
            const timer = window.setTimeout(()=>finalizeGridAnimation(), flipMoveDuration + 50);
            gridCleanup = ()=>{
                window.clearTimeout(timer);
                gridCleanup = null;
                grid.style.transition = "";
                grid.style.height = "";
            };
        }
        entering.forEach((card)=>{
            card.classList.remove("is-filtering-in");
        });
    };
    const applyStateFromUrl = ()=>{
        const params = new URLSearchParams(window.location.search);
        Object.entries(urlParamMap).forEach(([key, param])=>{
            const filter = filters[key];
            if (!filter || !params.has(param)) return;
            const value = params.get(param) || "";
            if (key === "open") {
                filter.checked = "1" === value;
                return;
            }
            if (Array.from(filter.options || []).some((option)=>option.value === value)) filter.value = value;
        });
    };
    const syncUrl = (state)=>{
        if (!window.history || !window.history.replaceState) return;
        const url = new URL(window.location.href);
        Object.entries(urlParamMap).forEach(([key, param])=>{
            const value = "open" === key ? state.open ? "1" : "" : state[key];
            const preset = "open" === key ? presetState.open ? "1" : "" : presetState[key];
            if (value && value !== preset) url.searchParams.set(param, value);
            else url.searchParams.delete(param);
        });
        window.history.replaceState(null, "", url);
    };
    const applyFilters = ({ animate: animate = true } = {})=>{
        refreshOpenStates();
        syncSubtypeOptions();
        syncRatingFilter();
        const state = getState();
        updateOptionCounts(state);
        syncUrl(state);
        const changes = cards.map((card)=>({
                card: card,
                isVisible: cardMatches(card, state)
            }));
        const visibleCount = changes.filter(({ isVisible: isVisible })=>isVisible).length;
        if (animate && shouldAnimateCards()) animateCardVisibility(changes);
        else applyCardVisibility(changes);
        if (countTarget) countTarget.textContent = String(visibleCount);
        // Zahl und Wort stehen zusammen in einer aria-live-Region — wird nur die
        // Zahl getauscht, liest der Screenreader „1 Unterkünfte".
        if (countLabelTarget) {
            const nextLabel = visibleCount === 1 ? countLabelTarget.dataset.countLabelOne : countLabelTarget.dataset.countLabelOther;
            if (nextLabel && countLabelTarget.textContent !== nextLabel) countLabelTarget.textContent = nextLabel;
        }
        if (emptyState) emptyState.hidden = visibleCount > 0;
        if (resetButton) resetButton.disabled = !(countedFilterKeys.some((key)=>state[key] !== presetState[key]) || state.open !== presetState.open);
    };
    Object.values(filters).forEach((filter)=>{
        if (!filter) return;
        filter.addEventListener("change", applyFilters);
    });
    const resetFilters = ()=>{
        Object.entries(filters).forEach(([key, filter])=>{
            if (!filter) return;
            if (key === "open") filter.checked = presetState.open;
            else filter.value = presetState[key] || "";
        });
        applyFilters();
    };
    [
        resetButton,
        emptyResetButton
    ].forEach((button)=>{
        if (button) button.addEventListener("click", resetFilters);
    });
    applyStateFromUrl();
    applyFilters({
        animate: false
    });
    if (cards.some((card)=>(cardPeriods.get(card) || []).length > 0)) {
        window.setInterval(()=>{
            if (refreshOpenStates()) applyFilters();
        }, openStateRefreshInterval);
        window.addEventListener("pageshow", (event)=>{
            if (event.persisted && refreshOpenStates()) applyFilters({
                animate: false
            });
        });
    }
});


/**
 * Opening-hours flyout on the Gastgeber detail page
 * (inc/gastgeber-opening-hours.php): disclosure button + WAI-ARIA tabs.
 *
 * Works like the footer pills (footer-tooltip.js) — click toggles, Escape and
 * a click outside close — plus what the footer lacks: aria-controls, a close
 * button, closing when keyboard focus leaves, and arrow keys in the tabs.
 */ const $c584be7988f36c33$var$OPEN_CLASS = "is-open";
function $c584be7988f36c33$var$setOpen(wrapper, open, { focusToggle: focusToggle = false } = {}) {
    const toggle = wrapper.querySelector("[aria-controls]");
    const flyout = toggle && document.getElementById(toggle.getAttribute("aria-controls"));
    if (!toggle || !flyout) return;
    wrapper.classList.toggle($c584be7988f36c33$var$OPEN_CLASS, open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    flyout.hidden = !open;
    if (!open && focusToggle) toggle.focus();
}
function $c584be7988f36c33$var$initFlyout(wrapper) {
    const toggle = wrapper.querySelector("[aria-controls]");
    const close = wrapper.querySelector(".js-gastgeber-hours-close");
    if (!toggle) return;
    toggle.addEventListener("click", ()=>{
        $c584be7988f36c33$var$setOpen(wrapper, !wrapper.classList.contains($c584be7988f36c33$var$OPEN_CLASS));
    });
    if (close) close.addEventListener("click", ()=>$c584be7988f36c33$var$setOpen(wrapper, false, {
            focusToggle: true
        }));
    wrapper.addEventListener("keydown", (event)=>{
        if (event.key === "Escape" && wrapper.classList.contains($c584be7988f36c33$var$OPEN_CLASS)) {
            event.stopPropagation();
            $c584be7988f36c33$var$setOpen(wrapper, false, {
                focusToggle: true
            });
        }
    });
    // Tabbing past the last link closes it, so it never lingers over the page.
    wrapper.addEventListener("focusout", (event)=>{
        if (event.relatedTarget && !wrapper.contains(event.relatedTarget)) $c584be7988f36c33$var$setOpen(wrapper, false);
    });
    document.addEventListener("click", (event)=>{
        if (wrapper.classList.contains($c584be7988f36c33$var$OPEN_CLASS) && !wrapper.contains(event.target)) $c584be7988f36c33$var$setOpen(wrapper, false);
    });
}
function $c584be7988f36c33$var$initTabs(container) {
    const tabs = Array.from(container.querySelectorAll('[role="tab"]'));
    const select = (tab, focus)=>{
        tabs.forEach((other)=>{
            const selected = other === tab;
            const panel = document.getElementById(other.getAttribute("aria-controls"));
            other.setAttribute("aria-selected", selected ? "true" : "false");
            other.tabIndex = selected ? 0 : -1;
            if (panel) panel.hidden = !selected;
        });
        if (focus) tab.focus();
    };
    tabs.forEach((tab, index)=>{
        tab.addEventListener("click", ()=>select(tab, false));
        tab.addEventListener("keydown", (event)=>{
            let next = null;
            if (event.key === "ArrowRight") next = tabs[(index + 1) % tabs.length];
            else if (event.key === "ArrowLeft") next = tabs[(index - 1 + tabs.length) % tabs.length];
            else if (event.key === "Home") next = tabs[0];
            else if (event.key === "End") next = tabs[tabs.length - 1];
            if (next) {
                event.preventDefault();
                select(next, true);
            }
        });
    });
}
function $c584be7988f36c33$var$init() {
    document.querySelectorAll(".js-gastgeber-hours").forEach($c584be7988f36c33$var$initFlyout);
    document.querySelectorAll("[data-gastgeber-hours-tabs]").forEach($c584be7988f36c33$var$initTabs);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $c584be7988f36c33$var$init, {
    once: true
});
else $c584be7988f36c33$var$init();


/**
 * Recommendation block below detail pages (inc/related-content.php).
 *
 * The visible cards are fixed in the cached HTML, so crawlers always see the
 * same links. Spare cards wait in a <template>: once per page load, a visible
 * card whose venue is closed right now (Berlin time) is swapped for the first
 * open spare of the same group. Cards without known hours never move.
 */ 
var $bErSZ = parcelRequire("bErSZ");
function $dc2804c4e7903b4b$var$slotStatus(slot, clock) {
    const periods = (0, $bErSZ.parsePeriodsAttribute)(slot.getAttribute("data-periods"));
    const special = (0, $bErSZ.parseSpecialAttribute)(slot.getAttribute("data-special"));
    if (!periods.length && !special.length) return null;
    return (0, $bErSZ.computeOpeningStatus)(periods, {
        special: special,
        clock: clock,
        compact: true
    });
}
function $dc2804c4e7903b4b$var$swapClosedSlots(section) {
    const grid = section.querySelector("[data-related-grid]");
    const template = section.querySelector("template[data-related-reserve]");
    if (!grid || !template) return;
    const clock = (0, $bErSZ.getBerlinClock)();
    const spares = Array.from(template.content.querySelectorAll("[data-related-slot][data-related-group]")).filter((spare)=>$dc2804c4e7903b4b$var$slotStatus(spare, clock)?.open);
    grid.querySelectorAll(":scope > [data-related-slot][data-related-group]").forEach((slot)=>{
        const status = $dc2804c4e7903b4b$var$slotStatus(slot, clock);
        if (!status || status.open || status.state === "unknown") return;
        const index = spares.findIndex((spare)=>spare.dataset.relatedGroup === slot.dataset.relatedGroup);
        if (index === -1) return;
        const [spare] = spares.splice(index, 1);
        slot.replaceWith(document.importNode(spare, true));
    });
    (0, $bErSZ.refreshAllOpeningStatuses)({
        root: grid,
        clock: clock
    });
}
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll("[data-related]").forEach($dc2804c4e7903b4b$var$swapClosedSlots);
});


// Merken-Buttons (Lesezeichen) und Merklisten-Zähler im Header, auf jeder Seite (bundle.js).
// Zustand und Zahl kommen immer aus dem Store, nie aus einem eigenen Zähler.

var $6K3oU = parcelRequire("6K3oU");

var $kNIpW = parcelRequire("kNIpW");

var $1rCcS = parcelRequire("1rCcS");
const $d31817a620f9bac1$var$BUTTON = ".ws-favorite-toggle";
function $d31817a620f9bac1$var$initFavorites() {
    const store = (0, $6K3oU.getFavoritesStore)();
    const known = new WeakSet();
    function pop(button, added) {
        const targets = [
            button,
            ...document.querySelectorAll("[data-favorites-nav]")
        ];
        for (const target of targets){
            target.classList.remove("is-popping");
            if (!added || !target.getClientRects().length || window.matchMedia("(prefers-reduced-motion: reduce)").matches) continue;
            // Restart the CSS animation when the same heart is pressed twice.
            target.offsetWidth;
            target.classList.add("is-popping");
            target.addEventListener("animationend", ()=>target.classList.remove("is-popping"), {
                once: true
            });
        }
    }
    function update({ items: items }) {
        const ids = new Set(items.map((item)=>item.id));
        for (const button of document.querySelectorAll($d31817a620f9bac1$var$BUTTON)){
            const saved = ids.has(Number(button.dataset.id));
            button.setAttribute("aria-pressed", String(saved));
            const action = saved ? (0, $kNIpW.t)("remove") : (0, $kNIpW.t)("save");
            button.setAttribute("aria-label", `${action}: ${button.dataset.title}`);
            const label = button.querySelector(".ws-favorite-toggle__label");
            if (label) label.textContent = saved ? (0, $kNIpW.t)("saved") : (0, $kNIpW.t)("save");
        }
        for (const nav of document.querySelectorAll("[data-favorites-nav]")){
            nav.classList.toggle("has-favorites", items.length > 0);
            nav.setAttribute("aria-label", `${(0, $kNIpW.t)("favorites")} (${items.length})`);
            const count = nav.querySelector("[data-favorites-count]");
            if (count) {
                count.textContent = items.length > 99 ? "99+" : String(items.length);
                count.hidden = items.length === 0;
            }
        }
    }
    function discover(root) {
        const buttons = root.matches?.($d31817a620f9bac1$var$BUTTON) ? [
            root
        ] : [
            ...root.querySelectorAll($d31817a620f9bac1$var$BUTTON)
        ];
        const fresh = buttons.filter((button)=>!known.has(button));
        if (!fresh.length) return;
        fresh.forEach((button)=>known.add(button));
        // Saved titles and links follow renames as soon as a heart is seen again.
        store.updateDetails(fresh.map((button)=>({
                id: button.dataset.id,
                title: button.dataset.title,
                url: button.dataset.url
            })));
        update(store.getState());
    }
    store.subscribe(update);
    discover(document);
    // The event archive and the restaurant filter replace cards without a navigation.
    new MutationObserver((records)=>{
        for (const record of records)for (const node of record.addedNodes)if (node.nodeType === 1) discover(node);
    }).observe(document.body, {
        childList: true,
        subtree: true
    });
    document.addEventListener("click", (event)=>{
        const button = event.target.closest($d31817a620f9bac1$var$BUTTON);
        if (!button) return;
        event.preventDefault();
        const result = store.toggle({
            id: button.dataset.id,
            title: button.dataset.title,
            url: button.dataset.url
        });
        if (!result.ok) return (0, $kNIpW.showError)(result.error);
        if (result.added) (0, $1rCcS.trackFavoriteEvent)("saved");
        pop(button, result.added);
        (0, $kNIpW.notify)(result.added ? (0, $kNIpW.t)("added") : (0, $kNIpW.t)("removed"), {
            open: result.added,
            undo: result.added ? null : result
        });
    });
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $d31817a620f9bac1$var$initFavorites, {
    once: true
});
else $d31817a620f9bac1$var$initFavorites();


/**
 * Tooltip positioning — the situational half of the .ws-tip primitive.
 *
 * The chip is already usable without this file: CSS parks it above the anchor,
 * centred, which is the right answer nearly everywhere. What CSS cannot do is
 * notice that "above" would land off the top of the window, or that a chip
 * centred on a button near the right edge would hang past it. That is the job
 * here — measure on hover/focus, pick a side that fits, slide the chip along
 * the cross axis until it is inside, and move the caret back over the anchor's
 * centre so it still points at the thing it belongs to.
 *
 * Everything is written back as custom properties with CSS-side defaults
 * (see src/sass/modules/_tooltip.scss), so a failure here degrades to the
 * plain centred-above chip rather than to a broken one.
 */ // Breathing room between the chip and the edge it is being kept inside.
const $0201af05aeb470a9$var$EDGE_MARGIN = 8;
// Preferred side first, then its opposite, then the two perpendicular ones —
// flipping to the far side keeps the chip on the axis the author asked for,
// which is the least surprising fallback.
const $0201af05aeb470a9$var$FALLBACKS = {
    top: [
        'top',
        'bottom',
        'right',
        'left'
    ],
    bottom: [
        'bottom',
        'top',
        'right',
        'left'
    ],
    left: [
        'left',
        'right',
        'top',
        'bottom'
    ],
    right: [
        'right',
        'left',
        'top',
        'bottom'
    ]
};
const $0201af05aeb470a9$var$HORIZONTAL = {
    top: true,
    bottom: true
};
let $0201af05aeb470a9$var$active = null; // { anchor, tip } currently shown
let $0201af05aeb470a9$var$frame = 0;
/**
 * The box the chip has to stay inside: the viewport, further tightened by any
 * scrolling or clipping ancestor. Without the ancestor walk a chip inside an
 * `overflow: hidden` strip would happily be placed "in the viewport" and then
 * be cut in half by the strip.
 */ function $0201af05aeb470a9$var$clipBounds(anchor) {
    const bounds = {
        top: $0201af05aeb470a9$var$EDGE_MARGIN,
        left: $0201af05aeb470a9$var$EDGE_MARGIN,
        right: document.documentElement.clientWidth - $0201af05aeb470a9$var$EDGE_MARGIN,
        bottom: document.documentElement.clientHeight - $0201af05aeb470a9$var$EDGE_MARGIN
    };
    for(let el = anchor.parentElement; el && el !== document.body; el = el.parentElement){
        const cs = getComputedStyle(el);
        if (cs.overflow === 'visible' && cs.overflowX === 'visible' && cs.overflowY === 'visible') continue;
        const box = el.getBoundingClientRect();
        bounds.top = Math.max(bounds.top, box.top);
        bounds.left = Math.max(bounds.left, box.left);
        bounds.right = Math.min(bounds.right, box.right);
        bounds.bottom = Math.min(bounds.bottom, box.bottom);
    }
    return bounds;
}
/** How far the chip pokes past the bound on the side it points from; <= 0 fits. */ function $0201af05aeb470a9$var$overflowOf(rect, bounds, at) {
    if (at === 'top') return bounds.top - rect.top;
    if (at === 'bottom') return rect.bottom - bounds.bottom;
    if (at === 'left') return bounds.left - rect.left;
    return rect.right - bounds.right;
}
/**
 * How far the caret may sit from the chip's edge before it starts crawling
 * onto the rounded corner. Read from the rendered CSS rather than hard-coded,
 * so changing --ws-tip-radius or --ws-tip-caret cannot desynchronise the two.
 *
 * The caret is a border triangle, so the side facing the chip is collapsed to
 * zero width and which side that is depends on the placement. The largest of
 * the four is the one we want, whichever way the chip is currently pointing.
 */ function $0201af05aeb470a9$var$caretLimits(tip, length) {
    const radius = parseFloat(getComputedStyle(tip).borderTopLeftRadius) || 0;
    const caret = getComputedStyle(tip, '::after');
    const half = Math.max(parseFloat(caret.borderTopWidth) || 0, parseFloat(caret.borderRightWidth) || 0, parseFloat(caret.borderBottomWidth) || 0, parseFloat(caret.borderLeftWidth) || 0);
    const inset = radius + half;
    // A chip narrower than two corners' worth has nowhere safe to put the caret;
    // dead-centre is the least bad answer.
    if (inset * 2 >= length) return [
        length / 2,
        length / 2
    ];
    return [
        inset,
        length - inset
    ];
}
function $0201af05aeb470a9$var$place(anchor, tip) {
    // offsetParent is null while anything up the chain is display: none — there
    // is nothing to measure and nothing to show.
    if (!tip.offsetParent) return;
    // Measure from scratch: a shift left over from the last time this chip was
    // shown would otherwise be baked into every rect below.
    tip.style.removeProperty('--ws-tip-shift');
    tip.style.removeProperty('--ws-tip-caret-pos');
    const preferred = $0201af05aeb470a9$var$FALLBACKS[tip.dataset.wsTipPlace] ? tip.dataset.wsTipPlace : 'top';
    const bounds = $0201af05aeb470a9$var$clipBounds(anchor);
    const anchorBox = anchor.getBoundingClientRect();
    // Try each candidate for real rather than predicting it: the chip's size can
    // change between sides (a 20rem max-width wraps differently once the
    // available room changes), so only a measured rect is trustworthy. The
    // preferred side is measured first and breaks out immediately, so the common
    // case costs one layout, not four.
    let best = null;
    for (const candidate of $0201af05aeb470a9$var$FALLBACKS[preferred]){
        tip.dataset.wsTipAt = candidate;
        // Safe to read straight back: the chip animates opacity only, so nothing
        // it has is mid-flight and the rect is the position it is really in.
        const rect = tip.getBoundingClientRect();
        const overflow = $0201af05aeb470a9$var$overflowOf(rect, bounds, candidate);
        if (overflow <= 0) {
            best = {
                at: candidate,
                rect: rect
            };
            break;
        }
        // Nothing fits in a window this small; remember the least bad side rather
        // than letting the loop's last candidate win by accident.
        if (!best || overflow < best.overflow) best = {
            at: candidate,
            rect: rect,
            overflow: overflow
        };
    }
    const { at: at, rect: rect } = best;
    tip.dataset.wsTipAt = at;
    // Cross-axis nudge: push the chip back inside whichever edge it overshot.
    // Only one of the two can be true unless the chip is wider than the bounds,
    // in which case the leading edge wins and the tail is allowed to overflow —
    // better than centring the overflow on both sides.
    const horizontal = $0201af05aeb470a9$var$HORIZONTAL[at];
    const startEdge = horizontal ? rect.left : rect.top;
    const endEdge = horizontal ? rect.right : rect.bottom;
    const lowBound = horizontal ? bounds.left : bounds.top;
    const highBound = horizontal ? bounds.right : bounds.bottom;
    let shift = 0;
    if (startEdge < lowBound) shift = lowBound - startEdge;
    else if (endEdge > highBound) shift = highBound - endEdge;
    // Put the caret back over the anchor's centre, expressed from the chip's own
    // leading edge, then keep it clear of the rounded corners.
    const anchorCentre = horizontal ? anchorBox.left + anchorBox.width / 2 : anchorBox.top + anchorBox.height / 2;
    const length = horizontal ? rect.width : rect.height;
    const [min, max] = $0201af05aeb470a9$var$caretLimits(tip, length);
    const caret = Math.min(Math.max(anchorCentre - (startEdge + shift), min), max);
    tip.style.setProperty('--ws-tip-shift', `${Math.round(shift)}px`);
    tip.style.setProperty('--ws-tip-caret-pos', `${Math.round(caret)}px`);
}
function $0201af05aeb470a9$var$show(anchor) {
    const tip = anchor.querySelector(':scope > .ws-tip');
    if (!tip) return;
    $0201af05aeb470a9$var$active = {
        anchor: anchor,
        tip: tip
    };
    $0201af05aeb470a9$var$place(anchor, tip);
}
function $0201af05aeb470a9$var$hide(anchor) {
    if ($0201af05aeb470a9$var$active && $0201af05aeb470a9$var$active.anchor === anchor) $0201af05aeb470a9$var$active = null;
}
/**
 * A chip that is already open can go stale when the page moves under it — the
 * side that fitted a moment ago may not fit now. Re-measuring is cheap and
 * only ever runs while something is actually shown.
 */ function $0201af05aeb470a9$var$reposition() {
    if (!$0201af05aeb470a9$var$active || $0201af05aeb470a9$var$frame) return;
    $0201af05aeb470a9$var$frame = requestAnimationFrame(()=>{
        $0201af05aeb470a9$var$frame = 0;
        if ($0201af05aeb470a9$var$active) $0201af05aeb470a9$var$place($0201af05aeb470a9$var$active.anchor, $0201af05aeb470a9$var$active.tip);
    });
}
/**
 * Safety net for markup that carries the chip but forgot the anchor class.
 * Without `position: relative` on the anchor the chip would be placed against
 * some far-away ancestor, which looks like a bug in the primitive rather than
 * a typo in the template.
 */ function $0201af05aeb470a9$var$adoptOrphans(root) {
    root.querySelectorAll('.ws-tip').forEach((tip)=>{
        const anchor = tip.parentElement;
        if (anchor) anchor.classList.add('ws-tip-anchor');
    });
}
function $0201af05aeb470a9$var$init() {
    $0201af05aeb470a9$var$adoptOrphans(document);
    // pointerover/focusin rather than pointerenter/focus: those do not bubble,
    // and delegation is what keeps Ajax-replaced markup (the event filter) working
    // without re-binding anything.
    document.addEventListener('pointerover', (event)=>{
        const anchor = event.target.closest && event.target.closest('.ws-tip-anchor');
        if (!anchor || $0201af05aeb470a9$var$active && $0201af05aeb470a9$var$active.anchor === anchor) return;
        $0201af05aeb470a9$var$show(anchor);
    });
    document.addEventListener('pointerout', (event)=>{
        const anchor = event.target.closest && event.target.closest('.ws-tip-anchor');
        // relatedTarget inside the same anchor means the pointer only crossed from
        // the icon to the padding — the chip should stay put.
        if (!anchor || event.relatedTarget && anchor.contains(event.relatedTarget)) return;
        $0201af05aeb470a9$var$hide(anchor);
    });
    document.addEventListener('focusin', (event)=>{
        const anchor = event.target.closest && event.target.closest('.ws-tip-anchor');
        if (anchor) $0201af05aeb470a9$var$show(anchor);
    });
    document.addEventListener('focusout', (event)=>{
        const anchor = event.target.closest && event.target.closest('.ws-tip-anchor');
        if (anchor) $0201af05aeb470a9$var$hide(anchor);
    });
    addEventListener('scroll', $0201af05aeb470a9$var$reposition, {
        passive: true,
        capture: true
    });
    addEventListener('resize', $0201af05aeb470a9$var$reposition, {
        passive: true
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $0201af05aeb470a9$var$init, {
    once: true
});
else $0201af05aeb470a9$var$init();


document.addEventListener('DOMContentLoaded', ()=>{
    // The Bürger page pills moved into blocks/opening-hours (own view script).
    const wrappers = document.querySelectorAll('.footer-status-wrapper');
    wrappers.forEach((wrapper)=>{
        const btn = wrapper.querySelector('.js-footer-status-btn');
        if (!btn) return;
        btn.addEventListener('click', (e)=>{
            e.stopPropagation(); // Prevent document click from immediately closing
            // Close other tooltips
            wrappers.forEach((w)=>{
                if (w !== wrapper && w.classList.contains('is-open')) {
                    w.classList.remove('is-open');
                    const otherBtn = w.querySelector('.js-footer-status-btn');
                    if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
                }
            });
            const isOpen = wrapper.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', isOpen.toString());
        });
    });
    // Close when clicking outside
    document.addEventListener('click', (e)=>{
        wrappers.forEach((wrapper)=>{
            if (!wrapper.contains(e.target) && wrapper.classList.contains('is-open')) {
                wrapper.classList.remove('is-open');
                const btn = wrapper.querySelector('.js-footer-status-btn');
                if (btn) btn.setAttribute('aria-expanded', 'false');
            }
        });
    });
    // Close on Escape key
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape') wrappers.forEach((wrapper)=>{
            if (wrapper.classList.contains('is-open')) {
                wrapper.classList.remove('is-open');
                const btn = wrapper.querySelector('.js-footer-status-btn');
                if (btn) {
                    btn.setAttribute('aria-expanded', 'false');
                    btn.focus(); // Return focus to button when closing via keyboard
                }
            }
        });
    });
});


document.addEventListener("DOMContentLoaded", ()=>{
    const section = document.querySelector("#highlights");
    const gridShell = section?.querySelector(".highlight-grid-shell");
    const grid = section?.querySelector(".highlight-grid");
    const templates = section ? new Map(Array.from(section.querySelectorAll("template[data-highlight-template]")).map((template)=>[
            template.dataset.highlightTemplate || "",
            template.innerHTML
        ])) : new Map();
    const rail = section?.querySelector(".highlight-selector__rail");
    const selectorItems = section ? Array.from(section.querySelectorAll(".highlight-selector__item")) : [];
    const prefersReducedMotion = typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!section || !gridShell || !grid) return;
    let revealObserver;
    let motionRefreshFrame;
    const getCards = ()=>Array.from(section.querySelectorAll(".highlight-eq"));
    const rowTopTolerance = 6;
    const motionProfiles = {
        default: {
            rowDelayStep: 126,
            columnDelayStep: 60,
            maxCardDelay: 300
        },
        fast: {
            rowDelayStep: 66,
            columnDelayStep: 26,
            maxCardDelay: 132
        }
    };
    const getMotionProfile = (motionMode = "default")=>motionProfiles[motionMode] || motionProfiles.default;
    const setMotionMode = (motionMode = "default")=>{
        section.dataset.highlightMotion = motionMode;
    };
    const syncCardMotionDelays = (cards = getCards(), motionProfile = getMotionProfile(section.dataset.highlightMotion))=>{
        const { rowDelayStep: rowDelayStep, columnDelayStep: columnDelayStep, maxCardDelay: maxCardDelay } = motionProfile;
        const rowTops = [];
        const rowCounts = [];
        cards.forEach((card, index)=>{
            const currentTop = card.offsetTop;
            let rowIndex = rowTops.findIndex((rowTop)=>Math.abs(rowTop - currentTop) <= rowTopTolerance);
            if (rowIndex === -1) {
                rowTops.push(currentTop);
                rowCounts.push(0);
                rowIndex = rowTops.length - 1;
            }
            const columnIndex = rowCounts[rowIndex];
            const cardDelay = Math.min(rowIndex * rowDelayStep + columnIndex * columnDelayStep, maxCardDelay);
            rowCounts[rowIndex] += 1;
            card.style.setProperty("--highlight-index", index);
            card.style.setProperty("--highlight-delay", `${cardDelay}ms`);
        });
    };
    const refreshCardMotionDelays = ()=>{
        if (prefersReducedMotion) return;
        window.cancelAnimationFrame(motionRefreshFrame);
        motionRefreshFrame = window.requestAnimationFrame(()=>{
            syncCardMotionDelays(getCards(), getMotionProfile(section.dataset.highlightMotion));
        });
    };
    const prepareCardsForReveal = (cards = getCards(), options = {})=>{
        const { motionMode: motionMode = "default" } = options;
        if (revealObserver) {
            revealObserver.disconnect();
            revealObserver = undefined;
        }
        if (cards.length === 0) {
            setMotionMode(motionMode);
            section.classList.remove("is-motion-ready");
            return {
                cards: cards,
                shouldAnimate: false
            };
        }
        cards.forEach((card, index)=>{
            card.classList.remove("is-visible");
            card.style.setProperty("--highlight-index", index);
        });
        if (prefersReducedMotion || !("IntersectionObserver" in window)) {
            setMotionMode(motionMode);
            section.classList.remove("is-motion-ready");
            cards.forEach((card)=>{
                card.classList.add("is-visible");
            });
            return {
                cards: cards,
                shouldAnimate: false
            };
        }
        setMotionMode(motionMode);
        syncCardMotionDelays(cards, getMotionProfile(motionMode));
        section.classList.add("is-motion-ready");
        return {
            cards: cards,
            shouldAnimate: true
        };
    };
    const startReveal = (cards, options = {})=>{
        const { immediate: immediate = false } = options;
        if (cards.length === 0) return;
        if (immediate) {
            window.requestAnimationFrame(()=>{
                cards.forEach((card)=>{
                    card.classList.add("is-visible");
                });
            });
            return;
        }
        revealObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                entry.target.classList.add("is-visible");
                revealObserver?.unobserve(entry.target);
            });
        }, {
            threshold: 0.14,
            rootMargin: "0px 0px -8% 0px"
        });
        window.requestAnimationFrame(()=>{
            cards.forEach((card)=>{
                revealObserver?.observe(card);
            });
        });
    };
    const revealCards = ()=>{
        const { cards: cards, shouldAnimate: shouldAnimate } = prepareCardsForReveal();
        if (!shouldAnimate) return;
        startReveal(cards);
    };
    // Die Reiterleiste bricht nicht mehr um, sondern scrollt (siehe
    // _frontpage.scss). Damit kann der aktive Reiter außerhalb des sichtbaren
    // Ausschnitts liegen — beim Aufruf mit ?highlight_category=… genauso wie
    // nach einem Wechsel. Nur die Leiste scrollen, nie die Seite: scrollIntoView
    // würde den Viewport vertikal mitziehen.
    const centerRailItem = (item, behavior = "smooth")=>{
        if (!rail || !item || rail.scrollWidth <= rail.clientWidth + 1) return;
        const railRect = rail.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const delta = itemRect.left + itemRect.width / 2 - (railRect.left + railRect.width / 2);
        if (Math.abs(delta) < 1) return;
        const left = rail.scrollLeft + delta;
        if (typeof rail.scrollTo === "function") rail.scrollTo({
            left: left,
            behavior: prefersReducedMotion ? "auto" : behavior
        });
        else rail.scrollLeft = left;
    };
    const setActiveItem = (nextActiveItem)=>{
        selectorItems.forEach((item)=>{
            const isActive = item === nextActiveItem;
            item.classList.toggle("is-active", isActive);
            if (isActive) item.setAttribute("aria-current", "true");
            else item.removeAttribute("aria-current");
        });
        centerRailItem(nextActiveItem);
    };
    const replaceGridContent = (nextHtml)=>{
        grid.innerHTML = nextHtml;
        const { cards: cards, shouldAnimate: shouldAnimate } = prepareCardsForReveal(getCards(), {
            motionMode: "fast"
        });
        if (!shouldAnimate) return;
        window.requestAnimationFrame(()=>{
            startReveal(cards, {
                immediate: true
            });
        });
    };
    const getCategoryFromUrl = (url)=>{
        const nextUrl = new URL(url, window.location.origin);
        return nextUrl.searchParams.get("highlight_category") || "alle";
    };
    const switchCategory = (item, options = {})=>{
        const { skipHistory: skipHistory = false } = options;
        const nextCategory = item.dataset.highlightCategory || "alle";
        const nextHtml = templates.get(nextCategory);
        if (typeof nextHtml !== "string") {
            window.location.href = item.href;
            return;
        }
        setActiveItem(item);
        if (gridShell) gridShell.setAttribute("aria-busy", "true");
        replaceGridContent(nextHtml);
        if (!skipHistory && item.href) window.history.pushState({
            highlightCategory: nextCategory
        }, "", item.href);
        if (gridShell) gridShell.setAttribute("aria-busy", "false");
    };
    revealCards();
    centerRailItem(selectorItems.find((item)=>item.classList.contains("is-active")), "auto");
    window.addEventListener("resize", refreshCardMotionDelays);
    selectorItems.forEach((item)=>{
        item.addEventListener("click", (event)=>{
            event.preventDefault();
            if (item.classList.contains("is-active") && gridShell?.getAttribute("aria-busy") !== "true") return;
            switchCategory(item);
        });
    });
    window.addEventListener("popstate", ()=>{
        const targetCategory = getCategoryFromUrl(window.location.href);
        const targetItem = selectorItems.find((item)=>(item.dataset.highlightCategory || "alle") === targetCategory) || selectorItems[0];
        if (!targetItem) return;
        if (targetItem.classList.contains("is-active") && gridShell?.getAttribute("aria-busy") !== "true") return;
        switchCategory(targetItem, {
            skipHistory: true
        });
    });
});


document.addEventListener("DOMContentLoaded", ()=>{
    const section = document.querySelector("#frontpage-neuigkeiten");
    const gridShell = section?.querySelector(".highlight-grid-shell");
    const grid = section?.querySelector(".highlight-grid");
    const templates = section ? new Map(Array.from(section.querySelectorAll("template[data-frontpage-news-template]")).map((template)=>[
            template.dataset.frontpageNewsTemplate || "",
            template.innerHTML
        ])) : new Map();
    const rail = section?.querySelector(".highlight-selector__rail");
    const selectorItems = section ? Array.from(section.querySelectorAll(".highlight-selector__item")) : [];
    const prefersReducedMotion = typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!section || !gridShell || !grid) return;
    let revealObserver;
    let motionRefreshFrame;
    const getCards = ()=>Array.from(section.querySelectorAll(".highlight-eq"));
    const rowTopTolerance = 6;
    const motionProfiles = {
        default: {
            rowDelayStep: 126,
            columnDelayStep: 60,
            maxCardDelay: 300
        },
        fast: {
            rowDelayStep: 66,
            columnDelayStep: 26,
            maxCardDelay: 132
        }
    };
    const getMotionProfile = (motionMode = "default")=>motionProfiles[motionMode] || motionProfiles.default;
    const setMotionMode = (motionMode = "default")=>{
        section.dataset.highlightMotion = motionMode;
    };
    const syncCardMotionDelays = (cards = getCards(), motionProfile = getMotionProfile(section.dataset.highlightMotion))=>{
        const { rowDelayStep: rowDelayStep, columnDelayStep: columnDelayStep, maxCardDelay: maxCardDelay } = motionProfile;
        const rowTops = [];
        const rowCounts = [];
        cards.forEach((card, index)=>{
            const currentTop = card.offsetTop;
            let rowIndex = rowTops.findIndex((rowTop)=>Math.abs(rowTop - currentTop) <= rowTopTolerance);
            if (rowIndex === -1) {
                rowTops.push(currentTop);
                rowCounts.push(0);
                rowIndex = rowTops.length - 1;
            }
            const columnIndex = rowCounts[rowIndex];
            const cardDelay = Math.min(rowIndex * rowDelayStep + columnIndex * columnDelayStep, maxCardDelay);
            rowCounts[rowIndex] += 1;
            card.style.setProperty("--highlight-index", index);
            card.style.setProperty("--highlight-delay", `${cardDelay}ms`);
        });
    };
    const refreshCardMotionDelays = ()=>{
        if (prefersReducedMotion) return;
        window.cancelAnimationFrame(motionRefreshFrame);
        motionRefreshFrame = window.requestAnimationFrame(()=>{
            syncCardMotionDelays(getCards(), getMotionProfile(section.dataset.highlightMotion));
        });
    };
    const prepareCardsForReveal = (cards = getCards(), options = {})=>{
        const { motionMode: motionMode = "default" } = options;
        if (revealObserver) {
            revealObserver.disconnect();
            revealObserver = undefined;
        }
        if (cards.length === 0) {
            setMotionMode(motionMode);
            section.classList.remove("is-motion-ready");
            return {
                cards: cards,
                shouldAnimate: false
            };
        }
        cards.forEach((card, index)=>{
            card.classList.remove("is-visible");
            card.style.setProperty("--highlight-index", index);
        });
        if (prefersReducedMotion || !("IntersectionObserver" in window)) {
            setMotionMode(motionMode);
            section.classList.remove("is-motion-ready");
            cards.forEach((card)=>{
                card.classList.add("is-visible");
            });
            return {
                cards: cards,
                shouldAnimate: false
            };
        }
        setMotionMode(motionMode);
        syncCardMotionDelays(cards, getMotionProfile(motionMode));
        section.classList.add("is-motion-ready");
        return {
            cards: cards,
            shouldAnimate: true
        };
    };
    const startReveal = (cards, options = {})=>{
        const { immediate: immediate = false } = options;
        if (cards.length === 0) return;
        if (immediate) {
            window.requestAnimationFrame(()=>{
                cards.forEach((card)=>{
                    card.classList.add("is-visible");
                });
            });
            return;
        }
        revealObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                entry.target.classList.add("is-visible");
                revealObserver?.unobserve(entry.target);
            });
        }, {
            threshold: 0.14,
            rootMargin: "0px 0px -8% 0px"
        });
        window.requestAnimationFrame(()=>{
            cards.forEach((card)=>{
                revealObserver?.observe(card);
            });
        });
    };
    const revealCards = ()=>{
        const { cards: cards, shouldAnimate: shouldAnimate } = prepareCardsForReveal();
        if (!shouldAnimate) return;
        startReveal(cards);
    };
    // Die Reiterleiste bricht nicht mehr um, sondern scrollt (siehe
    // _frontpage.scss). Nur die Leiste scrollen, nie die Seite: scrollIntoView
    // würde den Viewport vertikal mitziehen.
    const centerRailItem = (item, behavior = "smooth")=>{
        if (!rail || !item || rail.scrollWidth <= rail.clientWidth + 1) return;
        const railRect = rail.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const delta = itemRect.left + itemRect.width / 2 - (railRect.left + railRect.width / 2);
        if (Math.abs(delta) < 1) return;
        const left = rail.scrollLeft + delta;
        if (typeof rail.scrollTo === "function") rail.scrollTo({
            left: left,
            behavior: prefersReducedMotion ? "auto" : behavior
        });
        else rail.scrollLeft = left;
    };
    const setActiveItem = (nextActiveItem)=>{
        selectorItems.forEach((item)=>{
            const isActive = item === nextActiveItem;
            item.classList.toggle("is-active", isActive);
            if (isActive) item.setAttribute("aria-current", "true");
            else item.removeAttribute("aria-current");
        });
        centerRailItem(nextActiveItem);
    };
    const replaceGridContent = (nextHtml)=>{
        grid.innerHTML = nextHtml;
        const { cards: cards, shouldAnimate: shouldAnimate } = prepareCardsForReveal(getCards(), {
            motionMode: "fast"
        });
        if (!shouldAnimate) return;
        window.requestAnimationFrame(()=>{
            startReveal(cards, {
                immediate: true
            });
        });
    };
    const getCategoryFromUrl = (url)=>{
        const nextUrl = new URL(url, window.location.origin);
        return nextUrl.searchParams.get("frontpage_news_category") || "veranstaltungen";
    };
    const switchCategory = (item, options = {})=>{
        const { skipHistory: skipHistory = false } = options;
        const nextCategory = item.dataset.frontpageNewsCategory || "veranstaltungen";
        const nextHtml = templates.get(nextCategory);
        if (typeof nextHtml !== "string") {
            window.location.href = item.href;
            return;
        }
        setActiveItem(item);
        if (gridShell) gridShell.setAttribute("aria-busy", "true");
        replaceGridContent(nextHtml);
        if (!skipHistory && item.href) window.history.pushState({
            frontpageNewsCategory: nextCategory
        }, "", item.href);
        if (gridShell) gridShell.setAttribute("aria-busy", "false");
    };
    revealCards();
    centerRailItem(selectorItems.find((item)=>item.classList.contains("is-active")), "auto");
    window.addEventListener("resize", refreshCardMotionDelays);
    selectorItems.forEach((item)=>{
        item.addEventListener("click", (event)=>{
            event.preventDefault();
            if (item.classList.contains("is-active") && gridShell?.getAttribute("aria-busy") !== "true") return;
            switchCategory(item);
        });
    });
    window.addEventListener("popstate", ()=>{
        const targetCategory = getCategoryFromUrl(window.location.href);
        const targetItem = selectorItems.find((item)=>(item.dataset.frontpageNewsCategory || "veranstaltungen") === targetCategory) || selectorItems[0];
        if (!targetItem) return;
        if (targetItem.classList.contains("is-active") && gridShell?.getAttribute("aria-busy") !== "true") return;
        switchCategory(targetItem, {
            skipHistory: true
        });
    });
});


/**
 * Scroll-Zustand der Filterleisten (.highlight-selector).
 *
 * Die Leiste bricht nicht mehr um, sondern scrollt horizontal — ohne Hinweis
 * merkt das niemand, bevor er zufällig wischt. Dieses Modul setzt den
 * tatsächlichen Zustand als Klassen auf die Leiste, damit das CSS nur dort
 * abblendet und Pfeile zeigt, wo wirklich etwas verborgen ist:
 *
 *   is-scrollable   überhaupt Überlauf vorhanden
 *   has-scroll-start  links ist noch etwas verborgen
 *   has-scroll-end    rechts ist noch etwas verborgen
 *
 * Rein zustandsgesteuert statt per Breakpoint: Eine Leiste, die passt, zeigt
 * nie einen Hinweis — auch nicht auf schmalen Fenstern am Desktop.
 */ document.addEventListener("DOMContentLoaded", ()=>{
    const selectors = Array.from(document.querySelectorAll(".highlight-selector")).filter((selector)=>selector.querySelector(".highlight-selector__rail"));
    if (selectors.length === 0) return;
    // Subpixel-Toleranz: scrollWidth/clientWidth runden unterschiedlich, ohne
    // Puffer flackert der Endwinkel am letzten Pixel.
    const tolerance = 2;
    // Unterhalb davon lohnt der Hinweis nicht: Ein Überlauf von wenigen Pixeln
    // (gemessen 6px bei 600px Fensterbreite) verbirgt nichts, was man suchen
    // müsste — Abblendung und Winkel wären dann nur Lärm.
    const minOverflow = 14;
    const prefersReducedMotion = typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    // Während des Anstupsers keine Startmarkierung setzen — sonst blitzt der
    // linke Winkel für eine halbe Sekunde auf und sieht nach Fehler aus.
    const nudging = new WeakSet();
    const sync = (selector)=>{
        const rail = selector.querySelector(".highlight-selector__rail");
        if (!rail) return;
        const maxScroll = rail.scrollWidth - rail.clientWidth;
        const isScrollable = maxScroll > minOverflow;
        selector.classList.toggle("is-scrollable", isScrollable);
        selector.classList.toggle("has-scroll-start", isScrollable && !nudging.has(selector) && rail.scrollLeft > tolerance);
        selector.classList.toggle("has-scroll-end", isScrollable && rail.scrollLeft < maxScroll - tolerance);
    };
    // Einmaliger Anstupser, sobald die Leiste ins Bild kommt: Abblendung und
    // Winkel sagen „da ist mehr", die Bewegung sagt „und zwar durch Wischen".
    // Nur wenn wirklich Überlauf da ist, nur am Anfang der Leiste, nur einmal.
    const nudge = (selector)=>{
        const rail = selector.querySelector(".highlight-selector__rail");
        if (prefersReducedMotion || !selector.classList.contains("is-scrollable") || typeof rail.scrollTo !== "function" || rail.scrollLeft > tolerance) return;
        nudging.add(selector);
        // Ohne `is-nudging` (schaltet scroll-snap ab) zieht der Snap-Punkt die
        // Leiste sofort zurück — gemessen kam sie dann nur 13px weit statt 30.
        rail.classList.add("is-nudging");
        rail.scrollTo({
            left: 30,
            behavior: "smooth"
        });
        window.setTimeout(()=>{
            rail.scrollTo({
                left: 0,
                behavior: "smooth"
            });
            window.setTimeout(()=>{
                rail.classList.remove("is-nudging");
                nudging.delete(selector);
                sync(selector);
            }, 500);
        }, 600);
    };
    selectors.forEach((selector)=>{
        const rail = selector.querySelector(".highlight-selector__rail");
        sync(selector);
        rail.addEventListener("scroll", ()=>sync(selector), {
            passive: true
        });
        // Die Reiterbreite hängt an der geladenen Schrift und an der
        // Containerbreite — beides ändert sich nach dem ersten sync.
        if ("ResizeObserver" in window) new ResizeObserver(()=>sync(selector)).observe(rail);
        else window.addEventListener("resize", ()=>sync(selector));
    });
    if (document.fonts && typeof document.fonts.ready?.then === "function") document.fonts.ready.then(()=>selectors.forEach(sync));
    if ("IntersectionObserver" in window) {
        const nudgeObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                nudgeObserver.unobserve(entry.target);
                // Kurz warten: Beim Hereinscrollen soll die Leiste erst stehen,
                // bevor sie sich bewegt — sonst geht der Hinweis unter.
                window.setTimeout(()=>nudge(entry.target), 420);
            });
        }, {
            threshold: 0.9
        });
        selectors.forEach((selector)=>nudgeObserver.observe(selector));
    }
});


document.addEventListener("DOMContentLoaded", ()=>{
    const section = document.querySelector("#buerger-nachrichten");
    const gridShell = section?.querySelector(".highlight-grid-shell");
    const grid = section?.querySelector(".highlight-grid");
    const templates = section ? new Map(Array.from(section.querySelectorAll("template[data-buerger-news-template]")).map((template)=>[
            template.dataset.buergerNewsTemplate || "",
            template.innerHTML
        ])) : new Map();
    const selectorItems = section ? Array.from(section.querySelectorAll(".highlight-selector__item")) : [];
    const prefersReducedMotion = typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!section || !gridShell || !grid) return;
    let revealObserver;
    let motionRefreshFrame;
    const getCards = ()=>Array.from(section.querySelectorAll(".highlight-eq"));
    const rowTopTolerance = 6;
    const motionProfiles = {
        default: {
            rowDelayStep: 126,
            columnDelayStep: 60,
            maxCardDelay: 300
        },
        fast: {
            rowDelayStep: 66,
            columnDelayStep: 26,
            maxCardDelay: 132
        }
    };
    const getMotionProfile = (motionMode = "default")=>motionProfiles[motionMode] || motionProfiles.default;
    const setMotionMode = (motionMode = "default")=>{
        section.dataset.highlightMotion = motionMode;
    };
    const syncCardMotionDelays = (cards = getCards(), motionProfile = getMotionProfile(section.dataset.highlightMotion))=>{
        const { rowDelayStep: rowDelayStep, columnDelayStep: columnDelayStep, maxCardDelay: maxCardDelay } = motionProfile;
        const rowTops = [];
        const rowCounts = [];
        cards.forEach((card, index)=>{
            const currentTop = card.offsetTop;
            let rowIndex = rowTops.findIndex((rowTop)=>Math.abs(rowTop - currentTop) <= rowTopTolerance);
            if (rowIndex === -1) {
                rowTops.push(currentTop);
                rowCounts.push(0);
                rowIndex = rowTops.length - 1;
            }
            const columnIndex = rowCounts[rowIndex];
            const cardDelay = Math.min(rowIndex * rowDelayStep + columnIndex * columnDelayStep, maxCardDelay);
            rowCounts[rowIndex] += 1;
            card.style.setProperty("--highlight-index", index);
            card.style.setProperty("--highlight-delay", `${cardDelay}ms`);
        });
    };
    const refreshCardMotionDelays = ()=>{
        if (prefersReducedMotion) return;
        window.cancelAnimationFrame(motionRefreshFrame);
        motionRefreshFrame = window.requestAnimationFrame(()=>{
            syncCardMotionDelays(getCards(), getMotionProfile(section.dataset.highlightMotion));
        });
    };
    const prepareCardsForReveal = (cards = getCards(), options = {})=>{
        const { motionMode: motionMode = "default" } = options;
        if (revealObserver) {
            revealObserver.disconnect();
            revealObserver = undefined;
        }
        if (cards.length === 0) {
            setMotionMode(motionMode);
            section.classList.remove("is-motion-ready");
            return {
                cards: cards,
                shouldAnimate: false
            };
        }
        cards.forEach((card, index)=>{
            card.classList.remove("is-visible");
            card.style.setProperty("--highlight-index", index);
        });
        if (prefersReducedMotion || !("IntersectionObserver" in window)) {
            setMotionMode(motionMode);
            section.classList.remove("is-motion-ready");
            cards.forEach((card)=>{
                card.classList.add("is-visible");
            });
            return {
                cards: cards,
                shouldAnimate: false
            };
        }
        setMotionMode(motionMode);
        syncCardMotionDelays(cards, getMotionProfile(motionMode));
        section.classList.add("is-motion-ready");
        return {
            cards: cards,
            shouldAnimate: true
        };
    };
    const startReveal = (cards, options = {})=>{
        const { immediate: immediate = false } = options;
        if (cards.length === 0) return;
        if (immediate) {
            window.requestAnimationFrame(()=>{
                cards.forEach((card)=>{
                    card.classList.add("is-visible");
                });
            });
            return;
        }
        revealObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                entry.target.classList.add("is-visible");
                revealObserver?.unobserve(entry.target);
            });
        }, {
            threshold: 0.14,
            rootMargin: "0px 0px -8% 0px"
        });
        window.requestAnimationFrame(()=>{
            cards.forEach((card)=>{
                revealObserver?.observe(card);
            });
        });
    };
    const revealCards = ()=>{
        const { cards: cards, shouldAnimate: shouldAnimate } = prepareCardsForReveal();
        if (!shouldAnimate) return;
        startReveal(cards);
    };
    const setActiveItem = (nextActiveItem)=>{
        selectorItems.forEach((item)=>{
            const isActive = item === nextActiveItem;
            item.classList.toggle("is-active", isActive);
            if (isActive) item.setAttribute("aria-current", "true");
            else item.removeAttribute("aria-current");
        });
    };
    const replaceGridContent = (nextHtml)=>{
        grid.innerHTML = nextHtml;
        const { cards: cards, shouldAnimate: shouldAnimate } = prepareCardsForReveal(getCards(), {
            motionMode: "fast"
        });
        if (!shouldAnimate) return;
        window.requestAnimationFrame(()=>{
            startReveal(cards, {
                immediate: true
            });
        });
    };
    const getCategoryFromUrl = (url)=>{
        const nextUrl = new URL(url, window.location.origin);
        return nextUrl.searchParams.get("buerger_news_category") || "alle";
    };
    const switchCategory = (item, options = {})=>{
        const { skipHistory: skipHistory = false } = options;
        const nextCategory = item.dataset.buergerNewsCategory || "alle";
        const nextHtml = templates.get(nextCategory);
        if (typeof nextHtml !== "string") {
            window.location.href = item.href;
            return;
        }
        setActiveItem(item);
        if (gridShell) gridShell.setAttribute("aria-busy", "true");
        replaceGridContent(nextHtml);
        if (!skipHistory && item.href) window.history.pushState({
            buergerNewsCategory: nextCategory
        }, "", item.href);
        if (gridShell) gridShell.setAttribute("aria-busy", "false");
    };
    revealCards();
    window.addEventListener("resize", refreshCardMotionDelays);
    // ── Nützliche Seiten + Branchenverzeichnis reveal ─────────────────────────
    [
        "#buerger-seiten",
        "#buerger-branchenverzeichnis"
    ].forEach((selectorId)=>{
        const revealSection = document.querySelector(selectorId);
        if (revealSection && !prefersReducedMotion && "IntersectionObserver" in window) {
            const revealCards = Array.from(revealSection.querySelectorAll(".highlight-eq"));
            if (revealCards.length > 0) {
                revealCards.forEach((card, index)=>{
                    card.classList.remove("is-visible");
                    card.style.setProperty("--highlight-index", index);
                    card.style.setProperty("--highlight-delay", `${Math.min(index * 95, 475)}ms`);
                });
                revealSection.classList.add("is-motion-ready");
                const revealObs = new IntersectionObserver((entries)=>{
                    entries.forEach((entry)=>{
                        if (!entry.isIntersecting) return;
                        entry.target.classList.add("is-visible");
                        revealObs.unobserve(entry.target);
                    });
                }, {
                    threshold: 0.14,
                    rootMargin: "0px 0px -8% 0px"
                });
                window.requestAnimationFrame(()=>{
                    revealCards.forEach((card)=>revealObs.observe(card));
                });
            }
        }
    });
    selectorItems.forEach((item)=>{
        item.addEventListener("click", (event)=>{
            event.preventDefault();
            if (item.classList.contains("is-active") && gridShell?.getAttribute("aria-busy") !== "true") return;
            switchCategory(item);
        });
    });
    window.addEventListener("popstate", ()=>{
        const targetCategory = getCategoryFromUrl(window.location.href);
        const targetItem = selectorItems.find((item)=>(item.dataset.buergerNewsCategory || "alle") === targetCategory) || selectorItems[0];
        if (!targetItem) return;
        if (targetItem.classList.contains("is-active") && gridShell?.getAttribute("aria-busy") !== "true") return;
        switchCategory(targetItem, {
            skipHistory: true
        });
    });
});


/**
 * Mobile-only Swiper for card grids (Startseite, /buerger/, /aktuelles/).
 * Activates at ≤ 47em (752 px), matching $break-tablet.
 *
 * Avoids touching the grid element so our theme's display:grid rules never
 * fight Swiper's display:flex. Instead we build a fresh .swiper container,
 * move the card items into individual .swiper-slide wrappers, and hide the
 * original grid. The grid is restored on deactivate / resize up.
 *
 * Two rebuild triggers, because the two filter implementations differ:
 * - watch: "grid"  → highlights-reveal.js / frontpage-news.js replace
 *   grid.innerHTML, so the grid element survives and only its children change.
 * - watch: "shell" → current-news.js replaces the whole results container's
 *   innerHTML, so the grid element itself is thrown away and recreated.
 */ const $9ed05929f970f800$var$MOBILE_MQ = "(max-width: 47em)";
/**
 * Slide shadows are extra DOM nodes per slide whose opacity Swiper repaints on
 * every drag frame. On low-end phones that is the most expensive part of the
 * cards effect, so we drop it where it hurts — and where the visitor asked for
 * less motion anyway.
 */ function $9ed05929f970f800$var$prefersCheapMotion() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return true;
    const cores = navigator.hardwareConcurrency;
    const memory = navigator.deviceMemory;
    return typeof cores === "number" && cores > 0 && cores <= 4 || typeof memory === "number" && memory > 0 && memory <= 4;
}
function $9ed05929f970f800$var$createSwiperInstance(swiperEl) {
    return new window.Swiper(swiperEl, {
        effect: "cards",
        grabCursor: true,
        cardsEffect: {
            slideShadows: !$9ed05929f970f800$var$prefersCheapMotion()
        }
    });
}
function $9ed05929f970f800$var$buildSwiperWrapper(items) {
    const wrapperEl = document.createElement("div");
    wrapperEl.className = "swiper-wrapper";
    items.forEach((item)=>{
        const slide = document.createElement("div");
        slide.className = "swiper-slide";
        slide.appendChild(item); // moves item out of grid
        wrapperEl.appendChild(slide);
    });
    return wrapperEl;
}
/**
 * @param {object} config
 * @param {string} config.sectionId       Section the grid lives in.
 * @param {string} config.shellSelector   Element the swiper is inserted into.
 * @param {string} config.gridSelector    The CSS grid holding the cards.
 * @param {string} config.itemSelector    Direct-child selector for one card.
 * @param {string} config.swiperClass     Extra class on the .swiper element.
 * @param {"grid"|"shell"} [config.watch] Which element the filter replaces.
 */ function $9ed05929f970f800$var$initCardSwiper(config) {
    const { sectionId: sectionId, shellSelector: shellSelector, gridSelector: gridSelector, itemSelector: itemSelector, swiperClass: swiperClass, watch: watch = "grid" } = config;
    const section = document.getElementById(sectionId);
    if (!section) return;
    const shell = section.querySelector(shellSelector);
    if (!shell) return;
    let swiperInstance = null;
    let swiperEl = null;
    let grid = null;
    let isMobile = false; // viewport is in swipe range
    let hasSwiper = false; // swiper is currently built
    let isSyncing = false; // our own DOM writes — ignore them in the observer
    const mq = window.matchMedia($9ed05929f970f800$var$MOBILE_MQ);
    const getGridItems = ()=>grid ? Array.from(grid.querySelectorAll(`:scope > ${itemSelector}`)) : [];
    const destroySwiper = ()=>{
        if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    };
    const observeSource = ()=>{
        const target = watch === "shell" ? shell : grid;
        if (target) observer.observe(target, {
            childList: true
        });
    };
    /** Rebuild in place — the grid element survived, only its cards changed. */ const rebuildInPlace = ()=>{
        const freshItems = getGridItems();
        if (freshItems.length === 0 || !swiperEl) {
            observeSource();
            return;
        }
        isSyncing = true;
        const oldWrapper = swiperEl.querySelector(".swiper-wrapper");
        const newWrapper = $9ed05929f970f800$var$buildSwiperWrapper(freshItems);
        if (oldWrapper) oldWrapper.replaceWith(newWrapper);
        else swiperEl.prepend(newWrapper);
        isSyncing = false;
        swiperInstance = $9ed05929f970f800$var$createSwiperInstance(swiperEl);
        observeSource();
    };
    const observer = new MutationObserver(()=>{
        if (isSyncing || !isMobile) return;
        observer.disconnect();
        destroySwiper();
        if (watch === "shell") {
            // The whole results container was rewritten: our swiper element and the
            // hidden grid went with it. Start over from the fresh markup.
            swiperEl = null;
            grid = null;
            hasSwiper = false;
            shell.classList.remove("has-card-swiper");
            build();
            return;
        }
        rebuildInPlace();
    });
    function build() {
        if (hasSwiper) return;
        grid = shell.matches(gridSelector) ? shell : shell.querySelector(gridSelector);
        // No grid (empty filter result) or a single card: nothing to swipe. Keep
        // listening so the swiper returns with the next result set.
        if (!grid || getGridItems().length < 2) {
            observeSource();
            return;
        }
        isSyncing = true;
        swiperEl = document.createElement("div");
        swiperEl.className = `swiper ${swiperClass}`;
        swiperEl.appendChild($9ed05929f970f800$var$buildSwiperWrapper(getGridItems()));
        // Hide original grid (now empty), insert swiper in its place.
        grid.style.display = "none";
        grid.parentNode.insertBefore(swiperEl, grid);
        isSyncing = false;
        hasSwiper = true;
        shell.classList.add("has-card-swiper");
        swiperInstance = $9ed05929f970f800$var$createSwiperInstance(swiperEl);
        observeSource();
    }
    function teardown() {
        observer.disconnect();
        destroySwiper();
        if (!hasSwiper) return;
        // Move only our cards back into the grid. Swiper's cards effect appends a
        // .swiper-slide-shadow element to every slide. Moving all child nodes here
        // used to put those shadows into the CSS grid as empty grid items, so after
        // resizing from mobile to desktop every second grid cell was occupied by a
        // shadow and the cards appeared in a zig-zag pattern.
        if (swiperEl && grid) {
            isSyncing = true;
            Array.from(swiperEl.querySelectorAll(".swiper-slide")).forEach((slide)=>{
                const item = slide.querySelector(`:scope > ${itemSelector}`);
                if (item) grid.appendChild(item);
            });
            swiperEl.remove();
            isSyncing = false;
        }
        swiperEl = null;
        hasSwiper = false;
        if (grid) grid.style.display = "";
        shell.classList.remove("has-card-swiper");
    }
    mq.addEventListener("change", (event)=>{
        isMobile = event.matches;
        if (isMobile) build();
        else teardown();
    });
    if (mq.matches) {
        isMobile = true;
        build();
    }
}
function $9ed05929f970f800$var$initHighlightSwiper(sectionId) {
    $9ed05929f970f800$var$initCardSwiper({
        sectionId: sectionId,
        shellSelector: ".highlight-grid-shell",
        gridSelector: ".highlight-grid",
        itemSelector: ".highlight-eq",
        swiperClass: "highlight-swiper",
        watch: "grid"
    });
}
document.addEventListener("DOMContentLoaded", ()=>{
    if (typeof window.Swiper === "undefined") return;
    $9ed05929f970f800$var$initHighlightSwiper("highlights");
    $9ed05929f970f800$var$initHighlightSwiper("frontpage-neuigkeiten");
    // /aktuelles/ — same stacked-card swipe. current-news.js swaps the entire
    // results container, so the grid element is not a stable reference here.
    $9ed05929f970f800$var$initCardSwiper({
        sectionId: "ws-current-news",
        shellSelector: "[data-current-news-results]",
        gridSelector: "[data-current-news-grid]",
        itemSelector: ".ws-content-card",
        swiperClass: "ws-card-swiper",
        watch: "shell"
    });
});


/**
 * Top-Themen-Slider auf /buerger/.
 *
 * Ersetzt den alten Slick-Slider der Vor-Relaunch-Seite. Die Karten nutzen die
 * .highlight-card-Optik der übrigen Relaunch-Sektionen; Swiper übernimmt nur
 * das Scrollen samt Pfeil-Navigation.
 *
 * Swiper wird nur auf Startseite und /buerger/ enqueued (functions.php) —
 * ohne window.Swiper macht das Modul nichts und die CSS-Fallback-Regel
 * (.js-topthemen-slider:not(.swiper-initialized)) liefert ein scrollbares Rail.
 */ function $4bcfafee5fbd34fa$var$initTopthemenSlider() {
    const container = document.querySelector(".js-topthemen-slider");
    if (!container) return;
    const root = container.closest(".buerger-section--topthemen");
    const prevEl = root ? root.querySelector(".js-topthemen-prev") : null;
    const nextEl = root ? root.querySelector(".js-topthemen-next") : null;
    const currentEl = root ? root.querySelector(".js-topthemen-current") : null;
    const progressEl = root ? root.querySelector(".js-topthemen-progress") : null;
    const updatePosition = (swiper)=>{
        const current = swiper.activeIndex + 1;
        const total = swiper.slides.length;
        const slidesPerView = typeof swiper.params.slidesPerView === "number" ? Math.max(1, Math.floor(swiper.params.slidesPerView)) : 1;
        const visibleThrough = Math.min(current + slidesPerView - 1, total);
        const visibleRange = visibleThrough > current ? `${current}\u{2013}${visibleThrough}` : `${current}`;
        if (currentEl) currentEl.textContent = visibleRange;
        if (progressEl) progressEl.style.width = `${visibleThrough / total * 100}%`;
    };
    new window.Swiper(container, {
        slidesPerView: 1.08,
        spaceBetween: 18,
        watchOverflow: true,
        grabCursor: true,
        a11y: {
            containerMessage: "Top Themen",
            nextSlideMessage: "N\xe4chstes Top-Thema",
            prevSlideMessage: "Vorheriges Top-Thema",
            slideLabelMessage: "{{index}} von {{slidesLength}}"
        },
        navigation: prevEl && nextEl ? {
            prevEl: prevEl,
            nextEl: nextEl,
            disabledClass: "is-disabled",
            lockClass: "is-locked"
        } : false,
        on: {
            init: updatePosition,
            slideChange: updatePosition,
            breakpoint: updatePosition
        },
        breakpoints: {
            760: {
                slidesPerView: 2,
                spaceBetween: 24
            },
            1120: {
                slidesPerView: 3,
                spaceBetween: 30
            }
        }
    });
}
document.addEventListener("DOMContentLoaded", ()=>{
    if (typeof window.Swiper === "undefined") return;
    $4bcfafee5fbd34fa$var$initTopthemenSlider();
});


// import "./js/campaign";
// import "./backstretch";
// Live open/closed pills (cards, singles, footer) — see opening-hours-status.js.
(0, $bErSZ.bindOpeningStatusAutoRefresh)();

})();
//# sourceMappingURL=bundle.js.map
